'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var core = require('@material-ui/core');
var React$1 = require('react');
var styles$6 = require('@material-ui/core/styles');
var Button$1 = require('@material-ui/core/Button');
var Card$1 = require('@material-ui/core/Card');
var CardHeader = require('@material-ui/core/CardHeader');
var Checkbox$1 = require('@material-ui/core/Checkbox');
var Divider = require('@material-ui/core/Divider');
var Grid = require('@material-ui/core/Grid');
var List = require('@material-ui/core/List');
var ListItem = require('@material-ui/core/ListItem');
var ListItemIcon = require('@material-ui/core/ListItemIcon');
var ListItemText = require('@material-ui/core/ListItemText');
var DatePicker$2 = require('react-datepicker');
require('react-datepicker/dist/react-datepicker.css');
var Popper = require('@material-ui/core/Popper');
var ListSubheader = require('@material-ui/core/ListSubheader');
var Paper = require('@material-ui/core/Paper');
var IconButton = require('@material-ui/core/IconButton');
var Chip = require('@material-ui/core/Chip');
var require$$0 = require('@material-ui/core/utils');
var DateFnsUtils = require('@date-io/date-fns');
var Typography = require('@material-ui/core/Typography');
var Toolbar = require('@material-ui/core/Toolbar');
var DialogActions = require('@material-ui/core/DialogActions');
var DialogContent = require('@material-ui/core/DialogContent');
var Dialog = require('@material-ui/core/Dialog');
var Popover = require('@material-ui/core/Popover');
var TextField = require('@material-ui/core/TextField');
var InputAdornment = require('@material-ui/core/InputAdornment');
var SvgIcon = require('@material-ui/core/SvgIcon');
var CircularProgress = require('@material-ui/core/CircularProgress');
var ReactDOM = require('react-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React$1);
var React__namespace = /*#__PURE__*/_interopNamespace(React$1);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button$1);
var Card__default = /*#__PURE__*/_interopDefaultLegacy(Card$1);
var CardHeader__default = /*#__PURE__*/_interopDefaultLegacy(CardHeader);
var Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(Checkbox$1);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);
var Grid__default = /*#__PURE__*/_interopDefaultLegacy(Grid);
var List__default = /*#__PURE__*/_interopDefaultLegacy(List);
var ListItem__default = /*#__PURE__*/_interopDefaultLegacy(ListItem);
var ListItemIcon__default = /*#__PURE__*/_interopDefaultLegacy(ListItemIcon);
var ListItemText__default = /*#__PURE__*/_interopDefaultLegacy(ListItemText);
var DatePicker__default = /*#__PURE__*/_interopDefaultLegacy(DatePicker$2);
var Popper__default = /*#__PURE__*/_interopDefaultLegacy(Popper);
var ListSubheader__default = /*#__PURE__*/_interopDefaultLegacy(ListSubheader);
var Paper__default = /*#__PURE__*/_interopDefaultLegacy(Paper);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);
var Chip__default = /*#__PURE__*/_interopDefaultLegacy(Chip);
var require$$0__default = /*#__PURE__*/_interopDefaultLegacy(require$$0);
var DateFnsUtils__default = /*#__PURE__*/_interopDefaultLegacy(DateFnsUtils);
var Typography__default = /*#__PURE__*/_interopDefaultLegacy(Typography);
var Toolbar__default = /*#__PURE__*/_interopDefaultLegacy(Toolbar);
var DialogActions__default = /*#__PURE__*/_interopDefaultLegacy(DialogActions);
var DialogContent__default = /*#__PURE__*/_interopDefaultLegacy(DialogContent);
var Dialog__default = /*#__PURE__*/_interopDefaultLegacy(Dialog);
var Popover__default = /*#__PURE__*/_interopDefaultLegacy(Popover);
var TextField__default = /*#__PURE__*/_interopDefaultLegacy(TextField);
var InputAdornment__default = /*#__PURE__*/_interopDefaultLegacy(InputAdornment);
var SvgIcon__default = /*#__PURE__*/_interopDefaultLegacy(SvgIcon);
var CircularProgress__default = /*#__PURE__*/_interopDefaultLegacy(CircularProgress);
var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

var useStyles$y = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    item: {
      display: "block",
      width: 80,
      height: 80,
      borderRadius: " 50%",
      marginLeft: "calc(50% - 40px)",
      marginTop: 12,
      position: "relative",
      boxSizing: "border-box",
      background: "transparent"
    },
    dot: {
      width: 20,
      height: 20,
      display: "block",
      position: "absolute",
      top: "20%",
      borderRadius: "50%",
      backgroundColor: theme.palette.secondary.main,
      transform: "translateY(-20%)",
      animation: "item7-dot 1.2s ease-in-out infinite"
    },
    dotDefault: {
      width: 20,
      height: 20,
      display: "block",
      position: "absolute",
      top: "20%",
      borderRadius: "50%",
      backgroundColor: '#4c4b4f',
      // backgroundColor: theme.palette.primary.dark,
      transform: "translateY(-20%)",
      animation: "item7-dot 1.2s ease-in-out infinite"
    },
    dot1: {
      left: "20%",
      transfrom: "translateX(-30%)"
    },
    dot2: {
      left: "50%",
      transfrom: "translateX(-30%)",
      animationDelay: "0.2s"
    },
    dot3: {
      transfrom: "translateX(-30%)",
      left: " 80%",
      animationDelay: "0.4s"
    },
    itemSmall: {
      marginTop: 24,
      width: 40,
      height: 20,
      marginLeft: "0",
      "& $dot": {
        width: 10,
        top: "30%",
        height: 10,
        animation: "item7-dot-small 0.9s ease-in-out infinite"
      },
      "& $dotDefault": {
        width: 10,
        top: "30%",
        height: 10,
        animation: "item7-dot-small 0.9s ease-in-out infinite"
      },
      "& $dot1": {
        transfrom: "translateX(-30%)"
      },
      "& $dot2": {
        transfrom: "translateX(-30%)",
        animationDelay: "0.2s"
      },
      "& $dot3": {
        transfrom: "translateX(-30%)",
        animationDelay: "0.4s"
      }
    }
  });
});

function LoadingIcon(props) {
  var size = props.size,
      defaultColor = props.defaultColor;
  var classes = useStyles$y();
  var className = classes.item;

  if (size === "small") {
    className += " " + classes.itemSmall;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: className
  }, defaultColor ? /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.dotDefault + " " + classes.dot1
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.dotDefault + " " + classes.dot2
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.dotDefault + " " + classes.dot3
  })) : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.dot + " " + classes.dot1
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.dot + " " + classes.dot2
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.dot + " " + classes.dot3
  })));
}

var useStyles$x = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    text: {
      color: theme.palette.secondary.main,
      textTransform: "initial",
      fontWeight: "normal",
      padding: 0,
      fontSize: 14,
      letterSpacing: "-0.24px",
      textDecoration: "underline",
      "&:hover": {
        background: "transparent"
      } // "& .MuiTouchRipple-root": {
      //   display: "none",
      // },

    },
    outlined: {
      border: "none",
      padding: "6px 12px",
      fontSize: 14,
      textTransform: "initial",
      "&:hover, &:focus": {
        background: "none",
        fontWeight: "bold",
        fontSize: 16,
        letterSpacing: -0.3
      }
    },
    contained: {
      fontFamily: "Mulish",
      padding: "2px 16px",
      borderRadius: "18px",
      textTransform: "initial",
      fontSize: 14,
      boxShadow: "none",
      background: "transparent",
      border: "1px solid " + theme.palette.secondary.main,
      color: theme.palette.secondary.main,
      transition: "0.3s ease-in-out",
      "&:hover": {
        color: "white",
        background: theme.palette.secondary.main,
        boxShadow: "none"
      }
    },
    containedPrimary: {
      background: theme.palette.secondary.main,
      padding: "2px 16px",
      border: "1px solid " + theme.palette.secondary.main,
      color: "white",
      transition: "0.3s ease-in-out",
      "&:hover": {
        background: "transparent",
        color: theme.palette.secondary.main,
        boxShadow: "none"
      }
    },
    containedSecondary: {
      background: theme.palette.secondary.dark,
      border: "1px solid " + theme.palette.secondary.dark,
      padding: "2px 16px",
      color: "white",
      transition: "0.3s ease-in-out",
      "&:hover": {
        background: "transparent",
        color: theme.palette.secondary.dark,
        border: "1px solid " + theme.palette.secondary.dark,
        boxShadow: "none"
      }
    },
    textPrimary: {
      color: theme.palette.secondary.dark,
      fontSize: 13,
      fontFamily: "Mulish"
    },
    textSecondary: {
      "& svg": {
        "& > g": {
          fill: theme.palette.secondary.dark
        },
        paddingBottom: 14,
        fontSize: 24
      },
      "&:hover": {
        "& svg": {
          "& > g": {
            fill: theme.palette.secondary.main
          }
        },
        background: "none"
      }
    },
    disabled: {
      border: "none"
    },
    startIconRed: {
      marginRight: 2,
      color: theme.palette.secondary.main
    }
  });
});

function Button(props) {
  var color = props.color,
      title = props.title,
      onClick = props.onClick,
      disabled = props.disabled,
      className = props.className,
      type = props.type,
      fetching = props.fetching,
      variant = props.variant,
      icon = props.icon,
      ariaLabel = props.ariaLabel,
      dataTestId = props.dataTestId,
      iconRed = props.iconRed;
  var classes = useStyles$x();
  var propsButton = {
    "aria-label": ariaLabel || title,
    "data-testid": dataTestId,
    title: ariaLabel,
    disabled: disabled,
    color: color || "default",
    onClick: onClick,
    className: className,
    variant: variant || "contained",
    type: type ? type : "button",
    classes: {
      text: classes.text,
      textSecondary: classes.textSecondary,
      outlined: classes.outlined,
      // containedDefault: classes.containedDefault,
      contained: classes.contained,
      containedPrimary: classes.containedPrimary,
      containedSecondary: classes.containedSecondary,
      startIcon: iconRed ? classes.startIconRed : "",
      disabled: classes.disabled,
      textPrimary: classes.textPrimary
    }
  };
  return fetching ? /*#__PURE__*/React__default['default'].createElement(LoadingIcon, {
    size: "small"
  }) : /*#__PURE__*/React__default['default'].createElement(core.Button, __assign({}, propsButton, {
    startIcon: icon && icon
  }), title);
}

function Compte(props) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: props.width ? props.width + 'px' : '23px',
    height: "26px",
    viewBox: "0 0 23 26",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "Clients"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "BOARD-3---Ic\xF4nes",
    transform: "translate(-968.000000, -335.000000)",
    fill: "#1B202D"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Pictogrammes",
    transform: "translate(305.000000, 178.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "22---Compte",
    transform: "translate(663.000000, 155.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M18.2472325,17.9604523 C20.8680443,17.9604523 23,20.2300117 23,23.0199796 L23,27.2772104 C23,27.6761903 22.6958229,28 22.3210332,28 C21.9462435,28 21.6420664,27.6761903 21.6420664,27.2772104 L21.6420664,23.0199796 C21.6420664,21.0272486 20.1191439,19.4060315 18.2472325,19.4060315 L4.75276753,19.4060315 C2.88085609,19.4060315 1.35793358,21.0272486 1.35793358,23.0199796 L1.35793358,27.2772104 C1.35793358,27.6761903 1.05375646,28 0.67896679,28 C0.304177122,28 0,27.6761903 0,27.2772104 L0,23.0199796 C0,20.2300117 2.13195572,17.9604523 4.75276753,17.9604523 L18.2472325,17.9604523 Z M11.4605432,2 C14.9814351,2 17.8463541,4.87589627 17.8463541,8.41071247 C17.8463541,11.9458814 14.9814351,14.8217777 11.4605432,14.8217777 C7.93965135,14.8217777 5.07508378,11.9458814 5.07508378,8.41071247 C5.07508378,4.87589627 7.93965135,2 11.4605432,2 Z M11.4605432,3.41096346 C8.71473243,3.41096346 6.48048919,5.65368987 6.48048919,8.41071247 C6.48048919,11.1677351 8.71473243,13.4108142 11.4605432,13.4108142 C14.2067054,13.4108142 16.4409486,11.1677351 16.4409486,8.41071247 C16.4409486,5.65368987 14.2067054,3.41096346 11.4605432,3.41096346 Z",
    id: "Combined-Shape"
  })))));
}

function Fidelite(props) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.width ? props.width + "px" : "33px",
    height: props.height ? props.height + "px" : "31.348px",
    viewBox: "0 0 33 31.348",
    fill: props.fill ? props.fill : "white"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "contact",
    transform: "translate(-0.001 -12.813)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Groupe_81",
    "data-name": "Groupe 81",
    transform: "translate(0.001 12.813)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Groupe_80",
    "data-name": "Groupe 80"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Trac\xE9_24",
    "data-name": "Trac\xE9 24",
    d: "M31.6,12.813H8.548a1.4,1.4,0,0,0-1.4,1.4v6.358L6.091,18.993a1.63,1.63,0,0,0-2.2-.5L1.722,19.8A3.182,3.182,0,0,0,.268,21.687c-.791,2.881-.2,7.843,7.08,15.129,5.793,5.787,10.112,7.345,13.089,7.345a7.686,7.686,0,0,0,2.041-.266,3.187,3.187,0,0,0,1.886-1.452l1.3-2.171a1.63,1.63,0,0,0-.5-2.2l-5.193-3.461a1.639,1.639,0,0,0-2.194.356l-1.512,1.944a.526.526,0,0,1-.673.142l-.288-.158a17.294,17.294,0,0,1-4.505-3.538c-.257-.257-.491-.5-.71-.729H31.6a1.4,1.4,0,0,0,1.4-1.4V14.216A1.4,1.4,0,0,0,31.6,12.813ZM14.785,37.863l.279.154a1.621,1.621,0,0,0,2.077-.428l1.512-1.944a.535.535,0,0,1,.715-.116l5.193,3.461a.531.531,0,0,1,.161.715l-1.3,2.171a2.09,2.09,0,0,1-1.233.957c-2.6.715-7.152.11-14.059-6.8s-7.51-11.459-6.8-14.057a2.091,2.091,0,0,1,.957-1.233l2.171-1.3a.532.532,0,0,1,.715.161L8.637,24.8a.534.534,0,0,1-.116.715L6.576,27.024A1.62,1.62,0,0,0,6.148,29.1l.154.279a18.238,18.238,0,0,0,3.727,4.756A18.274,18.274,0,0,0,14.785,37.863ZM31.9,31.233a.3.3,0,0,1-.3.3H9.1a13.874,13.874,0,0,1-1.836-2.676l-.158-.289a.525.525,0,0,1,.142-.672L9.2,26.381a1.638,1.638,0,0,0,.356-2.194L8.245,22.225V14.216a.3.3,0,0,1,.3-.3H31.6a.3.3,0,0,1,.3.3V31.233Z",
    transform: "translate(-0.001 -12.813)",
    fill: "fill"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Trac\xE9_25",
    "data-name": "Trac\xE9 25",
    d: "M168.455,50.7l-9.195,6.973a.742.742,0,0,1-.873,0L149.2,50.7a.55.55,0,1,0-.665.877l9.192,6.972a1.852,1.852,0,0,0,2.2,0l9.2-6.972a.55.55,0,0,0-.665-.877Z",
    transform: "translate(-138.752 -48.152)",
    fill: "fill"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Trac\xE9_26",
    "data-name": "Trac\xE9 26",
    d: "M154.593,172.565l-5.636,6.035a.55.55,0,0,0,.8.75l5.636-6.038a.55.55,0,0,0-.8-.748Z",
    transform: "translate(-139.216 -162.122)",
    fill: "fill"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    id: "Trac\xE9_27",
    "data-name": "Trac\xE9 27",
    d: "M370.9,172.253a.55.55,0,1,0-.8.75l5.634,6.035a.55.55,0,0,0,.8-.75Z",
    transform: "translate(-346.101 -161.811)",
    fill: "fill"
  })))));
}

var img = "data:image/png;base64,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";

var useStyles$w = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    buttonHeader: {
      minWidth: 50,
      height: 50,
      padding: 12,
      marginLeft: 8,
      borderRadius: 12,
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      "& > span": {
        lineHeight: 1
      },
      "&:before": {
        position: "absolute",
        content: '""',
        borderRadius: 12,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundImage: 'linear-gradient(62deg, ' + theme.palette.secondary.light + ' 1%, ' + theme.palette.secondary.main + ' 98%)',
        zIndex: -1,
        transition: "opacity 0.5s ease",
        opacity: 0
      },
      "&:after": {
        content: ' " "  attr(title)',
        letterSpacing: "-7px",
        textTransform: "initial",
        fontWeight: "200",
        fontSize: 14,
        color: "white",
        opacity: 0,
        transition: "letter-spacing 0.3s ease, opacity 0.3s ease",
        marginLeft: -3
      },
      "&:hover": {
        boxShadow: "0 2px 13px 1px rgba(211,211,211, 0.2)",
        "& svg": {
          pointerEvents: "none",
          "& > g": {
            fill: "white",
            "& path": {
              fill: "white"
            }
          }
        },
        "&:after": {
          paddingLeft: 12,
          letterSpacing: "normal",
          opacity: 1
        },
        "&:before": {
          opacity: 1
        }
      },
      "& .MuiTouchRipple-root": {
        display: "none"
      },
      "& svg": {
        "&  > g": {
          fill: theme.palette.secondary.main
        }
      }
    },
    noTitle: {
      "&:hover": {
        "&:after": {
          opacity: 0,
          padding: 0
        }
      }
    },
    active: {
      background: 'linear-gradient(62deg, ' + theme.palette.secondary.light + ' 1%, ' + theme.palette.secondary.main + ' 98%)',
      boxShadow: "0 2px 13px 1px rgba(211,211,211, 0.2)",
      "& svg": {
        "&  > g": {
          fill: "white",
          "& path": {
            fill: "white"
          }
        }
      }
    }
  });
});

function LinkButton$1(props) {
  var title = props.title,
      onClick = props.onClick,
      disabled = props.disabled,
      icon = props.icon,
      ariaLabel = props.ariaLabel,
      active = props.active,
      noTitle = props.noTitle,
      dataTestId = props.dataTestId;
  var classes = useStyles$w();
  var classNameLink = classes.buttonHeader;

  if (active) {
    classNameLink += " " + classes.active;
  }

  if (noTitle) classNameLink += " " + classes.noTitle;
  var propsButton = {
    "aria-label": ariaLabel || title,
    disabled: disabled,
    onClick: onClick,
    className: classNameLink,
    underline: "none"
  };
  return /*#__PURE__*/React__default['default'].createElement(core.Button, __assign({}, propsButton, {
    title: title,
    "data-testid": dataTestId
  }), icon);
}

var useStyles$v = core.makeStyles(function (theme) {
  return core.createStyles({
    header: {
      height: 50,
      background: "#FFF",
      borderRadius: "0 0 26px 26px",
      boxShadow: "0 1px 5px 3px rgba(224,224,224,0.5)",
      padding: "12px 48px",
      position: "fixed",
      width: "calc(100% - 96px)",
      zIndex: 10,
      top: 0,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    logo: {
      width: "25%",
      textAlign: "left"
    },
    search: {
      width: "50%"
    },
    inputRoot: {
      width: "100%",
      background: theme.palette.primary.light,
      borderRadius: 12,
      padding: "7px 18px"
    },
    buttonsHeader: {
      width: "25%",
      display: "flex",
      justifyContent: "flex-end"
    }
  });
});

function HeaderConnected(props) {
  var menuHeader = props.menuHeader,
      lienAccueil = props.lienAccueil,
      menuPopoverHeader = props.menuPopoverHeader,
      withSearch = props.withSearch,
      mobileHeader = props.mobileHeader,
      contactLink = props.contactLink,
      activeContactLink = props.activeContactLink,
      logoFile = props.logoFile;
  var classes = useStyles$v();

  var _a = React__default['default'].useState(null),
      anchorEl = _a[0],
      setAnchorEl = _a[1];

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var open = Boolean(anchorEl);

  var handleClickLinks = function handleClickLinks(id) {
    var selectedMenu = menuPopoverHeader.find(function (menu) {
      return menu.id === id;
    });
    selectedMenu && selectedMenu.link();

    if (id === "deconnexion") {
      sessionStorage.clear();
    }
  };

  var findCompteButton = menuPopoverHeader.find(function (menu) {
    return menu.id === "compte";
  });
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React__default['default'].createElement(core.Link, {
    component: "button",
    onClick: function onClick() {
      return lienAccueil();
    },
    className: classes.logo,
    "data-testid": "btn-logo"
  }, logoFile ? /*#__PURE__*/React__default['default'].createElement("img", {
    src: "data:image/jpeg;base64," + logoFile.content,
    alt: logoFile.nom,
    height: 50
  }) : /*#__PURE__*/React__default['default'].createElement("img", {
    src: img,
    alt: "Saga",
    width: 90
  })), withSearch && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.search
  }, /*#__PURE__*/React__default['default'].createElement("div", null), /*#__PURE__*/React__default['default'].createElement(core.InputBase, {
    placeholder: "Rechercher",
    disabled: true,
    classes: {
      root: classes.inputRoot
    },
    inputProps: {
      "aria-label": "rechercher"
    }
  })), mobileHeader && findCompteButton ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.buttonsHeader
  }, /*#__PURE__*/React__default['default'].createElement(LinkButton$1, {
    key: findCompteButton.id,
    active: window.location.pathname === "/compte",
    icon: /*#__PURE__*/React__default['default'].createElement(Compte, null),
    title: findCompteButton.value,
    onClick: findCompteButton.link
  })) : /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.buttonsHeader
  }, contactLink && /*#__PURE__*/React__default['default'].createElement(LinkButton$1, {
    key: "contact",
    active: activeContactLink,
    ariaLabel: "Contact",
    icon: /*#__PURE__*/React__default['default'].createElement(Fidelite, null),
    noTitle: true,
    onClick: contactLink
  }), menuHeader.map(function (menu, i) {
    return /*#__PURE__*/React__default['default'].createElement(LinkButton$1, {
      key: menu.id,
      active: window.location.pathname === "/" + menu.id,
      icon: menu.icon,
      title: menu.value,
      onClick: menu.link
    });
  }), menuPopoverHeader && /*#__PURE__*/React__default['default'].createElement(LinkButton$1, {
    dataTestId: "compteUtilisateur",
    onClick: handleClick,
    active: open,
    icon: /*#__PURE__*/React__default['default'].createElement(Compte, null),
    noTitle: true
  }), menuPopoverHeader && /*#__PURE__*/React__default['default'].createElement(PopoverComponent, {
    onSelect: handleClickLinks,
    onClose: handleClose,
    list: menuPopoverHeader,
    id: "compteUtilisateur",
    buttonName: "compteUtilisateur",
    anchorEl: anchorEl,
    withArrow: true
  })));
}

var Close$1 = require$$0.createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

var CloseOutlined = require$$0.createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
}), 'CloseOutlined');

var ExpandMore = require$$0.createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

var Search = require$$0.createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');

var Visibility = require$$0.createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
}), 'Visibility');

var VisibilityOff = require$$0.createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), 'VisibilityOff');

var getNameStatut = function getNameStatut(statut) {
  if (statut === "VALIDER" || statut === "VALIDER_ELECTRO") {
    return "Validé";
  } else if (statut === "ATTENTE_SIGNATURE") {
    return "En att. de signature";
  } else if (statut === "INCOMPLET") {
    return "Incomplet";
  } else if (statut === "ATTENTE_RECEPTION") {
    return "En att. réception";
  } else if (statut === "FERMEE") {
    return "Fermé";
  } else if (statut === "ANNULEE") {
    return "Annulé";
  }
};
var getColorStatut = function getColorStatut(statut) {
  if (statut === "Validé" || statut === "En att. réception") {
    return "green";
  } else if (statut === "En att. de signature" || statut === "Incomplet") {
    return "red";
  } else if (statut === "Fermé" || statut === "Annulé") {
    return "black";
  }
};
var messageErrorImmat = "Ce format n'est pas valide.<br />Formats acceptés :<br />Anciennes plaques : de 1AA11 à 9999ZZZ99 <br />Nouvelles plaques : de AA-111-AA à ZZ-999-ZZ";
var getNameCategorie = function getNameCategorie(c) {
  if (c === "VN") {
    return "VN (Véhicule neuf)";
  } else if (c === "VO") {
    return "VO (Véhicule d'occasion)";
  } else if (c === "VU") {
    return "VU (Véhicule utilitaire)";
  } else if (c === "ATE.") {
    return "ATE. (Atelier)";
  } else if (c === "LOC.") {
    return "LOC. (Location)";
  } else if (c === "SOC.") {
    return "SOC. (Société)";
  } else if (c === "Sans Véhic") {
    return "Sans véhicule";
  } else if (c === "EXT") {
    return "EXT (EXTERIEUR)";
  } else return c;
};

var useStyles$u = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    statut: {
      color: theme.palette.error.main,
      fontSize: 13,
      border: "1px solid " + theme.palette.error.main,
      borderRadius: 12,
      padding: "0 12px"
    },
    green: {
      color: theme.palette.success.main,
      borderColor: theme.palette.success.main
    },
    black: {
      color: theme.palette.secondary.dark,
      borderColor: theme.palette.secondary.dark
    }
  });
});

function StatutTag(props) {
  var statut = props.statut;
  var classes = useStyles$u();
  var colorStatut = getColorStatut(statut);
  var classStatut = classes.statut;

  if (colorStatut === "green") {
    classStatut += " " + classes.green;
  }

  if (colorStatut === "black") {
    classStatut += " " + classes.black;
  }

  return /*#__PURE__*/React__default['default'].createElement("p", {
    className: classStatut
  }, statut);
}

var useStyles$t = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    accordeon: {
      padding: 24,
      marginBottom: 16,
      background: "white",
      boxShadow: "2px 3px 13px -2px #C2C2C2",
      borderRadius: 12,
      position: "relative",
      "&:last-child, &:first-child": {
        borderRadius: 12
      },
      "&:before": {
        content: "none"
      }
    },
    accordeonSummary: {
      padding: 0,
      minHeight: 0 + " !important"
    },
    accordeonSummaryContent: {
      margin: 0 + " !important",
      alignItems: "center",
      justifyContent: "space-between",
      "& h4": {
        fontSize: 17
      },
      "& > div": {
        display: "flex",
        alignItems: "center"
      }
    },
    expandIcon: {
      padding: 0,
      fontSize: 19
    },
    titleProduit: {
      maxWidth: "500px",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
      marginRight: 32,
      marginLeft: 8
    },
    accordeonAction: {
      "& > button": {
        margin: "0 12px"
      }
    },
    accordeonDetail: {
      marginTop: 12
    }
  });
});

function Accordeon(props) {
  var expanded = props.expanded,
      children = props.children,
      setExpanded = props.setExpanded,
      id = props.id,
      title = props.title,
      statut = props.statut,
      icon = props.icon,
      buttons = props.buttons;
  var classes = useStyles$t();

  var handleChange = function handleChange(id) {
    return function (event, isExpanded) {
      setExpanded(id, isExpanded);
    };
  };

  return /*#__PURE__*/React__default['default'].createElement(core.Accordion, {
    expanded: expanded,
    onChange: handleChange(id),
    classes: {
      rounded: classes.accordeon
    }
  }, /*#__PURE__*/React__default['default'].createElement(core.AccordionSummary, {
    "data-testid": "accordeon-test",
    expandIcon: /*#__PURE__*/React__default['default'].createElement(ExpandMore, null),
    "aria-controls": id + "-content",
    id: id + "-header",
    classes: {
      root: classes.accordeonSummary,
      content: classes.accordeonSummaryContent,
      expandIcon: classes.expandIcon
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", null, icon, /*#__PURE__*/React__default['default'].createElement(core.Tooltip, {
    title: title || "-"
  }, /*#__PURE__*/React__default['default'].createElement(core.Typography, {
    variant: "h4",
    className: classes.titleProduit
  }, title || "-")), /*#__PURE__*/React__default['default'].createElement(StatutTag, {
    statut: statut
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.accordeonAction
  }, buttons.map(function (btn) {
    return /*#__PURE__*/React__default['default'].createElement(Button, {
      variant: "text",
      color: "primary",
      key: btn.id,
      title: btn.title,
      icon: btn.icon,
      onClick: btn.onClick
    });
  }))), /*#__PURE__*/React__default['default'].createElement(core.AccordionDetails, {
    classes: {
      root: classes.accordeonDetail
    }
  }, children));
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

reactIs_development.AsyncMode = AsyncMode;
reactIs_development.ConcurrentMode = ConcurrentMode;
reactIs_development.ContextConsumer = ContextConsumer;
reactIs_development.ContextProvider = ContextProvider;
reactIs_development.Element = Element;
reactIs_development.ForwardRef = ForwardRef;
reactIs_development.Fragment = Fragment;
reactIs_development.Lazy = Lazy;
reactIs_development.Memo = Memo;
reactIs_development.Portal = Portal;
reactIs_development.Profiler = Profiler;
reactIs_development.StrictMode = StrictMode;
reactIs_development.Suspense = Suspense;
reactIs_development.isAsyncMode = isAsyncMode;
reactIs_development.isConcurrentMode = isConcurrentMode;
reactIs_development.isContextConsumer = isContextConsumer;
reactIs_development.isContextProvider = isContextProvider;
reactIs_development.isElement = isElement;
reactIs_development.isForwardRef = isForwardRef;
reactIs_development.isFragment = isFragment;
reactIs_development.isLazy = isLazy;
reactIs_development.isMemo = isMemo;
reactIs_development.isPortal = isPortal;
reactIs_development.isProfiler = isProfiler;
reactIs_development.isStrictMode = isStrictMode;
reactIs_development.isSuspense = isSuspense;
reactIs_development.isValidElementType = isValidElementType;
reactIs_development.typeOf = typeOf;
  })();
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = reactIs_production_min;
} else {
  reactIs.exports = reactIs_development;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$3 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$3;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$2 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$2);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$1(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$1(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactIs$1 = reactIs.exports;
var assign = objectAssign;

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
var checkPropTypes = checkPropTypes_1;

var has = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs.exports;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

/**
 * @ignore - internal component.
 */

var SuccessOutlinedIcon = require$$0.createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

/**
 * @ignore - internal component.
 */

var ReportProblemOutlinedIcon = require$$0.createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

/**
 * @ignore - internal component.
 */

var ErrorOutlineIcon = require$$0.createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

/**
 * @ignore - internal component.
 */

var InfoOutlinedIcon = require$$0.createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

/**
 * @ignore - internal component.
 */

var CloseIcon = require$$0.createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

var styles$5 = function styles(theme) {
  var getColor = theme.palette.type === 'light' ? styles$6.darken : styles$6.lighten;
  var getBackgroundColor = theme.palette.type === 'light' ? styles$6.lighten : styles$6.darken;
  return {
    /* Styles applied to the root element. */
    root: _extends({}, theme.typography.body2, {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: 'transparent',
      display: 'flex',
      padding: '6px 16px'
    }),

    /* Styles applied to the root element if `variant="standard"` and `color="success"`. */
    standardSuccess: {
      color: getColor(theme.palette.success.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.success.main, 0.9),
      '& $icon': {
        color: theme.palette.success.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="info"`. */
    standardInfo: {
      color: getColor(theme.palette.info.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.info.main, 0.9),
      '& $icon': {
        color: theme.palette.info.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="warning"`. */
    standardWarning: {
      color: getColor(theme.palette.warning.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.warning.main, 0.9),
      '& $icon': {
        color: theme.palette.warning.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="error"`. */
    standardError: {
      color: getColor(theme.palette.error.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.error.main, 0.9),
      '& $icon': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="success"`. */
    outlinedSuccess: {
      color: getColor(theme.palette.success.main, 0.6),
      border: "1px solid ".concat(theme.palette.success.main),
      '& $icon': {
        color: theme.palette.success.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="info"`. */
    outlinedInfo: {
      color: getColor(theme.palette.info.main, 0.6),
      border: "1px solid ".concat(theme.palette.info.main),
      '& $icon': {
        color: theme.palette.info.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="warning"`. */
    outlinedWarning: {
      color: getColor(theme.palette.warning.main, 0.6),
      border: "1px solid ".concat(theme.palette.warning.main),
      '& $icon': {
        color: theme.palette.warning.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="error"`. */
    outlinedError: {
      color: getColor(theme.palette.error.main, 0.6),
      border: "1px solid ".concat(theme.palette.error.main),
      '& $icon': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `variant="filled"` and `color="success"`. */
    filledSuccess: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.success.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="info"`. */
    filledInfo: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.info.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="warning"`. */
    filledWarning: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.warning.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="error"`. */
    filledError: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.error.main
    },

    /* Styles applied to the icon wrapper element. */
    icon: {
      marginRight: 12,
      padding: '7px 0',
      display: 'flex',
      fontSize: 22,
      opacity: 0.9
    },

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 16,
      marginRight: -8
    }
  };
};
var defaultIconMapping = {
  success: /*#__PURE__*/React__namespace.createElement(SuccessOutlinedIcon, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/React__namespace.createElement(ReportProblemOutlinedIcon, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/React__namespace.createElement(ErrorOutlineIcon, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/React__namespace.createElement(InfoOutlinedIcon, {
    fontSize: "inherit"
  })
};

var _ref$1 = /*#__PURE__*/React__namespace.createElement(CloseIcon, {
  fontSize: "small"
});

var Alert = /*#__PURE__*/React__namespace.forwardRef(function Alert(props, ref) {
  var action = props.action,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$closeText = props.closeText,
      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText,
      color = props.color,
      icon = props.icon,
      _props$iconMapping = props.iconMapping,
      iconMapping = _props$iconMapping === void 0 ? defaultIconMapping : _props$iconMapping,
      onClose = props.onClose,
      _props$role = props.role,
      role = _props$role === void 0 ? 'alert' : _props$role,
      _props$severity = props.severity,
      severity = _props$severity === void 0 ? 'success' : _props$severity,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties(props, ["action", "children", "classes", "className", "closeText", "color", "icon", "iconMapping", "onClose", "role", "severity", "variant"]);

  return /*#__PURE__*/React__namespace.createElement(Paper__default['default'], _extends({
    role: role,
    square: true,
    elevation: 0,
    className: clsx(classes.root, classes["".concat(variant).concat(require$$0.capitalize(color || severity))], className),
    ref: ref
  }, other), icon !== false ? /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.icon
  }, icon || iconMapping[severity] || defaultIconMapping[severity]) : null, /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.message
  }, children), action != null ? /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.action
  }, action) : null, action == null && onClose ? /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.action
  }, /*#__PURE__*/React__namespace.createElement(IconButton__default['default'], {
    size: "small",
    "aria-label": closeText,
    title: closeText,
    color: "inherit",
    onClick: onClose
  }, _ref$1)) : null);
});
process.env.NODE_ENV !== "production" ? Alert.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: PropTypes.node,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: PropTypes.string,

  /**
   * The main color for the alert. Unless provided, the value is taken from the `severity` prop.
   */
  color: PropTypes.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   */
  icon: PropTypes.node,

  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: PropTypes.shape({
    error: PropTypes.node,
    info: PropTypes.node,
    success: PropTypes.node,
    warning: PropTypes.node
  }),

  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * The ARIA role attribute of the element.
   */
  role: PropTypes.string,

  /**
   * The severity of the alert. This defines the color and icon used.
   */
  severity: PropTypes.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var Alert$1 = styles$6.withStyles(styles$5, {
  name: 'MuiAlert'
})(Alert);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/**
 * @ignore - internal component.
 */

var ArrowDropDownIcon = require$$0.createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _typeof$2(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$2 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$2 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$2(obj);
}

// Give up on IE 11 support for this feature

function stripDiacritics(string) {
  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}

function createFilterOptions() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$ignoreAccents = config.ignoreAccents,
      ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents,
      _config$ignoreCase = config.ignoreCase,
      ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase,
      limit = config.limit,
      _config$matchFrom = config.matchFrom,
      matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom,
      stringify = config.stringify,
      _config$trim = config.trim,
      trim = _config$trim === void 0 ? false : _config$trim;
  return function (options, _ref) {
    var inputValue = _ref.inputValue,
        getOptionLabel = _ref.getOptionLabel;
    var input = trim ? inputValue.trim() : inputValue;

    if (ignoreCase) {
      input = input.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
    }

    var filteredOptions = options.filter(function (option) {
      var candidate = (stringify || getOptionLabel)(option);

      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }

      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }

      return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
    });
    return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
  };
} // To replace with .findIndex() once we stop IE 11 support.

function findIndex$1(array, comp) {
  for (var i = 0; i < array.length; i += 1) {
    if (comp(array[i])) {
      return i;
    }
  }

  return -1;
}

var defaultFilterOptions = createFilterOptions(); // Number of options to jump in list box when pageup and pagedown keys are used.

var pageSize = 5;
function useAutocomplete(props) {
  var _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
      _props$autoHighlight = props.autoHighlight,
      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
      _props$autoSelect = props.autoSelect,
      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
      _props$blurOnSelect = props.blurOnSelect,
      blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
      _props$clearOnBlur = props.clearOnBlur,
      clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur,
      _props$clearOnEscape = props.clearOnEscape,
      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
      _props$componentName = props.componentName,
      componentName = _props$componentName === void 0 ? 'useAutocomplete' : _props$componentName,
      _props$debug = props.debug,
      debug = _props$debug === void 0 ? false : _props$debug,
      _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue,
      _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
      _props$disableCloseOn = props.disableCloseOnSelect,
      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      _props$filterOptions = props.filterOptions,
      filterOptions = _props$filterOptions === void 0 ? defaultFilterOptions : _props$filterOptions,
      _props$filterSelected = props.filterSelectedOptions,
      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      getOptionDisabled = props.getOptionDisabled,
      _props$getOptionLabel = props.getOptionLabel,
      getOptionLabelProp = _props$getOptionLabel === void 0 ? function (option) {
    return option;
  } : _props$getOptionLabel,
      _props$getOptionSelec = props.getOptionSelected,
      getOptionSelected = _props$getOptionSelec === void 0 ? function (option, value) {
    return option === value;
  } : _props$getOptionSelec,
      groupBy = props.groupBy,
      _props$handleHomeEndK = props.handleHomeEndKeys,
      handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK,
      idProp = props.id,
      _props$includeInputIn = props.includeInputInList,
      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
      inputValueProp = props.inputValue,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      onChange = props.onChange,
      onClose = props.onClose,
      onHighlightChange = props.onHighlightChange,
      onInputChange = props.onInputChange,
      onOpen = props.onOpen,
      openProp = props.open,
      _props$openOnFocus = props.openOnFocus,
      openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus,
      options = props.options,
      _props$selectOnFocus = props.selectOnFocus,
      selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus,
      valueProp = props.value;
  var id = require$$0.unstable_useId(idProp);
  var getOptionLabel = getOptionLabelProp;

  if (process.env.NODE_ENV !== 'production') {
    getOptionLabel = function getOptionLabel(option) {
      var optionLabel = getOptionLabelProp(option);

      if (typeof optionLabel !== 'string') {
        var erroneousReturn = optionLabel === undefined ? 'undefined' : "".concat(_typeof$2(optionLabel), " (").concat(optionLabel, ")");
        console.error("Material-UI: The `getOptionLabel` method of ".concat(componentName, " returned ").concat(erroneousReturn, " instead of a string for ").concat(JSON.stringify(option), "."));
      }

      return optionLabel;
    };
  }

  var ignoreFocus = React__namespace.useRef(false);
  var firstFocus = React__namespace.useRef(true);
  var inputRef = React__namespace.useRef(null);
  var listboxRef = React__namespace.useRef(null);

  var _React$useState = React__namespace.useState(null),
      anchorEl = _React$useState[0],
      setAnchorEl = _React$useState[1];

  var _React$useState2 = React__namespace.useState(-1),
      focusedTag = _React$useState2[0],
      setFocusedTag = _React$useState2[1];

  var defaultHighlighted = autoHighlight ? 0 : -1;
  var highlightedIndexRef = React__namespace.useRef(defaultHighlighted);

  var _useControlled = require$$0.useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: componentName
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var _useControlled3 = require$$0.useControlled({
    controlled: inputValueProp,
    default: '',
    name: componentName,
    state: 'inputValue'
  }),
      _useControlled4 = _slicedToArray(_useControlled3, 2),
      inputValue = _useControlled4[0],
      setInputValue = _useControlled4[1];

  var _React$useState3 = React__namespace.useState(false),
      focused = _React$useState3[0],
      setFocused = _React$useState3[1];

  var resetInputValue = require$$0.useEventCallback(function (event, newValue) {
    var newInputValue;

    if (multiple) {
      newInputValue = '';
    } else if (newValue == null) {
      newInputValue = '';
    } else {
      var optionLabel = getOptionLabel(newValue);
      newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
    }

    if (inputValue === newInputValue) {
      return;
    }

    setInputValue(newInputValue);

    if (onInputChange) {
      onInputChange(event, newInputValue, 'reset');
    }
  });
  React__namespace.useEffect(function () {
    resetInputValue(null, value);
  }, [value, resetInputValue]);

  var _useControlled5 = require$$0.useControlled({
    controlled: openProp,
    default: false,
    name: componentName,
    state: 'open'
  }),
      _useControlled6 = _slicedToArray(_useControlled5, 2),
      open = _useControlled6[0],
      setOpenState = _useControlled6[1];

  var inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
  var popupOpen = open;
  var filteredOptions = popupOpen ? filterOptions(options.filter(function (option) {
    if (filterSelectedOptions && (multiple ? value : [value]).some(function (value2) {
      return value2 !== null && getOptionSelected(option, value2);
    })) {
      return false;
    }

    return true;
  }), // we use the empty string to manipulate `filterOptions` to not filter any options
  // i.e. the filter predicate always returns true
  {
    inputValue: inputValueIsSelectedValue ? '' : inputValue,
    getOptionLabel: getOptionLabel
  }) : [];

  if (process.env.NODE_ENV !== 'production') {
    if (value !== null && !freeSolo && options.length > 0) {
      var missingValue = (multiple ? value : [value]).filter(function (value2) {
        return !options.some(function (option) {
          return getOptionSelected(option, value2);
        });
      });

      if (missingValue.length > 0) {
        console.warn(["Material-UI: The value provided to ".concat(componentName, " is invalid."), "None of the options match with `".concat(missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0]), "`."), 'You can use the `getOptionSelected` prop to customize the equality test.'].join('\n'));
      }
    }
  }

  var focusTag = require$$0.useEventCallback(function (tagToFocus) {
    if (tagToFocus === -1) {
      inputRef.current.focus();
    } else {
      anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
    }
  }); // Ensure the focusedTag is never inconsistent

  React__namespace.useEffect(function () {
    if (multiple && focusedTag > value.length - 1) {
      setFocusedTag(-1);
      focusTag(-1);
    }
  }, [value, multiple, focusedTag, focusTag]);

  function validOptionIndex(index, direction) {
    if (!listboxRef.current || index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      var nextFocusDisabled = disabledItemsFocusable ? false : option && (option.disabled || option.getAttribute('aria-disabled') === 'true');

      if (option && !option.hasAttribute('tabindex') || nextFocusDisabled) {
        // Move to the next element.
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var setHighlightedIndex = require$$0.useEventCallback(function (_ref2) {
    var event = _ref2.event,
        index = _ref2.index,
        _ref2$reason = _ref2.reason,
        reason = _ref2$reason === void 0 ? 'auto' : _ref2$reason;
    highlightedIndexRef.current = index; // does the index exist?

    if (index === -1) {
      inputRef.current.removeAttribute('aria-activedescendant');
    } else {
      inputRef.current.setAttribute('aria-activedescendant', "".concat(id, "-option-").concat(index));
    }

    if (onHighlightChange) {
      onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
    }

    if (!listboxRef.current) {
      return;
    }

    var prev = listboxRef.current.querySelector('[data-focus]');

    if (prev) {
      prev.removeAttribute('data-focus');
    }

    var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"

    if (!listboxNode) {
      return;
    }

    if (index === -1) {
      listboxNode.scrollTop = 0;
      return;
    }

    var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));

    if (!option) {
      return;
    }

    option.setAttribute('data-focus', 'true'); // Scroll active descendant into view.
    // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
    //
    // Consider this API instead once it has a better browser support:
    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });

    if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse') {
      var element = option;
      var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
      var elementBottom = element.offsetTop + element.offsetHeight;

      if (elementBottom > scrollBottom) {
        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
      } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
        listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
      }
    }
  });
  var changeHighlightedIndex = require$$0.useEventCallback(function (_ref3) {
    var event = _ref3.event,
        diff = _ref3.diff,
        _ref3$direction = _ref3.direction,
        direction = _ref3$direction === void 0 ? 'next' : _ref3$direction,
        _ref3$reason = _ref3.reason,
        reason = _ref3$reason === void 0 ? 'auto' : _ref3$reason;

    if (!popupOpen) {
      return;
    }

    var getNextIndex = function getNextIndex() {
      var maxIndex = filteredOptions.length - 1;

      if (diff === 'reset') {
        return defaultHighlighted;
      }

      if (diff === 'start') {
        return 0;
      }

      if (diff === 'end') {
        return maxIndex;
      }

      var newIndex = highlightedIndexRef.current + diff;

      if (newIndex < 0) {
        if (newIndex === -1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
          return 0;
        }

        return maxIndex;
      }

      if (newIndex > maxIndex) {
        if (newIndex === maxIndex + 1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap || Math.abs(diff) > 1) {
          return maxIndex;
        }

        return 0;
      }

      return newIndex;
    };

    var nextIndex = validOptionIndex(getNextIndex(), direction);
    setHighlightedIndex({
      index: nextIndex,
      reason: reason,
      event: event
    }); // Sync the content of the input with the highlighted option.

    if (autoComplete && diff !== 'reset') {
      if (nextIndex === -1) {
        inputRef.current.value = inputValue;
      } else {
        var option = getOptionLabel(filteredOptions[nextIndex]);
        inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
        // a completion string, appears inline after the input cursor in the textbox.

        var index = option.toLowerCase().indexOf(inputValue.toLowerCase());

        if (index === 0 && inputValue.length > 0) {
          inputRef.current.setSelectionRange(inputValue.length, option.length);
        }
      }
    }
  });
  var syncHighlightedIndex = React__namespace.useCallback(function () {
    if (!popupOpen) {
      return;
    }

    var valueItem = multiple ? value[0] : value; // The popup is empty, reset

    if (filteredOptions.length === 0 || valueItem == null) {
      changeHighlightedIndex({
        diff: 'reset'
      });
      return;
    }

    if (!listboxRef.current) {
      return;
    } // Synchronize the value with the highlighted index


    if (!filterSelectedOptions && valueItem != null) {
      var currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible

      if (multiple && currentOption && findIndex$1(value, function (val) {
        return getOptionSelected(currentOption, val);
      }) !== -1) {
        return;
      }

      var itemIndex = findIndex$1(filteredOptions, function (optionItem) {
        return getOptionSelected(optionItem, valueItem);
      });

      if (itemIndex === -1) {
        changeHighlightedIndex({
          diff: 'reset'
        });
      } else {
        setHighlightedIndex({
          index: itemIndex
        });
      }

      return;
    } // Prevent the highlighted index to leak outside the boundaries.


    if (highlightedIndexRef.current >= filteredOptions.length - 1) {
      setHighlightedIndex({
        index: filteredOptions.length - 1
      });
      return;
    } // Restore the focus to the previous index.


    setHighlightedIndex({
      index: highlightedIndexRef.current
    }); // Ignore filteredOptions (and options, getOptionSelected, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [// Only sync the highlighted index when the option switch between empty and not
  // eslint-disable-next-line react-hooks/exhaustive-deps
  filteredOptions.length === 0, // Don't sync the highlighted index with the value when multiple
  // eslint-disable-next-line react-hooks/exhaustive-deps
  multiple ? false : value, filterSelectedOptions, changeHighlightedIndex, setHighlightedIndex, popupOpen, inputValue, multiple]);
  var handleListboxRef = require$$0.useEventCallback(function (node) {
    require$$0.setRef(listboxRef, node);

    if (!node) {
      return;
    }

    syncHighlightedIndex();
  });
  React__namespace.useEffect(function () {
    syncHighlightedIndex();
  }, [syncHighlightedIndex]);

  var handleOpen = function handleOpen(event) {
    if (open) {
      return;
    }

    setOpenState(true);

    if (onOpen) {
      onOpen(event);
    }
  };

  var handleClose = function handleClose(event, reason) {
    if (!open) {
      return;
    }

    setOpenState(false);

    if (onClose) {
      onClose(event, reason);
    }
  };

  var handleValue = function handleValue(event, newValue, reason, details) {
    if (value === newValue) {
      return;
    }

    if (onChange) {
      onChange(event, newValue, reason, details);
    }

    setValue(newValue);
  };

  var isTouch = React__namespace.useRef(false);

  var selectNewValue = function selectNewValue(event, option) {
    var reasonProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'select-option';
    var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'options';
    var reason = reasonProp;
    var newValue = option;

    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];

      if (process.env.NODE_ENV !== 'production') {
        var matches = newValue.filter(function (val) {
          return getOptionSelected(option, val);
        });

        if (matches.length > 1) {
          console.error(["Material-UI: The `getOptionSelected` method of ".concat(componentName, " do not handle the arguments correctly."), "The component expects a single value to match a given option but found ".concat(matches.length, " matches.")].join('\n'));
        }
      }

      var itemIndex = findIndex$1(newValue, function (valueItem) {
        return getOptionSelected(option, valueItem);
      });

      if (itemIndex === -1) {
        newValue.push(option);
      } else if (origin !== 'freeSolo') {
        newValue.splice(itemIndex, 1);
        reason = 'remove-option';
      }
    }

    resetInputValue(event, newValue);
    handleValue(event, newValue, reason, {
      option: option
    });

    if (!disableCloseOnSelect) {
      handleClose(event, reason);
    }

    if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) {
      inputRef.current.blur();
    }
  };

  function validTagIndex(index, direction) {
    if (index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) {
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var handleFocusTag = function handleFocusTag(event, direction) {
    if (!multiple) {
      return;
    }

    handleClose(event, 'toggleInput');
    var nextTag = focusedTag;

    if (focusedTag === -1) {
      if (inputValue === '' && direction === 'previous') {
        nextTag = value.length - 1;
      }
    } else {
      nextTag += direction === 'next' ? 1 : -1;

      if (nextTag < 0) {
        nextTag = 0;
      }

      if (nextTag === value.length) {
        nextTag = -1;
      }
    }

    nextTag = validTagIndex(nextTag, direction);
    setFocusedTag(nextTag);
    focusTag(nextTag);
  };

  var handleClear = function handleClear(event) {
    ignoreFocus.current = true;
    setInputValue('');

    if (onInputChange) {
      onInputChange(event, '', 'clear');
    }

    handleValue(event, multiple ? [] : null, 'clear');
  };

  var handleKeyDown = function handleKeyDown(other) {
    return function (event) {
      if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
        setFocusedTag(-1);
        focusTag(-1);
      }

      switch (event.key) {
        case 'Home':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'start',
              direction: 'next',
              reason: 'keyboard',
              event: event
            });
          }

          break;

        case 'End':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'end',
              direction: 'previous',
              reason: 'keyboard',
              event: event
            });
          }

          break;

        case 'PageUp':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: -pageSize,
            direction: 'previous',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'PageDown':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: pageSize,
            direction: 'next',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'ArrowDown':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: 1,
            direction: 'next',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'ArrowUp':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: -1,
            direction: 'previous',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'ArrowLeft':
          handleFocusTag(event, 'previous');
          break;

        case 'ArrowRight':
          handleFocusTag(event, 'next');
          break;

        case 'Enter':
          // Wait until IME is settled.
          if (event.which === 229) {
            break;
          }

          if (highlightedIndexRef.current !== -1 && popupOpen) {
            var option = filteredOptions[highlightedIndexRef.current];
            var disabled = getOptionDisabled ? getOptionDisabled(option) : false; // We don't want to validate the form.

            event.preventDefault();

            if (disabled) {
              return;
            }

            selectNewValue(event, option, 'select-option'); // Move the selection to the end.

            if (autoComplete) {
              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }
          } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
            if (multiple) {
              // Allow people to add new values before they submit the form.
              event.preventDefault();
            }

            selectNewValue(event, inputValue, 'create-option', 'freeSolo');
          }

          break;

        case 'Escape':
          if (popupOpen) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault(); // Avoid the Modal to handle the event.

            event.stopPropagation();
            handleClose(event, 'escape');
          } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault(); // Avoid the Modal to handle the event.

            event.stopPropagation();
            handleClear(event);
          }

          break;

        case 'Backspace':
          if (multiple && inputValue === '' && value.length > 0) {
            var index = focusedTag === -1 ? value.length - 1 : focusedTag;
            var newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'remove-option', {
              option: value[index]
            });
          }

          break;
      }

      if (other.onKeyDown) {
        other.onKeyDown(event);
      }
    };
  };

  var handleFocus = function handleFocus(event) {
    setFocused(true);

    if (openOnFocus && !ignoreFocus.current) {
      handleOpen(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    // Ignore the event when using the scrollbar with IE 11
    if (listboxRef.current !== null && document.activeElement === listboxRef.current.parentElement) {
      inputRef.current.focus();
      return;
    }

    setFocused(false);
    firstFocus.current = true;
    ignoreFocus.current = false;

    if (debug && inputValue !== '') {
      return;
    }

    if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) {
      selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
    } else if (autoSelect && freeSolo && inputValue !== '') {
      selectNewValue(event, inputValue, 'blur', 'freeSolo');
    } else if (clearOnBlur) {
      resetInputValue(event, value);
    }

    handleClose(event, 'blur');
  };

  var handleInputChange = function handleInputChange(event) {
    var newValue = event.target.value;

    if (inputValue !== newValue) {
      setInputValue(newValue);

      if (onInputChange) {
        onInputChange(event, newValue, 'input');
      }
    }

    if (newValue === '') {
      if (!disableClearable && !multiple) {
        handleValue(event, null, 'clear');
      }
    } else {
      handleOpen(event);
    }
  };

  var handleOptionMouseOver = function handleOptionMouseOver(event) {
    setHighlightedIndex({
      event: event,
      index: Number(event.currentTarget.getAttribute('data-option-index')),
      reason: 'mouse'
    });
  };

  var handleOptionTouchStart = function handleOptionTouchStart() {
    isTouch.current = true;
  };

  var handleOptionClick = function handleOptionClick(event) {
    var index = Number(event.currentTarget.getAttribute('data-option-index'));
    selectNewValue(event, filteredOptions[index], 'select-option');
    isTouch.current = false;
  };

  var handleTagDelete = function handleTagDelete(index) {
    return function (event) {
      var newValue = value.slice();
      newValue.splice(index, 1);
      handleValue(event, newValue, 'remove-option', {
        option: value[index]
      });
    };
  };

  var handlePopupIndicator = function handlePopupIndicator(event) {
    if (open) {
      handleClose(event, 'toggleInput');
    } else {
      handleOpen(event);
    }
  }; // Prevent input blur when interacting with the combobox


  var handleMouseDown = function handleMouseDown(event) {
    if (event.target.getAttribute('id') !== id) {
      event.preventDefault();
    }
  }; // Focus the input when interacting with the combobox


  var handleClick = function handleClick() {
    inputRef.current.focus();

    if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
      inputRef.current.select();
    }

    firstFocus.current = false;
  };

  var handleInputMouseDown = function handleInputMouseDown(event) {
    if (inputValue === '' || !open) {
      handlePopupIndicator(event);
    }
  };

  var dirty = freeSolo && inputValue.length > 0;
  dirty = dirty || (multiple ? value.length > 0 : value !== null);
  var groupedOptions = filteredOptions;

  if (groupBy) {
    // used to keep track of key and indexes in the result array
    var indexBy = new Map();
    var warn = false;
    groupedOptions = filteredOptions.reduce(function (acc, option, index) {
      var group = groupBy(option);

      if (acc.length > 0 && acc[acc.length - 1].group === group) {
        acc[acc.length - 1].options.push(option);
      } else {
        if (process.env.NODE_ENV !== 'production') {
          if (indexBy.get(group) && !warn) {
            console.warn("Material-UI: The options provided combined with the `groupBy` method of ".concat(componentName, " returns duplicated headers."), 'You can solve the issue by sorting the options with the output of `groupBy`.');
            warn = true;
          }

          indexBy.set(group, true);
        }

        acc.push({
          key: index,
          index: index,
          group: group,
          options: [option]
        });
      }

      return acc;
    }, []);
  }

  return {
    getRootProps: function getRootProps() {
      var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _extends({
        'aria-owns': popupOpen ? "".concat(id, "-popup") : null,
        role: 'combobox',
        'aria-expanded': popupOpen
      }, other, {
        onKeyDown: handleKeyDown(other),
        onMouseDown: handleMouseDown,
        onClick: handleClick
      });
    },
    getInputLabelProps: function getInputLabelProps() {
      return {
        id: "".concat(id, "-label"),
        htmlFor: id
      };
    },
    getInputProps: function getInputProps() {
      return {
        id: id,
        value: inputValue,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleInputChange,
        onMouseDown: handleInputMouseDown,
        // if open then this is handled imperativeley so don't let react override
        // only have an opinion about this when closed
        'aria-activedescendant': popupOpen ? '' : null,
        'aria-autocomplete': autoComplete ? 'both' : 'list',
        'aria-controls': popupOpen ? "".concat(id, "-popup") : null,
        // Disable browser's suggestion that might overlap with the popup.
        // Handle autocomplete but not autofill.
        autoComplete: 'off',
        ref: inputRef,
        autoCapitalize: 'none',
        spellCheck: 'false'
      };
    },
    getClearProps: function getClearProps() {
      return {
        tabIndex: -1,
        onClick: handleClear
      };
    },
    getPopupIndicatorProps: function getPopupIndicatorProps() {
      return {
        tabIndex: -1,
        onClick: handlePopupIndicator
      };
    },
    getTagProps: function getTagProps(_ref4) {
      var index = _ref4.index;
      return {
        key: index,
        'data-tag-index': index,
        tabIndex: -1,
        onDelete: handleTagDelete(index)
      };
    },
    getListboxProps: function getListboxProps() {
      return {
        role: 'listbox',
        id: "".concat(id, "-popup"),
        'aria-labelledby': "".concat(id, "-label"),
        ref: handleListboxRef,
        onMouseDown: function onMouseDown(event) {
          // Prevent blur
          event.preventDefault();
        }
      };
    },
    getOptionProps: function getOptionProps(_ref5) {
      var index = _ref5.index,
          option = _ref5.option;
      var selected = (multiple ? value : [value]).some(function (value2) {
        return value2 != null && getOptionSelected(option, value2);
      });
      var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
      return {
        key: index,
        tabIndex: -1,
        role: 'option',
        id: "".concat(id, "-option-").concat(index),
        onMouseOver: handleOptionMouseOver,
        onClick: handleOptionClick,
        onTouchStart: handleOptionTouchStart,
        'data-option-index': index,
        'aria-disabled': disabled,
        'aria-selected': selected
      };
    },
    id: id,
    inputValue: inputValue,
    value: value,
    dirty: dirty,
    popupOpen: popupOpen,
    focused: focused || focusedTag !== -1,
    anchorEl: anchorEl,
    setAnchorEl: setAnchorEl,
    focusedTag: focusedTag,
    groupedOptions: groupedOptions
  };
}

var styles$4 = function styles(theme) {
  var _option;

  return {
    /* Styles applied to the root element. */
    root: {
      '&$focused $clearIndicatorDirty': {
        visibility: 'visible'
      },

      /* Avoid double tap issue on iOS */
      '@media (pointer: fine)': {
        '&:hover $clearIndicatorDirty': {
          visibility: 'visible'
        }
      }
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Pseudo-class applied to the root element if focused. */
    focused: {},

    /* Styles applied to the tag elements, e.g. the chips. */
    tag: {
      margin: 3,
      maxWidth: 'calc(100% - 6px)'
    },

    /* Styles applied to the tag elements, e.g. the chips if `size="small"`. */
    tagSizeSmall: {
      margin: 2,
      maxWidth: 'calc(100% - 4px)'
    },

    /* Styles applied when the popup icon is rendered. */
    hasPopupIcon: {},

    /* Styles applied when the clear icon is rendered. */
    hasClearIcon: {},

    /* Styles applied to the Input element. */
    inputRoot: {
      flexWrap: 'wrap',
      '$hasPopupIcon &, $hasClearIcon &': {
        paddingRight: 26 + 4
      },
      '$hasPopupIcon$hasClearIcon &': {
        paddingRight: 52 + 4
      },
      '& $input': {
        width: 0,
        minWidth: 30
      },
      '&[class*="MuiInput-root"]': {
        paddingBottom: 1,
        '& $input': {
          padding: 4
        },
        '& $input:first-child': {
          padding: '6px 0'
        }
      },
      '&[class*="MuiInput-root"][class*="MuiInput-marginDense"]': {
        '& $input': {
          padding: '4px 4px 5px'
        },
        '& $input:first-child': {
          padding: '3px 0 6px'
        }
      },
      '&[class*="MuiOutlinedInput-root"]': {
        padding: 9,
        '$hasPopupIcon &, $hasClearIcon &': {
          paddingRight: 26 + 4 + 9
        },
        '$hasPopupIcon$hasClearIcon &': {
          paddingRight: 52 + 4 + 9
        },
        '& $input': {
          padding: '9.5px 4px'
        },
        '& $input:first-child': {
          paddingLeft: 6
        },
        '& $endAdornment': {
          right: 9
        }
      },
      '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
        padding: 6,
        '& $input': {
          padding: '4.5px 4px'
        }
      },
      '&[class*="MuiFilledInput-root"]': {
        paddingTop: 19,
        paddingLeft: 8,
        '$hasPopupIcon &, $hasClearIcon &': {
          paddingRight: 26 + 4 + 9
        },
        '$hasPopupIcon$hasClearIcon &': {
          paddingRight: 52 + 4 + 9
        },
        '& $input': {
          padding: '9px 4px'
        },
        '& $endAdornment': {
          right: 9
        }
      },
      '&[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]': {
        paddingBottom: 1,
        '& $input': {
          padding: '4.5px 4px'
        }
      }
    },

    /* Styles applied to the input element. */
    input: {
      flexGrow: 1,
      textOverflow: 'ellipsis',
      opacity: 0
    },

    /* Styles applied to the input element if tag focused. */
    inputFocused: {
      opacity: 1
    },

    /* Styles applied to the endAdornment element. */
    endAdornment: {
      // We use a position absolute to support wrapping tags.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 14px)' // Center vertically

    },

    /* Styles applied to the clear indicator. */
    clearIndicator: {
      marginRight: -2,
      padding: 4,
      visibility: 'hidden'
    },

    /* Styles applied to the clear indicator if the input is dirty. */
    clearIndicatorDirty: {},

    /* Styles applied to the popup indicator. */
    popupIndicator: {
      padding: 2,
      marginRight: -2
    },

    /* Styles applied to the popup indicator if the popup is open. */
    popupIndicatorOpen: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the popper element. */
    popper: {
      zIndex: theme.zIndex.modal
    },

    /* Styles applied to the popper element if `disablePortal={true}`. */
    popperDisablePortal: {
      position: 'absolute'
    },

    /* Styles applied to the `Paper` component. */
    paper: _extends({}, theme.typography.body1, {
      overflow: 'hidden',
      margin: '4px 0'
    }),

    /* Styles applied to the `listbox` component. */
    listbox: {
      listStyle: 'none',
      margin: 0,
      padding: '8px 0',
      maxHeight: '40vh',
      overflow: 'auto'
    },

    /* Styles applied to the loading wrapper. */
    loading: {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    },

    /* Styles applied to the no option wrapper. */
    noOptions: {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    },

    /* Styles applied to the option elements. */
    option: (_option = {
      minHeight: 48,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      cursor: 'pointer',
      paddingTop: 6,
      boxSizing: 'border-box',
      outline: '0',
      WebkitTapHighlightColor: 'transparent',
      paddingBottom: 6,
      paddingLeft: 16,
      paddingRight: 16
    }, _defineProperty(_option, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    }), _defineProperty(_option, '&[aria-selected="true"]', {
      backgroundColor: theme.palette.action.selected
    }), _defineProperty(_option, '&[data-focus="true"]', {
      backgroundColor: theme.palette.action.hover
    }), _defineProperty(_option, '&:active', {
      backgroundColor: theme.palette.action.selected
    }), _defineProperty(_option, '&[aria-disabled="true"]', {
      opacity: theme.palette.action.disabledOpacity,
      pointerEvents: 'none'
    }), _option),

    /* Styles applied to the group's label elements. */
    groupLabel: {
      backgroundColor: theme.palette.background.paper,
      top: -8
    },

    /* Styles applied to the group's ul elements. */
    groupUl: {
      padding: 0,
      '& $option': {
        paddingLeft: 24
      }
    }
  };
};

function DisablePortal(props) {
  // eslint-disable-next-line react/prop-types
  props.anchorEl;
      props.open;
      var other = _objectWithoutProperties(props, ["anchorEl", "open"]);

  return /*#__PURE__*/React__namespace.createElement("div", other);
}

var _ref = /*#__PURE__*/React__namespace.createElement(CloseIcon, {
  fontSize: "small"
});

var _ref2 = /*#__PURE__*/React__namespace.createElement(ArrowDropDownIcon, null);

var Autocomplete = /*#__PURE__*/React__namespace.forwardRef(function Autocomplete(props, ref) {
  /* eslint-disable no-unused-vars */
  props.autoComplete;
      props.autoHighlight;
      props.autoSelect;
      props.blurOnSelect;
      var ChipProps = props.ChipProps,
      classes = props.classes,
      className = props.className,
      _props$clearOnBlur = props.clearOnBlur;
      _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur;
      props.clearOnEscape;
      var _props$clearText = props.clearText,
      clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText,
      _props$closeIcon = props.closeIcon,
      closeIcon = _props$closeIcon === void 0 ? _ref : _props$closeIcon,
      _props$closeText = props.closeText,
      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText;
      props.debug;
      var _props$defaultValue = props.defaultValue;
      _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue;
      var _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab;
      props.disableCloseOnSelect;
      var _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
      props.disabledItemsFocusable;
      props.disableListWrap;
      var _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal;
      props.filterOptions;
      props.filterSelectedOptions;
      var _props$forcePopupIcon = props.forcePopupIcon,
      forcePopupIcon = _props$forcePopupIcon === void 0 ? 'auto' : _props$forcePopupIcon,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$getLimitTagsTe = props.getLimitTagsText,
      getLimitTagsText = _props$getLimitTagsTe === void 0 ? function (more) {
    return "+".concat(more);
  } : _props$getLimitTagsTe;
      props.getOptionDisabled;
      var _props$getOptionLabel = props.getOptionLabel,
      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
    return x;
  } : _props$getOptionLabel;
      props.getOptionSelected;
      var groupBy = props.groupBy,
      _props$handleHomeEndK = props.handleHomeEndKeys;
      _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK;
      props.id;
      props.includeInputInList;
      props.inputValue;
      var _props$limitTags = props.limitTags,
      limitTags = _props$limitTags === void 0 ? -1 : _props$limitTags,
      _props$ListboxCompone = props.ListboxComponent,
      ListboxComponent = _props$ListboxCompone === void 0 ? 'ul' : _props$ListboxCompone,
      ListboxProps = props.ListboxProps,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$loadingText = props.loadingText,
      loadingText = _props$loadingText === void 0 ? 'Loading…' : _props$loadingText,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$noOptionsText = props.noOptionsText,
      noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText;
      props.onChange;
      props.onClose;
      props.onHighlightChange;
      props.onInputChange;
      props.onOpen;
      props.open;
      props.openOnFocus;
      var _props$openText = props.openText,
      openText = _props$openText === void 0 ? 'Open' : _props$openText;
      props.options;
      var _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? Paper__default['default'] : _props$PaperComponent,
      _props$PopperComponen = props.PopperComponent,
      PopperComponentProp = _props$PopperComponen === void 0 ? Popper__default['default'] : _props$PopperComponen,
      _props$popupIcon = props.popupIcon,
      popupIcon = _props$popupIcon === void 0 ? _ref2 : _props$popupIcon,
      renderGroupProp = props.renderGroup,
      renderInput = props.renderInput,
      renderOptionProp = props.renderOption,
      renderTags = props.renderTags,
      _props$selectOnFocus = props.selectOnFocus;
      _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus;
      var _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size;
      props.value;
      var other = _objectWithoutProperties(props, ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "classes", "className", "clearOnBlur", "clearOnEscape", "clearText", "closeIcon", "closeText", "debug", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionLabel", "getOptionSelected", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "value"]);
  /* eslint-enable no-unused-vars */


  var PopperComponent = disablePortal ? DisablePortal : PopperComponentProp;

  var _useAutocomplete = useAutocomplete(_extends({}, props, {
    componentName: 'Autocomplete'
  })),
      getRootProps = _useAutocomplete.getRootProps,
      getInputProps = _useAutocomplete.getInputProps,
      getInputLabelProps = _useAutocomplete.getInputLabelProps,
      getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps,
      getClearProps = _useAutocomplete.getClearProps,
      getTagProps = _useAutocomplete.getTagProps,
      getListboxProps = _useAutocomplete.getListboxProps,
      getOptionProps = _useAutocomplete.getOptionProps,
      value = _useAutocomplete.value,
      dirty = _useAutocomplete.dirty,
      id = _useAutocomplete.id,
      popupOpen = _useAutocomplete.popupOpen,
      focused = _useAutocomplete.focused,
      focusedTag = _useAutocomplete.focusedTag,
      anchorEl = _useAutocomplete.anchorEl,
      setAnchorEl = _useAutocomplete.setAnchorEl,
      inputValue = _useAutocomplete.inputValue,
      groupedOptions = _useAutocomplete.groupedOptions;

  var startAdornment;

  if (multiple && value.length > 0) {
    var getCustomizedTagProps = function getCustomizedTagProps(params) {
      return _extends({
        className: clsx(classes.tag, size === 'small' && classes.tagSizeSmall),
        disabled: disabled
      }, getTagProps(params));
    };

    if (renderTags) {
      startAdornment = renderTags(value, getCustomizedTagProps);
    } else {
      startAdornment = value.map(function (option, index) {
        return /*#__PURE__*/React__namespace.createElement(Chip__default['default'], _extends({
          label: getOptionLabel(option),
          size: size
        }, getCustomizedTagProps({
          index: index
        }), ChipProps));
      });
    }
  }

  if (limitTags > -1 && Array.isArray(startAdornment)) {
    var more = startAdornment.length - limitTags;

    if (!focused && more > 0) {
      startAdornment = startAdornment.splice(0, limitTags);
      startAdornment.push( /*#__PURE__*/React__namespace.createElement("span", {
        className: classes.tag,
        key: startAdornment.length
      }, getLimitTagsText(more)));
    }
  }

  var defaultRenderGroup = function defaultRenderGroup(params) {
    return /*#__PURE__*/React__namespace.createElement("li", {
      key: params.key
    }, /*#__PURE__*/React__namespace.createElement(ListSubheader__default['default'], {
      className: classes.groupLabel,
      component: "div"
    }, params.group), /*#__PURE__*/React__namespace.createElement("ul", {
      className: classes.groupUl
    }, params.children));
  };

  var renderGroup = renderGroupProp || defaultRenderGroup;
  var renderOption = renderOptionProp || getOptionLabel;

  var renderListOption = function renderListOption(option, index) {
    var optionProps = getOptionProps({
      option: option,
      index: index
    });
    return /*#__PURE__*/React__namespace.createElement("li", _extends({}, optionProps, {
      className: classes.option
    }), renderOption(option, {
      selected: optionProps['aria-selected'],
      inputValue: inputValue
    }));
  };

  var hasClearIcon = !disableClearable && !disabled;
  var hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("div", _extends({
    ref: ref,
    className: clsx(classes.root, className, focused && classes.focused, fullWidth && classes.fullWidth, hasClearIcon && classes.hasClearIcon, hasPopupIcon && classes.hasPopupIcon)
  }, getRootProps(other)), renderInput({
    id: id,
    disabled: disabled,
    fullWidth: true,
    size: size === 'small' ? 'small' : undefined,
    InputLabelProps: getInputLabelProps(),
    InputProps: {
      ref: setAnchorEl,
      className: classes.inputRoot,
      startAdornment: startAdornment,
      endAdornment: /*#__PURE__*/React__namespace.createElement("div", {
        className: classes.endAdornment
      }, hasClearIcon ? /*#__PURE__*/React__namespace.createElement(IconButton__default['default'], _extends({}, getClearProps(), {
        "aria-label": clearText,
        title: clearText,
        className: clsx(classes.clearIndicator, dirty && classes.clearIndicatorDirty)
      }), closeIcon) : null, hasPopupIcon ? /*#__PURE__*/React__namespace.createElement(IconButton__default['default'], _extends({}, getPopupIndicatorProps(), {
        disabled: disabled,
        "aria-label": popupOpen ? closeText : openText,
        title: popupOpen ? closeText : openText,
        className: clsx(classes.popupIndicator, popupOpen && classes.popupIndicatorOpen)
      }), popupIcon) : null)
    },
    inputProps: _extends({
      className: clsx(classes.input, focusedTag === -1 && classes.inputFocused),
      disabled: disabled
    }, getInputProps())
  })), popupOpen && anchorEl ? /*#__PURE__*/React__namespace.createElement(PopperComponent, {
    className: clsx(classes.popper, disablePortal && classes.popperDisablePortal),
    style: {
      width: anchorEl ? anchorEl.clientWidth : null
    },
    role: "presentation",
    anchorEl: anchorEl,
    open: true
  }, /*#__PURE__*/React__namespace.createElement(PaperComponent, {
    className: classes.paper
  }, loading && groupedOptions.length === 0 ? /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.loading
  }, loadingText) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.noOptions
  }, noOptionsText) : null, groupedOptions.length > 0 ? /*#__PURE__*/React__namespace.createElement(ListboxComponent, _extends({
    className: classes.listbox
  }, getListboxProps(), ListboxProps), groupedOptions.map(function (option, index) {
    if (groupBy) {
      return renderGroup({
        key: option.key,
        group: option.group,
        children: option.options.map(function (option2, index2) {
          return renderListOption(option2, option.index + index2);
        })
      });
    }

    return renderListOption(option, index);
  })) : null)) : null);
});
process.env.NODE_ENV !== "production" ? Autocomplete.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the portion of the selected suggestion that has not been typed by the user,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   */
  autoComplete: PropTypes.bool,

  /**
   * If `true`, the first option is automatically highlighted.
   */
  autoHighlight: PropTypes.bool,

  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   */
  autoSelect: PropTypes.bool,

  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   */
  blurOnSelect: PropTypes.oneOfType([PropTypes.oneOf(['mouse', 'touch']), PropTypes.bool]),

  /**
   * Props applied to the [`Chip`](/api/chip/) element.
   */
  ChipProps: PropTypes.object,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the input's text will be cleared on blur if no value is selected.
   *
   * Set to `true` if you want to help the user enter a new value.
   * Set to `false` if you want to help the user resume his search.
   */
  clearOnBlur: PropTypes.bool,

  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   */
  clearOnEscape: PropTypes.bool,

  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  clearText: PropTypes.string,

  /**
   * The icon to display in place of the default close icon.
   */
  closeIcon: PropTypes.node,

  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: PropTypes.string,

  /**
   * If `true`, the popup will ignore the blur event if the input is filled.
   * You can inspect the popup markup with your browser tools.
   * Consider this option when you need to customize the component.
   */
  debug: PropTypes.bool,

  /**
   * The default input value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the input can't be cleared.
   */
  disableClearable: PropTypes
  /* @typescript-to-proptypes-ignore */
  .bool,

  /**
   * If `true`, the popup won't close when a value is selected.
   */
  disableCloseOnSelect: PropTypes.bool,

  /**
   * If `true`, the input will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, will allow focus on disabled items.
   */
  disabledItemsFocusable: PropTypes.bool,

  /**
   * If `true`, the list box in the popup will not wrap focus.
   */
  disableListWrap: PropTypes.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * A filter function that determines the options that are eligible.
   *
   * @param {T[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {T[]}
   */
  filterOptions: PropTypes.func,

  /**
   * If `true`, hide the selected options from the list box.
   */
  filterSelectedOptions: PropTypes.bool,

  /**
   * Force the visibility display of the popup icon.
   */
  forcePopupIcon: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.bool]),

  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   */
  freeSolo: PropTypes
  /* @typescript-to-proptypes-ignore */
  .bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   */
  getLimitTagsText: PropTypes.func,

  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {T} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: PropTypes.func,

  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * @param {T} option
   * @returns {string}
   */
  getOptionLabel: PropTypes.func,

  /**
   * Used to determine if an option is selected, considering the current value.
   * Uses strict equality by default.
   *
   * @param {T} option The option to test.
   * @param {T} value The value to test against.
   * @returns {boolean}
   */
  getOptionSelected: PropTypes.func,

  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {T} options The options to group.
   * @returns {string}
   */
  groupBy: PropTypes.func,

  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   */
  handleHomeEndKeys: PropTypes.bool,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,

  /**
   * If `true`, the highlight can move to the input.
   */
  includeInputInList: PropTypes.bool,

  /**
   * The input value.
   */
  inputValue: PropTypes.string,

  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   */
  limitTags: PropTypes.number,

  /**
   * The component used to render the listbox.
   */
  ListboxComponent: PropTypes.elementType,

  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: PropTypes.object,

  /**
   * If `true`, the component is in a loading state.
   */
  loading: PropTypes.bool,

  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  loadingText: PropTypes.node,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes
  /* @typescript-to-proptypes-ignore */
  .bool,

  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  noOptionsText: PropTypes.node,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T|T[]} value The new value of the component.
   * @param {string} reason One of "create-option", "select-option", "remove-option", "blur" or "clear".
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"select-option"`, `"blur"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the highlight option changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`.
   */
  onHighlightChange: PropTypes.func,

  /**
   * Callback fired when the input value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control the popup` open state.
   */
  open: PropTypes.bool,

  /**
   * If `true`, the popup will open on input focus.
   */
  openOnFocus: PropTypes.bool,

  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  openText: PropTypes.string,

  /**
   * Array of options.
   */
  options: PropTypes.array.isRequired,

  /**
   * The component used to render the body of the popup.
   */
  PaperComponent: PropTypes.elementType,

  /**
   * The component used to position the popup.
   */
  PopperComponent: PropTypes.elementType,

  /**
   * The icon to display in place of the default popup icon.
   */
  popupIcon: PropTypes.node,

  /**
   * Render the group.
   *
   * @param {any} option The group to render.
   * @returns {ReactNode}
   */
  renderGroup: PropTypes.func,

  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: PropTypes.func.isRequired,

  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {T} option The option to render.
   * @param {object} state The state of the component.
   * @returns {ReactNode}
   */
  renderOption: PropTypes.func,

  /**
   * Render the selected value.
   *
   * @param {T[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @returns {ReactNode}
   */
  renderTags: PropTypes.func,

  /**
   * If `true`, the input's text will be selected on focus.
   * It helps the user clear the selected value.
   */
  selectOnFocus: PropTypes.bool,

  /**
   * The size of the autocomplete.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `getOptionSelected` prop.
   */
  value: PropTypes.any
} : void 0;
var Autocomplete$1 = styles$6.withStyles(styles$4, {
  name: 'MuiAutocomplete'
})(Autocomplete);

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return !isNaN(date);
}

var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance$1(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$1[token] === 'string') {
    result = formatDistanceLocale$1[token];
  } else if (count === 1) {
    result = formatDistanceLocale$1[token].one;
  } else {
    result = formatDistanceLocale$1[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats$1 = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$1 = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative$1(token, _date, _baseDate, _options) {
  return formatRelativeLocale$1[token];
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challange you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues$1 = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues$1 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$1 = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues$1 = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber$1(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize$1 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

var matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns$1 = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns$1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale$1 = {
  code: 'en-US',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$1 = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters$1.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters$1.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters$1.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters$1.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters$1.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters$1.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters$1.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return formatters$1.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || locale$1;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

var useStyles$s = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    maintenance: {
      marginTop: 24,
      marginBottom: 24,
      position: "relative"
    },
    snackContent: {
      boxShadow: "2px 3px 13px -2px #C2C2C2",
      borderRadius: 12,
      background: "white",
      color: theme.palette.secondary.dark,
      padding: "0 24px 0 12px ",
      "& p": {
        margin: 0,
        fontWeight: "normal",
        fontSize: 15
      },
      "& h3": {
        fontSize: 18,
        fontFamily: "'Poppins', 'sans-serif'",
        margin: 0
      }
    },
    message: {
      display: "flex",
      alignItems: "center"
    },
    border: {
      marginRight: 12,
      background: theme.palette.secondary.main,
      height: "100%",
      borderRadius: 12,
      width: 6
    },
    messageTexte: {
      padding: "8px 0",
      paddingLeft: 8
    },
    illu: {
      position: "absolute",
      right: "-44px",
      top: "-25px",
      transform: "rotate(6deg)"
    }
  });
});

function BlocMaintenance(props) {
  var dateDebutMsgMaintenance = props.dateDebutMsgMaintenance,
      dateFinMsgMaintenance = props.dateFinMsgMaintenance,
      msgMaintenanceFr = props.msgMaintenanceFr;
  var classes = useStyles$s();
  var showMaintenance = (isAfter(new Date(), new Date(dateDebutMsgMaintenance)) || isEqual(new Date(), new Date(dateDebutMsgMaintenance))) && (isBefore(new Date(), new Date(dateFinMsgMaintenance)) || isEqual(new Date(), new Date(dateFinMsgMaintenance)));

  if (showMaintenance) {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: classes.maintenance
    }, /*#__PURE__*/React__default['default'].createElement(Alert$1, {
      severity: "error",
      icon: false,
      className: classes.snackContent,
      classes: {
        message: classes.message
      }
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      "data-testid": "colorSnack",
      className: classes.border
    }), /*#__PURE__*/React__default['default'].createElement("div", {
      className: classes.messageTexte,
      dangerouslySetInnerHTML: {
        __html: msgMaintenanceFr
      }
    })));
  }

  return null;
}

var useStyles$r = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    tag: {
      borderColor: theme.palette.secondary.dark,
      color: theme.palette.secondary.dark,
      height: "auto",
      marginRight: 8,
      marginBottom: 8,
      "& svg": {
        color: theme.palette.secondary.dark,
        cursor: "pointer"
      },
      "&:hover": {
        background: "transparent",
        color: theme.palette.secondary.main,
        borderColor: theme.palette.secondary.main,
        "& svg": {
          color: theme.palette.secondary.main
        }
      }
    },
    whiteTag: {
      borderColor: "white",
      color: "white",
      textOverflow: "ellipsis",
      maxWidth: 252,
      marginTop: 4,
      "& svg": {
        color: "white"
      }
    },
    deleteIcon: {
      marginRight: "8px !important",
      width: 14
    },
    label: {
      paddingRight: 8,
      fontSize: 12
    }
  });
});

function Tag(props) {
  var type = props.type,
      value = props.value,
      onDelete = props.onDelete,
      id = props.id,
      whiteTag = props.whiteTag;
  var classes = useStyles$r();

  var handleDelete = function handleDelete() {
    onDelete && onDelete(type, id);
  };

  var typeLabel = type && type.charAt(0).toUpperCase() + type.slice(1) + " :";

  if (type === "etatAdhesion") {
    typeLabel = "Statut :";
  }

  if (type === "categorieVehicule") {
    typeLabel = "Catégorie :";
  }

  if (type === "numeroAdhesion") {
    typeLabel = "N° client :";
  }

  if (type === "Dates") {
    typeLabel = "Date d’enregistrement :";
  }

  if (type === "client") {
    typeLabel = "Site vendeur :";
  }

  if (type === "numeroSerie") {
    typeLabel = "N° de série :";
  }

  if (type === "numeroFidelite") {
    typeLabel = "N° de fidélité :";
  }

  var tagClassName = classes.tag;
  if (whiteTag) tagClassName += " " + classes.whiteTag;
  return /*#__PURE__*/React__default['default'].createElement(core.Chip, {
    classes: {
      root: tagClassName,
      deleteIcon: classes.deleteIcon,
      label: classes.label
    },
    variant: "outlined",
    label: typeLabel + " " + value,
    onDelete: handleDelete,
    deleteIcon: /*#__PURE__*/React__default['default'].createElement(Close$1, {
      fontSize: "small"
    })
  });
}

var useStyles$q = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    containerTags: {
      marginBottom: 24
    },
    deleteAllBtn: {
      marginLeft: 12,
      marginBottom: 8
    }
  });
});

function BlocTags(props) {
  var tagsList = props.tagsList,
      onDelete = props.onDelete,
      onDeleteAll = props.onDeleteAll,
      whiteTag = props.whiteTag;
  var classes = useStyles$q();
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.containerTags
  }, tagsList && tagsList.map(function (tag) {
    if (tag) {
      if (Array.isArray(tag.value)) {
        if (tag.type === "etatAdhesion") {
          return tag.value.map(function (f) {
            return /*#__PURE__*/React__default['default'].createElement(Tag, {
              onDelete: onDelete,
              type: tag.type,
              value: getNameStatut(f),
              id: f
            });
          });
        }

        if (tag.type === "categorieVehicule") {
          return tag.value.map(function (f) {
            return /*#__PURE__*/React__default['default'].createElement(Tag, {
              onDelete: onDelete,
              type: tag.type,
              value: getNameCategorie(f),
              id: f
            });
          });
        } else if (tag.type === "client") {
          return tag.value.map(function (f) {
            return /*#__PURE__*/React__default['default'].createElement(Tag, {
              onDelete: onDelete,
              type: tag.type,
              value: f.value,
              id: f.value
            });
          });
        }
      } else return /*#__PURE__*/React__default['default'].createElement(Tag, {
        onDelete: onDelete,
        type: tag.type,
        id: tag.value,
        value: tag.value,
        whiteTag: whiteTag
      });
    }
  }), tagsList && (tagsList.length > 1 || tagsList.find(function (tag) {
    return tag && Array.isArray(tag.value) && tag.value.length > 1;
  })) && /*#__PURE__*/React__default['default'].createElement(Button, {
    className: classes.deleteAllBtn,
    variant: "text",
    color: "secondary",
    title: "Supprimer tous les filtres",
    onClick: onDeleteAll
  }));
}

function Fleche(props) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: props.width ? props.width + 'px' : '20px',
    height: "18px",
    viewBox: "0 0 20 18",
    version: "1.1"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "Fleche"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "BOARD-3---Ic\xF4nes",
    transform: "translate(-971.000000, -538.000000)",
    fill: "#1B202D"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Pictogrammes",
    transform: "translate(305.000000, 178.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "26---Fl\xE8che",
    transform: "translate(666.000000, 355.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19.1666667,13.1001207 L2.54208333,13.1001207 L8.90791667,6.55180048 C9.24125,6.20890466 9.25416667,5.6392116 8.93666667,5.27921599 C8.61958333,4.91967037 8.09208333,4.90527054 7.75833333,5.24816637 L0.488333333,12.7270752 C0.17375,13.0672711 0,13.5190656 0,14.0001097 C0,14.4807038 0.17375,14.9329483 0.502916667,15.287994 L7.75875,22.751603 C7.92,22.917651 8.12666667,23 8.33333333,23 C8.55333333,23 8.77333333,22.9064011 8.93708333,22.7205534 C9.25458333,22.3605578 9.24166667,21.7913147 8.90833333,21.4484189 L2.51583333,14.9000987 L19.1666667,14.9000987 C19.6266667,14.9000987 20,14.4969036 20,14.0001097 C20,13.5033157 19.6266667,13.1001207 19.1666667,13.1001207",
    id: "Fill-1"
  })))));
}

var useStyles$p = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    blocTextes: {
      border: "0.5px solid #d0d0d0",
      borderRadius: 12,
      padding: "12px 16px",
      marginBottom: 16,
      "& h4": {
        marginBottom: 4
      }
    },
    contentTexte: {
      color: "#000",
      display: "flex",
      fontSize: 14
    },
    title: {
      width: 130,
      minWidth: 130,
      color: theme.palette.primary.dark,
      fontSize: 13,
      paddingRight: 8
    },
    titleNoValue: {
      color: theme.palette.primary.dark,
      fontSize: 13
    },
    blocSmall: {
      height: "fit-content"
    },
    blocMedium: {
      height: "fit-content"
    },
    redTitle: {
      fontSize: 14,
      color: theme.palette.secondary.main
    },
    showMore: {
      display: "flex",
      justifyContent: "flex-end"
    },
    buttonShowMore: {
      "& svg": {
        transform: "rotate(180deg)"
      }
    }
  });
});

function BlocTextes(props) {
  var title = props.title,
      content = props.content,
      size = props.size,
      red = props.red,
      linkShowMore = props.linkShowMore,
      linkTexte = props.linkTexte;
  var classes = useStyles$p();
  var className = classes.blocTextes;

  if (size === "s") {
    className += " " + classes.blocSmall;
  } else if (size === "m") {
    className += " " + classes.blocMedium;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: className,
    "data-testid": "blocTextes"
  }, /*#__PURE__*/React__default['default'].createElement(core.Typography, {
    variant: "h4",
    className: red ? classes.redTitle : ""
  }, title), content && content.map(function (c, i) {
    var breakLine = false;

    if (c.option && c.option === "breakLine") {
      breakLine = true;
    }

    if (c.title) {
      return /*#__PURE__*/React__default['default'].createElement("div", {
        key: c.title + i
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        className: classes.contentTexte
      }, /*#__PURE__*/React__default['default'].createElement("span", {
        className: c.noValue ? classes.titleNoValue : classes.title,
        "data-testid": "value"
      }, c.title), c.value && !c.noValue && /*#__PURE__*/React__default['default'].createElement("p", {
        dangerouslySetInnerHTML: {
          __html: c.value
        }
      }), !c.value && !c.noValue && "-"), breakLine && /*#__PURE__*/React__default['default'].createElement("br", null));
    } else return /*#__PURE__*/React__default['default'].createElement("div", {
      key: i
    });
  }), linkTexte && linkShowMore && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.showMore
  }, /*#__PURE__*/React__default['default'].createElement(Button, {
    variant: "text",
    color: "primary",
    icon: /*#__PURE__*/React__default['default'].createElement(Fleche, {
      width: 14
    }),
    onClick: linkShowMore,
    title: linkTexte,
    className: classes.buttonShowMore
  })));
}

var useStyles$o = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    boxProduit: {
      display: "flex",
      background: "white",
      borderRadius: 12,
      margin: 24,
      marginTop: 8,
      padding: 16,
      width: "calc(100% - 80px)"
    },
    marginBox: {
      marginTop: 24
    },
    columnDetail: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      "& > div": {
        display: "flex",
        padding: "4px 8px",
        "& > span": {
          fontWeight: 600,
          fontSize: 14,
          wordBreak: "break-word"
        },
        "& > span:first-of-type": {
          color: theme.palette.primary.dark,
          width: "45%",
          paddingRight: 4,
          minWidth: 100,
          fontWeight: 600,
          fontSize: 14
        }
      }
    }
  });
});

function BoxCollapsed(props) {
  var children = props.children,
      withMargin = props.withMargin;
  var classes = useStyles$o();
  var className = classes.boxProduit;

  if (withMargin) {
    className += " " + classes.marginBox;
  }

  return /*#__PURE__*/React__default['default'].createElement(core.Box, {
    margin: 1,
    className: className,
    "data-testid": "box-collapsed"
  }, children);
}

function BoxColumns(props) {
  var children = props.children;
  var classes = useStyles$o();
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.columnDetail
  }, children);
}

var useStyles$n = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    card: {
      padding: 24,
      background: "white",
      boxShadow: "2px 3px 13px -2px #C2C2C2",
      borderRadius: 12,
      //minWidth: '50%',
      "& h4": {
        margin: 0,
        marginBottom: 24
      },
      "& h3": {
        marginBottom: 8,
        color: theme.palette.secondary.dark
      },
      position: "relative"
    },
    cardRed: {
      background: 'linear-gradient(62deg, ' + theme.palette.secondary.light + ' 1%, ' + theme.palette.secondary.main + ' 98%)',
      "& h3, & h2": {
        color: "white"
      }
    }
  });
});

function Card(props) {
  var children = props.children,
      className = props.className,
      red = props.red;
  var classes = useStyles$n();
  var classNameCard = classes.card;

  if (className) {
    classNameCard += " " + className;
  }

  if (red) {
    classNameCard += " " + classes.cardRed;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNameCard,
    "data-testid": "card"
  }, children);
}

var useStyles$m = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    header: {
      height: 50,
      background: "#FFF",
      borderRadius: "0 0 26px 26px",
      boxShadow: "0 1px 5px 3px rgba(224,224,224,0.5)",
      padding: "12px 48px",
      position: "fixed",
      width: "calc(100% - 96px)",
      zIndex: 10,
      top: 0,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    logo: {
      width: "25%"
    },
    inputRoot: {
      width: "100%",
      background: theme.palette.primary.light,
      borderRadius: 12,
      padding: "7px 18px"
    },
    buttonsHeader: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      "& > button": {
        marginLeft: 16
      }
    }
  });
});

function Header(props) {
  var hideConnectionBtn = props.hideConnectionBtn,
      lienAccueil = props.lienAccueil,
      inscriptionBtn = props.inscriptionBtn,
      lienInscription = props.lienInscription,
      activeContactLink = props.activeContactLink,
      contactLink = props.contactLink;
  var classes = useStyles$m();
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.header
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: "/",
    className: classes.logo,
    title: "Accueil"
  }, " ", /*#__PURE__*/React__default['default'].createElement("img", {
    src: img,
    alt: "Saga",
    width: 90
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.buttonsHeader
  }, contactLink && /*#__PURE__*/React__default['default'].createElement(LinkButton$1, {
    key: "contact",
    active: activeContactLink,
    ariaLabel: "Contact",
    icon: /*#__PURE__*/React__default['default'].createElement(Fidelite, null),
    noTitle: true,
    onClick: contactLink
  }), inscriptionBtn && lienInscription && /*#__PURE__*/React__default['default'].createElement(Button, {
    title: "Créer mon compte",
    variant: "contained",
    onClick: lienInscription,
    color: "default"
  }), !hideConnectionBtn && /*#__PURE__*/React__default['default'].createElement(Button, {
    title: "Se connecter",
    variant: "contained",
    onClick: lienAccueil,
    color: "primary"
  })));
}

var useStyles$l = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    footer: {
      height: 15,
      background: "#FFF",
      borderRadius: " 26px 26px 0 0",
      boxShadow: "0 -1px 2px 3px rgba(224,224,224,0.5)",
      padding: "12px",
      position: "fixed",
      width: "calc(100% - 24px)",
      zIndex: 10,
      left: 0,
      bottom: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "& a": {
        fontSize: 12,
        color: theme.palette.primary.dark,
        textDecoration: "none",
        "&:hover, &:focus, &:active": {
          color: theme.palette.secondary.dark,
          textDecoration: "underline"
        }
      },
      "& div": {
        margin: "0 12px",
        height: "100%",
        width: 1,
        background: theme.palette.primary.dark
      }
    }
  });
});

function Footer(props) {
  var classes = useStyles$l();
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React__default['default'].createElement("a", {
    href: "/mentions-legales"
  }, "Mentions l\xE9gales"), /*#__PURE__*/React__default['default'].createElement("div", null), /*#__PURE__*/React__default['default'].createElement("a", {
    href: "/donnees-personnelles"
  }, "Donn\xE9es personnelles"));
}

function Important(props) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: props.className,
    width: props.width ? props.width + 'px' : '21px',
    height: "20px",
    viewBox: "0 0 27 26",
    version: "1.1"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "Important"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "-Styleguides",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "BOARD-3---Ic\xF4nes",
    transform: "translate(-310.000000, -185.000000)",
    fill: "#1B202D"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Pictogrammes",
    transform: "translate(305.000000, 181.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "1---Important",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M13.4751517,4 L13.7037488,4.00537197 C15.3712401,4.08395209 16.8364213,5.02002606 17.6517237,6.51054384 L17.6517237,6.51054384 L26.4026366,22.8146504 C27.2265861,24.3440622 27.1981741,26.1331853 26.3174004,27.6337403 C25.4650387,29.1054384 23.9307878,30 22.2260645,30 L22.2260645,30 L4.75265093,30 C3.04792765,30 1.5136767,29.1054384 0.661315064,27.6337403 C-0.191046574,26.1331853 -0.219458629,24.3440622 0.576078901,22.8435072 L0.576078901,22.8435072 L9.29857967,6.53940067 C10.1509413,4.95227525 11.7136043,4 13.4751517,4 L13.4751517,4 Z M13.4751517,6.22197558 L13.2888612,6.22848226 C12.4256735,6.28905167 11.6548861,6.77025527 11.2305994,7.57824639 L11.2305994,7.57824639 L2.53651067,23.9112098 C2.11032985,24.7192009 2.1387419,25.6714761 2.59333478,26.4794673 C3.04792765,27.2874584 3.87187724,27.7491676 4.78106298,27.7491676 L4.78106298,27.7491676 L22.2260645,27.7491676 C23.1636623,27.7491676 23.9876119,27.2874584 24.4422048,26.4794673 C24.8967977,25.6714761 24.9252097,24.7192009 24.4706168,23.8823529 L24.4706168,23.8823529 L15.719704,7.57824639 C15.2651111,6.74139845 14.4411616,6.22197558 13.4751517,6.22197558 L13.4751517,6.22197558 Z M13.4751517,21.6603774 C14.4695736,21.6603774 15.2366991,22.4395117 15.2366991,23.4495006 C15.2366991,24.4306326 14.4411616,25.2386238 13.4751517,25.2386238 C12.5091418,25.2386238 11.7136043,24.4306326 11.7136043,23.4495006 C11.7136043,22.4683685 12.5091418,21.6603774 13.4751517,21.6603774 Z M13.4751517,10.9833518 C14.4127495,10.9833518 15.208287,11.7624861 15.208287,12.7436182 L15.208287,12.7436182 L15.208287,12.9744728 L14.3559254,20.3041065 C14.1002169,20.2463929 13.7876843,20.1886792 13.5035638,20.1886792 C13.2194432,20.1886792 12.9353227,20.2175361 12.6796142,20.3041065 L12.6796142,20.3041065 L11.7420164,12.9744728 C11.6851923,12.4839068 11.8272525,11.9933407 12.1681972,11.5893452 C12.5091418,11.2142064 12.9921468,10.9833518 13.4751517,10.9833518 Z",
    id: "Combined-Shape"
  }))))));
}

function Information() {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: "14px",
    height: "30px",
    viewBox: "0 0 14 30",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "Information"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "BOARD-3---Icones",
    transform: "translate(-315.000000, -230.000000)",
    fill: "#1B202D"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Pictogrammes",
    transform: "translate(305.000000, 181.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "2---Information",
    transform: "translate(10.000000, 49.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M6.62926721,9.375 C8.28237699,9.375 9.59606893,9.79479634 10.5330898,10.6230848 C11.4954636,11.4744955 11.9833768,12.5894993 11.9833768,13.9367526 C11.9833768,14.1988042 11.9554369,14.6237388 11.8964527,15.2362201 C11.8374685,15.867713 11.7251915,16.4601551 11.5632437,16.9971039 L11.5632437,16.9971039 L10.0503507,22.3146954 C9.93289975,22.7221599 9.82631427,23.1892283 9.73473354,23.7051102 C9.64470502,24.2086603 9.59865596,24.5827261 9.59865596,24.8165172 C9.59865596,25.3293161 9.7011022,25.593423 9.78906109,25.6643311 C9.85114972,25.7136584 10.1207179,25.8775691 10.9589144,25.8775691 C11.2548702,25.8775691 11.6072231,25.8220759 12.0045904,25.7126308 C12.5313089,25.5677317 12.779146,25.4731876 12.8934926,25.4202635 C13.1604737,25.2943759 13.4828172,25.3339406 13.7146147,25.519432 C13.9448601,25.7074925 14.0483411,26.0132194 13.9784914,26.2999346 L13.9784914,26.2999346 L13.5733631,27.9467489 C13.5133441,28.1903027 13.3379437,28.3896674 13.1030417,28.4811286 C11.8705824,28.9630979 10.8802688,29.3335669 10.1600407,29.5817451 C9.35599289,29.8592115 8.4205242,30 7.37898742,30 C5.71604694,30 4.38631545,29.5750654 3.42704611,28.7365004 C2.43828467,27.8732717 1.93691898,26.7634062 1.93691898,25.4382474 C1.93691898,24.9763173 1.97003292,24.5005138 2.03574339,24.0236827 C2.10093645,23.5535314 2.2049349,23.0201794 2.34515173,22.4385277 L2.34515173,22.4385277 L3.87563646,17.0603046 C4.00498778,16.5696001 4.11622991,16.0979073 4.20367139,15.6626962 C4.28542142,15.2552317 4.32733125,14.8842489 4.32733125,14.5595105 C4.32733125,14.0461977 4.22747203,13.7692451 4.14210017,13.6880605 L4.14210017,13.6880605 L4.12742426,13.676711 C4.06808362,13.6355954 3.81365131,13.4989723 3.05089249,13.4989723 C2.73372307,13.4989723 2.40051409,13.5498412 2.06057884,13.6500374 C1.66165939,13.7677037 1.32120673,13.879204 1.04905157,13.9809417 C0.778448625,14.0816517 0.475249148,14.0256446 0.260525968,13.8350149 C0.0452853832,13.6448991 -0.0462953464,13.3540732 0.0225195521,13.0755792 L0.0225195521,13.0755792 L0.428682675,11.4272235 C0.487666874,11.1882941 0.659962822,10.989957 0.889690754,10.8969544 C1.898631,10.4889761 2.88118357,10.1339219 3.80940859,9.84104073 C4.79247857,9.53171712 5.7413998,9.375 6.62926721,9.375 Z M6.62926721,10.9164798 C5.90127802,10.9164798 5.11016539,11.0490471 4.27817775,11.310071 C3.61952086,11.5181708 2.92930226,11.7601831 2.21942225,12.0314836 C2.50244292,11.9821562 2.77925473,11.9574925 3.05089249,11.9574925 C4.06811122,11.9574925 4.7754042,12.1589126 5.21312904,12.572543 C5.66171939,12.9979914 5.879547,13.6479821 5.879547,14.5595105 C5.879547,14.9844451 5.82780648,15.4576794 5.72587764,15.9648262 C5.6327447,16.4272702 5.5142589,16.9323617 5.37300726,17.4657138 L5.37300726,17.4657138 L3.84666177,22.8274944 C3.72455413,23.3392657 3.63142118,23.815583 3.5739892,24.233324 C3.51759203,24.6397608 3.48913474,25.04517 3.48913474,25.4382474 C3.48913474,26.3132941 3.80423454,27.0131259 4.45202591,27.578849 C5.11947869,28.1625561 6.10461829,28.4585202 7.37898742,28.4585202 C8.24564122,28.4585202 9.00984878,28.346506 9.65091389,28.1255605 C10.1983286,27.9364723 10.9087261,27.6749346 11.766584,27.3450579 C11.479424,27.3943853 11.2098559,27.419049 10.9589144,27.419049 C9.98050103,27.419049 9.27889951,27.2366405 8.81271738,26.8625747 C8.29686434,26.4484305 8.0464402,25.7789144 8.0464402,24.8165172 C8.0464402,24.488182 8.09869813,24.0370422 8.20683583,23.4358651 C8.30824726,22.8655176 8.42621565,22.3460389 8.55763659,21.89233 L8.55763659,21.89233 L10.0731166,16.5660034 C10.2081593,16.119488 10.3007749,15.6251868 10.3509632,15.0923487 C10.4047733,14.5327915 10.431161,14.1443386 10.431161,13.9367526 C10.431161,13.0355007 10.1274441,12.3284753 9.50086636,11.7740564 C8.85669682,11.2047365 7.89070122,10.9164798 6.62926721,10.9164798 Z M10.0082309,0 C11.0947146,0 12.0382151,0.366092526 12.8133341,1.0875513 C13.6011523,1.82113543 14,2.71981097 14,3.75839448 C14,4.79837707 13.6002117,5.69518717 12.8114528,6.42317498 C12.0363337,7.13763835 11.0933035,7.5 10.0082309,7.5 C8.92362867,7.5 7.97871715,7.13857107 7.19936504,6.42504042 C6.40355106,5.69751897 6,4.80024251 6,3.75839448 C6,2.71747917 6.40261038,1.81833727 7.19748369,1.0852195 C7.97683579,0.365159806 8.92268799,0 10.0082309,0 Z M10.0082309,1.39907972 C9.28108648,1.39907972 8.67623023,1.63132695 8.15885708,2.10934585 C7.6555941,2.57384032 7.4110177,3.11295237 7.4110177,3.75839448 C7.4110177,4.40243751 7.65465342,4.9387514 8.15603504,5.39671683 C8.6734082,5.87053849 9.27920513,6.10092028 10.0082309,6.10092028 C10.7353754,6.10092028 11.3378799,5.87147121 11.8500794,5.39904863 C12.3476983,4.93968412 12.5889823,4.40290387 12.5889823,3.75839448 C12.5889823,3.11201965 12.3467576,2.57197488 11.8472573,2.10748041 C11.3355282,1.63086059 10.7339644,1.39907972 10.0082309,1.39907972 Z",
    id: "icon"
  })))));
}

var useStyles$k = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    popperTooltip: {
      background: theme.palette.secondary.dark,
      fontSize: "13px",
      textAlign: "center"
    },
    higherTooltip: {
      background: theme.palette.secondary.dark,
      fontSize: "13px",
      textAlign: "left",
      maxWidth: 400,
      "& p": {
        color: "white"
      }
    },
    infoBulle: {
      marginTop: 36,
      marginLeft: 8,
      borderRadius: "100%",
      minWidth: 28,
      width: 28,
      height: 28,
      border: "1px solid " + theme.palette.primary.dark,
      transition: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& span": {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: 0
      },
      "& svg": {
        paddingBottom: 0,
        "& g": {
          fill: theme.palette.primary.dark
        },
        height: 17
      },
      "&:hover": {
        borderColor: theme.palette.secondary.main,
        "& svg": {
          "& g": {
            fill: theme.palette.secondary.main
          }
        }
      }
    },
    infoBulleHigh: {
      border: "none",
      background: theme.palette.secondary.main,
      marginTop: 0,
      marginRight: 8,
      marginLeft: 0,
      "& svg": {
        "& g": {
          fill: "white"
        },
        height: 17
      },
      "&:hover": {
        "& svg": {
          "& g": {
            fill: "white"
          }
        }
      }
    },
    containerInfoBulleHigh: {
      display: "flex",
      alignItems: "center",
      fontWeight: "bold",
      width: "fit-content"
    },
    smallInfo: {
      "& > div": {
        marginLeft: 0,
        marginRight: 8,
        marginTop: 0,
        height: 20,
        minWidth: 20,
        borderColor: theme.palette.secondary.main,
        width: 20,
        "& svg": {
          height: 12,
          "& g": {
            fill: theme.palette.secondary.main
          }
        }
      }
    }
  });
});

function InfoBulle(props) {
  var type = props.type,
      textTooltip = props.textTooltip,
      label = props.label,
      onClick = props.onClick,
      level = props.level;
  var classes = useStyles$k();
  var icon = /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.infoBulle
  }, /*#__PURE__*/React__default['default'].createElement("span", null, /*#__PURE__*/React__default['default'].createElement(Information, null)));

  if (level === "high") {
    icon = /*#__PURE__*/React__default['default'].createElement("div", {
      className: classes.containerInfoBulleHigh
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: classes.infoBulle + " " + classes.infoBulleHigh
    }, /*#__PURE__*/React__default['default'].createElement("span", null, /*#__PURE__*/React__default['default'].createElement(Important, null))), "Important");
  }

  if (type === "tooltip" && textTooltip) {
    return /*#__PURE__*/React__default['default'].createElement(core.Tooltip, {
      title: textTooltip,
      placement: "top",
      classes: {
        tooltip: level === "high" ? classes.higherTooltip : classes.popperTooltip
      }
    }, icon);
  } else if (type === "modale" && onClick) {
    return /*#__PURE__*/React__default['default'].createElement(Button, {
      icon: /*#__PURE__*/React__default['default'].createElement(Information, null),
      className: classes.infoBulle,
      onClick: onClick,
      variant: "text",
      color: "secondary",
      ariaLabel: label
    });
  } else {
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: classes.smallInfo
    }, icon);
  }
}

var grisMoyen = "#a1a1a1";
var primaryBlack = "#1b202d";
var gradientGris = "linear-gradient(43deg, #f7f6f6 11%, #d4d5d7 99%)";

var useStyles$j = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    link: {
      color: theme.palette.secondary.main,
      textTransform: "initial",
      fontWeight: 500,
      padding: 0,
      fontSize: 13,
      display: "flex",
      marginBottom: 12,
      "&:hover": {
        background: "transparent",
        fontWeight: "bold"
      },
      "& .MuiTouchRipple-root": {
        display: "none"
      }
    },
    white: {
      color: "white"
    },
    icon: {
      width: 34,
      height: 34,
      background: 'linear-gradient(62deg, ' + theme.palette.secondary.light + ' 1%, ' + theme.palette.secondary.main + ' 98%)',
      boxShadow: "0 2px 13px 1px rgba(211,211,211, 0.2)",
      borderRadius: 12,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginRight: 12,
      "& svg": {
        "&  > g": {
          fill: "white"
        }
      }
    },
    whiteIcon: {
      background: gradientGris,
      "& svg": {
        "&  > g": {
          fill: theme.palette.secondary.main
        }
      }
    }
  });
});

function LinkButton(props) {
  var color = props.color,
      title = props.title,
      onClick = props.onClick,
      disabled = props.disabled,
      fetching = props.fetching,
      icon = props.icon,
      ariaLabel = props.ariaLabel;
  var classes = useStyles$j();
  var classNameLink = classes.link;
  var classNameIcon = classes.icon;

  if (color === "secondary") {
    classNameLink += " " + classes.white;
    classNameIcon += " " + classes.whiteIcon;
  }

  var propsButton = {
    ariaLabel: ariaLabel || title,
    disabled: disabled,
    color: color || "primary",
    onClick: onClick,
    className: classNameLink,
    underline: "none"
  };
  return fetching ? /*#__PURE__*/React__default['default'].createElement(LoadingIcon, {
    size: "small"
  }) : /*#__PURE__*/React__default['default'].createElement(core.Button, __assign({}, propsButton), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNameIcon
  }, icon), title);
}

var styleSquare = {
  width: 6,
  height: 6,
  background: "white",
  right: "-24px",
  transition: "all 0.1s ease"
};
var useStyles$i = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    container: {
      position: "relative",
      "& $bordUp, $bordDown,  $squareUp,  $squareDown": {
        opacity: 0
      }
    },
    activeContainer: {
      "& $bordUp, $bordDown,  $squareUp,  $squareDown": {
        opacity: 1
      }
    },
    list: {
      zIndex: 3,
      padding: 2,
      background: theme.palette.primary.light,
      borderRadius: 12,
      display: "flex",
      width: "calc(100% - 6px)",
      fontFamily: "Mulish",
      textAlign: "left",
      alignItems: "inherit",
      cursor: "pointer",
      border: "1px solid " + theme.palette.primary.light,
      marginBottom: 8,
      transition: "all 0.1s ease",
      "& p": {
        lineHeight: "16px",
        fontWeight: 600,
        flex: 1,
        width: 195,
        textOverflow: "ellipsis",
        overflow: "hidden"
      },
      "&:hover, &:focus, &:active": {
        borderColor: theme.palette.secondary.main,
        outline: "none"
      }
    },
    activeList: {
      width: 276,
      borderRadius: "12px 0 0 12px",
      borderColor: theme.palette.primary.light,
      "&:hover, &:focus, &:active": {
        borderColor: theme.palette.primary.light,
        outline: "none"
      }
    },
    texte: {
      padding: "8px 0"
    },
    border: {
      marginRight: 12,
      width: 12,
      borderRadius: "12px 0 0 12px"
    },
    redList: {
      background: theme.palette.secondary.main
    },
    blackList: {
      background: theme.palette.secondary.dark
    },
    greyList: {
      background: theme.palette.primary.dark
    },
    popperTooltip: {
      background: theme.palette.secondary.dark,
      fontSize: "13px"
    },
    arrowTooltip: {
      color: theme.palette.secondary.dark
    },
    subtitle: {
      fontSize: 13,
      color: theme.palette.primary.dark
    },
    bordUp: {
      width: 12,
      height: 12,
      background: theme.palette.secondary.dark,
      borderRadius: "100%",
      right: "-24px",
      zIndex: 2,
      transition: "all 0.1s ease",
      position: "absolute",
      top: -12
    },
    bordDown: {
      width: 12,
      height: 12,
      background: theme.palette.secondary.dark,
      borderRadius: "100%",
      right: "-24px",
      zIndex: 2,
      transition: "all 0.1s ease",
      position: "absolute",
      bottom: -12
    },
    squareUp: __assign(__assign({}, styleSquare), {
      top: -6,
      position: "absolute"
    }),
    squareDown: __assign(__assign({}, styleSquare), {
      position: "absolute",
      bottom: -6
    }),
    inactiveList: {
      "& p": {
        fontStyle: "italic",
        color: "#666"
      }
    },
    etat: {
      fontSize: 12,
      color: theme.palette.primary.dark
    }
  });
});

function ListCard(props) {
  var title = props.title,
      borderColor = props.borderColor,
      tooltip = props.tooltip,
      id = props.id,
      activeItem = props.activeItem,
      _onClick = props.onClick;
      props.role;
      var etat = props.etat,
      inactive = props.inactive,
      subtitle = props.subtitle;
  var classes = useStyles$i();
  var borderClassName = classes.border;

  if (borderColor === "red") {
    borderClassName += " " + classes.redList;
  } else if (borderColor === "black") {
    borderClassName += " " + classes.blackList;
  } else {
    borderClassName += " " + classes.greyList;
  }

  var classList = classes.list;
  var classContainer = classes.container;

  if (activeItem === id) {
    classList += " " + classes.activeList;
    classContainer += " " + classes.activeContainer;
  }

  if (inactive) {
    classList += " " + classes.inactiveList;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classContainer
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.bordUp
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.squareUp
  }), /*#__PURE__*/React__default['default'].createElement("button", {
    className: classList,
    "data-testid": "card",
    onClick: function onClick() {
      return id && _onClick() || {};
    }
  }, tooltip ? /*#__PURE__*/React__default['default'].createElement(core.Tooltip, {
    arrow: true,
    placement: "right",
    title: tooltip || " ",
    classes: {
      tooltip: classes.popperTooltip,
      arrow: classes.arrowTooltip
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: borderClassName,
    "data-testid": "border"
  })) : /*#__PURE__*/React__default['default'].createElement("div", {
    className: borderClassName,
    "data-testid": "border"
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.texte
  }, /*#__PURE__*/React__default['default'].createElement(core.Typography, {
    variant: "body1"
  }, title), subtitle && /*#__PURE__*/React__default['default'].createElement("span", {
    className: classes.subtitle
  }, subtitle), etat && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("span", {
    className: classes.etat
  }, etat)))), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.bordDown
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.squareDown
  }));
}

var useStyles$h = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    formControl: {
      width: 310,
      paddingRight: 12,
      position: "relative",
      display: "flex",
      "& .MuiOutlinedInput-input": {
        paddingRight: "32px"
      },
      "&:hover": {
        "& $clearIcon": {
          opacity: "1"
        }
      },
      "& .MuiInputAdornment-root": {
        "& > button": {
          "&:hover": {
            background: "none",
            "& svg": {
              "& g": {
                fill: theme.palette.secondary.main
              }
            }
          }
        }
      }
    },
    disabled: {
      color: "rgba(0,0,0,0.7)",
      "& .MuiInputAdornment-root": {
        "& > button": {
          "& svg": {
            "& g": {
              fill: "rgba(0, 0, 0, 0.38)"
            }
          }
        }
      }
    },
    disabledInput: {
      color: "rgba(0,0,0,0.7)"
    },
    input: {
      borderRadius: 4,
      padding: "3px 0 3px 12px",
      fontSize: 12,
      color: "black",
      border: "0.2px solid rgba(92,92,92,0.3)",
      background: theme.palette.primary.light,
      "&:before, &:after": {
        borderBottom: "none !important"
      },
      "&:hover": {
        "&:before": {
          borderBottom: "none !important"
        },
        "& $clearIcon": {
          opacity: "1"
        }
      } // '& input': {
      //   width: 'auto',
      //   flex: 1,
      // },

    },
    focused: {
      borderColor: "#5C5C5C"
    },
    label: {
      fontSize: 13,
      transform: "scale(1)",
      color: "black",
      lineHeight: 1.3
    },
    disabledLabel: {
      color: "rgba(0, 0, 0, 0.38)"
    },
    errorLabel: {
      color: theme.palette.secondary.dark + " !important"
    },
    errorInput: {
      borderColor: theme.palette.text.hint,
      "& input": {
        borderColor: theme.palette.text.hint
      }
    },
    showError: {
      color: theme.palette.text.hint,
      fontSize: 13,
      fontWeight: "bold"
    },
    showErrorInline: {
      color: theme.palette.text.hint,
      marginLeft: 175,
      fontSize: 13,
      fontWeight: "bold"
    },
    messageError: {
      color: theme.palette.text.hint,
      fontSize: 12,
      marginTop: -4,
      width: 318,
      lineHeight: "1.4em",
      "& p": {
        fontSize: "12px !important",
        textAlign: "left",
        margin: 0
      }
    },
    inputAutoComplete: {
      paddingTop: "3.5px !important",
      paddingBottom: "3.5px !important"
    },
    popupIcon: {
      paddingRight: 12,
      paddingLeft: 12,
      "&:hover": {
        background: "transparent"
      }
    },
    select: {
      paddingRight: "44px !important"
    },
    listElement: {
      fontSize: 12
    },
    iconSelect: {
      paddingRight: 8
    },
    titleCheckbox: {
      fontSize: 12
    },
    containerCheckbox: {
      marginTop: 24,
      marginBottom: 4
    },
    iconCheckbox: {
      color: theme.palette.secondary.light,
      "& svg": {
        fontSize: "1.2rem"
      },
      "&$checked": {
        color: theme.palette.secondary.light
      }
    },
    clearIcon: {
      opacity: "0",
      position: "absolute",
      top: 20,
      right: 18,
      marginRight: 24,
      fontSize: 14,
      "& > button": {
        padding: 0
      }
    },
    iconButton: {
      border: "1px solid red"
    },
    paperPopover: {
      marginLeft: -310,
      width: 310,
      padding: "8px 0",
      maxHeight: "40vh",
      overflow: "auto",
      "& button": {
        width: "100%",
        fontFamily: "Mulish",
        display: "flex",
        justifyContent: "flex-start",
        textAlign: "left",
        border: "none",
        background: "none",
        cursor: "pointer",
        fontSize: "12px",
        fontWeight: 400,
        lineHeight: "1.5",
        padding: "6px 16px 6px 16px",
        "&:focus, &:hover": {
          border: "none",
          outline: "none",
          background: "rgba(0, 0, 0, 0.04)"
        }
      }
    },
    // END ADORNMENT FOR INPUT PASSWORD
    endAdornment: {
      "& > div": {
        marginRight: 8,
        cursor: "pointer"
      }
    },
    iconAdornment: {
      fontSize: "1.2rem",
      color: "rgba(0,0,0, 0.54)"
    },
    // force input to display Upper Case
    forceUpperCase: {
      "& input": {
        textTransform: 'uppercase'
      }
    },
    "@media all and (max-width: 420px)": {
      formControl: {
        width: 250
      },
      paperPopover: {
        marginLeft: -250,
        width: 250
      },
      messageError: {
        width: 258
      }
    }
  });
});

// import messages from '../../../traductions/index';

function Checkbox(props) {
  var required = props.required,
      label = props.label,
      value = props.value,
      name = props.name,
      className = props.className,
      disabled = props.disabled;
  var classes = useStyles$h();

  var _a = React__default['default'].useState(value || false),
      isChecked = _a[0],
      setChecked = _a[1];

  var handleChange = function handleChange(event) {
    setChecked(event.target.checked);

    if (props.onChange) {
      props.onChange(name, event.target.checked);
    }
  };

  React$1.useEffect(function () {
    if (value) {
      setChecked(value);
    } else {
      setChecked(false);
    }
  }, [value]);
  var requiredAsterisk = required ? " *" : "";
  return /*#__PURE__*/React__default['default'].createElement(core.FormControlLabel, {
    className: classes.containerCheckbox + " " + className,
    classes: {
      label: classes.titleCheckbox
    },
    control: /*#__PURE__*/React__default['default'].createElement(core.Checkbox, {
      disabled: disabled,
      color: "default",
      checked: isChecked,
      classes: {
        root: classes.iconCheckbox
      },
      onChange: handleChange,
      name: name
    }),
    label: label + requiredAsterisk
  });
}

function ListCheckbox(props) {
  var list = props.list;
  return /*#__PURE__*/React__default['default'].createElement("div", null, list === null || list === void 0 ? void 0 : list.map(function (l) {
    return /*#__PURE__*/React__default['default'].createElement(Checkbox, {
      name: l.name,
      label: l.label
    });
  }));
}

function Ouvrir(props) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    className: props.className,
    width: props.width ? props.width + 'px' : '24px',
    height: "12px",
    viewBox: "0 0 24 12",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "Ouvrir"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "BOARD-3---Ic\xF4nes",
    transform: "translate(-638.000000, -292.000000)",
    fill: "#1B202D"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Pictogrammes",
    transform: "translate(305.000000, 178.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "12---Ouvrir",
    transform: "translate(333.000000, 103.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12.6585938,22.7468221 L23.7285998,12.469726 C24.0910829,12.1329656 24.0904735,11.5878129 23.7267248,11.2517034 C23.363023,10.9157674 22.7738533,10.9166354 22.4110891,11.2534392 L11.9999557,20.9188117 L1.58886913,11.2530487 C1.22605797,10.916375 0.63726327,10.9155071 0.273514614,11.2513128 C0.0911715381,11.4198666 0,11.640627 0,11.8613873 C0,12.0815835 0.0905621653,12.301476 0.271639621,12.4696826 L11.3413643,22.7468221 C11.5156449,22.9089532 11.7528316,23 11.9999557,23 C12.2470797,23 12.4839382,22.9086928 12.6585938,22.7468221",
    id: "Fill-1"
  })))));
}

var useStyles$g = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    root: {
      margin: "auto",
      marginTop: 16
    },
    card: {
      backgroundColor: theme.palette.primary.light,
      border: "0.2px solid rgba(92,92,92,0.3)",
      borderRadius: 4
    },
    cardHeader: {
      padding: 8
    },
    checkboxContainer: {
      marginRight: 8
    },
    contentHeader: {
      display: "flex",
      "& > span": {
        fontSize: 13,
        color: theme.palette.secondary.dark,
        paddingRight: 4
      }
    },
    list: {
      width: 280,
      height: 230,
      // backgroundColor: 'white',
      overflow: "auto"
    },
    listItem: {
      padding: "4px 8px"
    },
    listItemIcon: {
      marginRight: 8,
      minWidth: 0
    },
    listItemText: {
      "& > span": {
        fontSize: 13,
        color: theme.palette.secondary.dark,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }
    },
    button: {
      borderColor: theme.palette.secondary.main,
      padding: 8,
      margin: "4px 16px",
      borderRadius: 10
    },
    disabledButton: {
      borderColor: theme.palette.secondary.main + " !important",
      opacity: 0.4
    },
    buttonLeft: {
      "& svg": {
        transform: "rotate(90deg)",
        "& > g": {
          fill: theme.palette.secondary.main
        }
      }
    },
    buttonRight: {
      "& svg": {
        transform: "rotate(-90deg)",
        "& > g": {
          fill: theme.palette.secondary.main
        }
      }
    },
    iconCheckbox: {
      color: theme.palette.secondary.main,
      padding: 4,
      "& svg": {
        fontSize: "1.2rem"
      },
      "&$checked": {
        color: theme.palette.secondary.main
      }
    }
  });
});

function not(items, checkedItems) {
  var itemsFilter = items.filter(function (value) {
    return !checkedItems.includes(value);
  });
  return itemsFilter;
}

function intersection(checkedItems, items) {
  return items.filter(function (value) {
    return checkedItems.find(function (c) {
      return c.id === value.id;
    });
  });
}

function union(checkedItems, items) {
  return __spreadArray(__spreadArray([], items), not(items, checkedItems));
} // gérer l'ordre


function customSort(_a) {
  var data = _a.data,
      sortBy = _a.sortBy,
      sortField = _a.sortField;
  var sortByObject = sortBy.reduce(function (obj, item, index) {
    var _a;

    return __assign(__assign({}, obj), (_a = {}, _a[item] = index, _a));
  }, {});
  return data.sort(function (a, b) {
    // @ts-ignore
    return sortByObject[a[sortField].substring(0, 1)] - // @ts-ignore
    sortByObject[b[sortField].substring(0, 1)];
  });
}

function ListTransfer(props) {
  var listLeft = props.listLeft,
      listRight = props.listRight,
      sortBy = props.sortBy,
      name = props.name;

  var _a = React__default['default'].useState([]),
      checked = _a[0],
      setChecked = _a[1];

  var _b = React__default['default'].useState(listLeft),
      left = _b[0],
      setLeft = _b[1];

  var _c = React__default['default'].useState(listRight || []),
      right = _c[0],
      setRight = _c[1];

  var leftChecked = intersection(checked, left);
  var rightChecked = intersection(checked, right);
  var classes = useStyles$g();
  React$1.useEffect(function () {
    if (listLeft) {
      setLeft(listLeft);
    }
  }, [listLeft]);
  React$1.useEffect(function () {
    if (listRight) {
      setRight(listRight);
    }
  }, [listRight]);

  var handleToggle = function handleToggle(value) {
    return function () {
      var valueIsChecked = checked.find(function (item) {
        return item.id === value.id;
      });

      var newChecked = __spreadArray([], checked);

      if (!valueIsChecked) {
        newChecked.push(value);
      } else {
        newChecked = newChecked.filter(function (item) {
          return item.id !== value.id;
        });
      }

      setChecked(newChecked);
    };
  };

  var numberOfChecked = function numberOfChecked(items) {
    return intersection(checked, items).length;
  };

  var handleToggleAll = function handleToggleAll(items) {
    return function () {
      if (numberOfChecked(items) === items.length) {
        setChecked(not(checked, items));
      } else {
        setChecked(union(checked, items));
      }
    };
  };

  var handleCheckedRight = function handleCheckedRight() {
    var rightSort = customSort({
      data: right.concat(leftChecked),
      sortBy: sortBy,
      sortField: "value"
    });
    setRight(rightSort);
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));

    if (props.onChange) {
      props.onChange(name, rightSort);
    }
  };

  var handleCheckedLeft = function handleCheckedLeft() {
    var leftSort = customSort({
      data: left.concat(rightChecked),
      sortBy: sortBy,
      sortField: "value"
    });
    setLeft(leftSort);
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));

    if (props.onChange) {
      props.onChange(name, not(right, rightChecked));
    }
  };

  var customList = function customList(title, items) {
    return /*#__PURE__*/React__default['default'].createElement(Card__default['default'], {
      elevation: 0,
      classes: {
        root: classes.card
      }
    }, /*#__PURE__*/React__default['default'].createElement(CardHeader__default['default'], {
      className: classes.cardHeader,
      classes: {
        avatar: classes.checkboxContainer,
        content: classes.contentHeader
      },
      avatar: /*#__PURE__*/React__default['default'].createElement(Checkbox__default['default'], {
        classes: {
          root: classes.iconCheckbox
        },
        "data-testid": title === "Sélectionnés" ? "select-all-right" : "select-all-left",
        onClick: handleToggleAll(items),
        checked: numberOfChecked(items) === items.length && items.length !== 0,
        indeterminate: numberOfChecked(items) !== items.length && numberOfChecked(items) !== 0,
        disabled: items.length === 0,
        inputProps: {
          "aria-label": "Tous les éléments sélectionnés"
        }
      }),
      title: title,
      subheader: "(" + numberOfChecked(items) + "/" + items.length + ")"
    }), /*#__PURE__*/React__default['default'].createElement(Divider__default['default'], null), /*#__PURE__*/React__default['default'].createElement(List__default['default'], {
      className: classes.list,
      dense: true,
      component: "div",
      role: "list"
    }, items.map(function (value) {
      var labelId = "item-" + value.id + "-label";
      return /*#__PURE__*/React__default['default'].createElement(ListItem__default['default'], {
        key: value.id,
        role: "listitem",
        button: true,
        onClick: handleToggle(value),
        classes: {
          root: classes.listItem
        }
      }, /*#__PURE__*/React__default['default'].createElement(ListItemIcon__default['default'], {
        classes: {
          root: classes.listItemIcon
        }
      }, /*#__PURE__*/React__default['default'].createElement(Checkbox__default['default'], {
        classes: {
          root: classes.iconCheckbox
        },
        "data-testid": labelId,
        checked: checked.find(function (item) {
          return item.id === value.id;
        }) ? true : false,
        tabIndex: -1,
        disableRipple: true,
        inputProps: {
          "aria-labelledby": labelId
        }
      })), /*#__PURE__*/React__default['default'].createElement(core.Tooltip, {
        title: value.value,
        placement: "top"
      }, /*#__PURE__*/React__default['default'].createElement(ListItemText__default['default'], {
        id: labelId,
        primary: value.value,
        classes: {
          root: classes.listItemText
        }
      })));
    }), /*#__PURE__*/React__default['default'].createElement(ListItem__default['default'], null)));
  };

  return /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    container: true,
    alignItems: "center",
    className: classes.root
  }, /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true
  }, customList("À sélectionner", left)), /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true
  }, /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    container: true,
    direction: "column",
    alignItems: "center"
  }, /*#__PURE__*/React__default['default'].createElement(Button__default['default'], {
    variant: "outlined",
    size: "small",
    className: classes.button,
    classes: {
      root: classes.buttonRight,
      disabled: classes.disabledButton
    },
    onClick: handleCheckedRight,
    disabled: leftChecked.length === 0,
    "data-testid": "select-right",
    "aria-label": "move selected right"
  }, /*#__PURE__*/React__default['default'].createElement(Ouvrir, {
    width: 14
  })), /*#__PURE__*/React__default['default'].createElement(Button__default['default'], {
    variant: "outlined",
    size: "small",
    className: classes.button,
    classes: {
      root: classes.buttonLeft,
      disabled: classes.disabledButton
    },
    "data-testid": "select-left",
    onClick: handleCheckedLeft,
    disabled: rightChecked.length === 0,
    "aria-label": "move selected left"
  }, /*#__PURE__*/React__default['default'].createElement(Ouvrir, {
    width: 14
  })))), /*#__PURE__*/React__default['default'].createElement(Grid__default['default'], {
    item: true
  }, customList("Sélectionnés", right)));
}

var Close = {};

var interopRequireDefault = {exports: {}};

(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;
}(interopRequireDefault));

var interopRequireWildcard = {exports: {}};

var _typeof$1 = {exports: {}};

(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;
}(_typeof$1));

(function (module) {
var _typeof = _typeof$1.exports["default"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard;
module.exports["default"] = module.exports, module.exports.__esModule = true;
}(interopRequireWildcard));

var createSvgIcon = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _utils.createSvgIcon;
  }
});

var _utils = require$$0__default['default'];
}(createSvgIcon));

var _interopRequireDefault = interopRequireDefault.exports;

var _interopRequireWildcard = interopRequireWildcard.exports;

Object.defineProperty(Close, "__esModule", {
  value: true
});
var default_1 = Close.default = void 0;

var React = _interopRequireWildcard(React__default['default']);

var _createSvgIcon = _interopRequireDefault(createSvgIcon);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

default_1 = Close.default = _default;

var useStyles$f = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    modaleContainer: {
      borderRadius: 12
    },
    title: {
      padding: "32px 32px 0 32px",
      "& h2": {
        color: theme.palette.secondary.light,
        fontSize: 14,
        fontWeight: "bold",
        margin: 0
      }
    },
    content: {
      padding: 32,
      "& p": {
        margin: 0,
        fontSize: 17,
        fontWeight: "bold"
      }
    },
    buttonsAction: {
      padding: "0 32px 32px 32px"
    },
    centerButtonsAction: {
      padding: "0 32px 32px 32px",
      justifyContent: "center",
      alignItems: "flex-start",
      "& > div": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: 140,
        flex: "1",
        "& > span": {
          fontSize: 12,
          maxWidth: 195,
          lineHeight: 1.4,
          marginTop: 8,
          textAlign: "center"
        }
      }
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    error: {
      padding: " 0 32px 32px 32px",
      textAlign: "right",
      marginTop: "-23px"
    }
  });
});

function Modale(props) {
  var open = props.open,
      onConfirm = props.onConfirm,
      onCancel = props.onCancel,
      message = props.message,
      children = props.children,
      title = props.title,
      fetchingConfirm = props.fetchingConfirm,
      disabledClose = props.disabledClose,
      buttonValidText = props.buttonValidText,
      centerButtons = props.centerButtons,
      error = props.error,
      subtitleCancel = props.subtitleCancel;
  var classes = useStyles$f();

  var handleClose = function handleClose() {
    if (onCancel) {
      onCancel();
    }
  };

  return /*#__PURE__*/React__default['default'].createElement(core.Dialog, {
    maxWidth: "sm",
    open: open,
    onClose: !disabledClose ? handleClose : undefined,
    disableBackdropClick: disabledClose,
    disableEscapeKeyDown: disabledClose,
    classes: {
      paper: classes.modaleContainer
    }
  }, title && /*#__PURE__*/React__default['default'].createElement(core.DialogTitle, {
    classes: {
      root: classes.title
    }
  }, title, !disabledClose ? /*#__PURE__*/React__default['default'].createElement(core.IconButton, {
    "aria-label": "close",
    "data-testid": "closeButton",
    className: classes.closeButton,
    onClick: handleClose
  }, /*#__PURE__*/React__default['default'].createElement(default_1, null)) : null), /*#__PURE__*/React__default['default'].createElement(core.DialogContent, {
    classes: {
      root: classes.content
    }
  }, message && /*#__PURE__*/React__default['default'].createElement("p", {
    dangerouslySetInnerHTML: {
      __html: message
    }
  }), children && children), onConfirm && /*#__PURE__*/React__default['default'].createElement(core.DialogActions, {
    classes: {
      root: centerButtons ? classes.centerButtonsAction : classes.buttonsAction
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", null, onCancel && /*#__PURE__*/React__default['default'].createElement(Button, {
    onClick: onCancel,
    title: "Annuler",
    variant: "contained",
    color: "default"
  }), subtitleCancel && /*#__PURE__*/React__default['default'].createElement("span", null, subtitleCancel)), onConfirm && /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(Button, {
    onClick: onConfirm,
    title: buttonValidText ? buttonValidText : "Valider",
    fetching: fetchingConfirm,
    variant: "contained",
    color: "primary"
  }))), error && /*#__PURE__*/React__default['default'].createElement(core.Typography, {
    className: classes.error,
    color: "error",
    variant: "body2"
  }, error));
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'moins d’une seconde',
    other: 'moins de {{count}} secondes'
  },
  xSeconds: {
    one: '1 seconde',
    other: '{{count}} secondes'
  },
  halfAMinute: '30 secondes',
  lessThanXMinutes: {
    one: 'moins d’une minute',
    other: 'moins de {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'environ 1 heure',
    other: 'environ {{count}} heures'
  },
  xHours: {
    one: '1 heure',
    other: '{{count}} heures'
  },
  xDays: {
    one: '1 jour',
    other: '{{count}} jours'
  },
  aboutXWeeks: {
    one: 'environ 1 semaine',
    other: 'environ {{count}} semaines'
  },
  xWeeks: {
    one: '1 semaine',
    other: '{{count}} semaines'
  },
  aboutXMonths: {
    one: 'environ 1 mois',
    other: 'environ {{count}} mois'
  },
  xMonths: {
    one: '1 mois',
    other: '{{count}} mois'
  },
  aboutXYears: {
    one: 'environ 1 an',
    other: 'environ {{count}} ans'
  },
  xYears: {
    one: '1 an',
    other: '{{count}} ans'
  },
  overXYears: {
    one: 'plus d’un an',
    other: 'plus de {{count}} ans'
  },
  almostXYears: {
    one: 'presqu’un an',
    other: 'presque {{count}} ans'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'dans ' + result;
    } else {
      return 'il y a ' + result;
    }
  }

  return result;
}

var dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

var eraValues = {
  narrow: ['av. J.-C', 'ap. J.-C'],
  abbreviated: ['av. J.-C', 'ap. J.-C'],
  wide: ['avant Jésus-Christ', 'après Jésus-Christ']
};
var quarterValues = {
  narrow: ['T1', 'T2', 'T3', 'T4'],
  abbreviated: ['1er trim.', '2ème trim.', '3ème trim.', '4ème trim.'],
  wide: ['1er trimestre', '2ème trimestre', '3ème trimestre', '4ème trimestre']
};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
  wide: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
};
var dayValues = {
  narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  short: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
  abbreviated: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
  wide: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
};
var dayPeriodValues = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'mat.',
    afternoon: 'ap.m.',
    evening: 'soir',
    night: 'mat.'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'matin',
    afternoon: 'après-midi',
    evening: 'soir',
    night: 'matin'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'du matin',
    afternoon: 'de l’après-midi',
    evening: 'du soir',
    night: 'du matin'
  }
};

function ordinalNumber(dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber);
  var options = dirtyOptions || {};
  var unit = String(options.unit);
  var suffix;

  if (number === 0) {
    return number;
  }

  if (unit === 'year' || unit === 'hour' || unit === 'week') {
    if (number === 1) {
      suffix = 'ère';
    } else {
      suffix = 'ème';
    }
  } else {
    if (number === 1) {
      suffix = 'er';
    } else {
      suffix = 'ème';
    }
  }

  return number + suffix;
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide'
  })
};

var matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var parseEraPatterns = {
  any: [/^av/i, /^ap/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](er|ème|e)? trimestre/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var parseDayPatterns = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */

var locale = {
  code: 'fr',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};

var reactTextMask = {exports: {}};

(function (module, exports) {
!function(e,t){module.exports=t(React__default['default']);}(commonjsGlobal,function(e){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function o(e,t){var r={};for(var n in e)t.indexOf(n)>=0||Object.prototype.hasOwnProperty.call(e,n)&&(r[n]=e[n]);return r}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function a(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t||"object"!=typeof t&&"function"!=typeof t?e:t}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t);}Object.defineProperty(t,"__esModule",{value:!0}),t.conformToMask=void 0;var s=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},l=function(){function e(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}return function(t,r,n){return r&&e(t.prototype,r),n&&e(t,n),t}}(),f=r(3);Object.defineProperty(t,"conformToMask",{enumerable:!0,get:function(){return n(f).default}});var c=r(11),p=n(c),d=r(9),h=n(d),v=r(5),y=n(v),m=r(2),b=function(e){function t(){var e;i(this,t);for(var r=arguments.length,n=Array(r),o=0;o<r;o++)n[o]=arguments[o];var u=a(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(n)));return u.setRef=u.setRef.bind(u),u.onBlur=u.onBlur.bind(u),u.onChange=u.onChange.bind(u),u}return u(t,e),l(t,[{key:"setRef",value:function(e){this.inputElement=e;}},{key:"initTextMask",value:function(){var e=this.props,t=this.props.value;this.textMaskInputElement=(0, y.default)(s({inputElement:this.inputElement},e)),this.textMaskInputElement.update(t);}},{key:"componentDidMount",value:function(){this.initTextMask();}},{key:"componentDidUpdate",value:function(e){var t=this.props,r=t.value,n=t.pipe,o=t.mask,i=t.guide,a=t.placeholderChar,u=t.showMask,s={guide:i,placeholderChar:a,showMask:u},l="function"==typeof n&&"function"==typeof e.pipe?n.toString()!==e.pipe.toString():(0, m.isNil)(n)&&!(0, m.isNil)(e.pipe)||!(0, m.isNil)(n)&&(0, m.isNil)(e.pipe),f=o.toString()!==e.mask.toString(),c=Object.keys(s).some(function(t){return s[t]!==e[t]})||f||l,p=r!==this.inputElement.value;(p||c)&&this.initTextMask();}},{key:"render",value:function e(){var t=this.props,e=t.render,r=o(t,["render"]);return delete r.mask,delete r.guide,delete r.pipe,delete r.placeholderChar,delete r.keepCharPositions,delete r.value,delete r.onBlur,delete r.onChange,delete r.showMask,e(this.setRef,s({onBlur:this.onBlur,onChange:this.onChange,defaultValue:this.props.value},r))}},{key:"onChange",value:function(e){this.textMaskInputElement.update(),"function"==typeof this.props.onChange&&this.props.onChange(e);}},{key:"onBlur",value:function(e){"function"==typeof this.props.onBlur&&this.props.onBlur(e);}}]),t}(p.default.PureComponent);t.default=b,b.propTypes={mask:h.default.oneOfType([h.default.array,h.default.func,h.default.bool,h.default.shape({mask:h.default.oneOfType([h.default.array,h.default.func]),pipe:h.default.func})]).isRequired,guide:h.default.bool,value:h.default.oneOfType([h.default.string,h.default.number]),pipe:h.default.func,placeholderChar:h.default.string,keepCharPositions:h.default.bool,showMask:h.default.bool},b.defaultProps={render:function(e,t){return p.default.createElement("input",s({ref:e},t))}};},function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t.placeholderChar="_",t.strFunction="function";},function(e,t,r){function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:f,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:l.placeholderChar;if(!o(e))throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");if(e.indexOf(t)!==-1)throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n"+("The placeholder character that was received is: "+JSON.stringify(t)+"\n\n")+("The mask that was received is: "+JSON.stringify(e)));return e.map(function(e){return e instanceof RegExp?t:e}).join("")}function o(e){return Array.isArray&&Array.isArray(e)||e instanceof Array}function i(e){return "string"==typeof e||e instanceof String}function a(e){return "number"==typeof e&&void 0===e.length&&!isNaN(e)}function u(e){return "undefined"==typeof e||null===e}function s(e){for(var t=[],r=void 0;r=e.indexOf(c),r!==-1;)t.push(r),e.splice(r,1);return {maskWithoutCaretTraps:e,indexes:t}}Object.defineProperty(t,"__esModule",{value:!0}),t.convertMaskToPlaceholder=n,t.isArray=o,t.isString=i,t.isNumber=a,t.isNil=u,t.processCaretTraps=s;var l=r(1),f=[],c="[]";},function(e,t,r){function n(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:s,t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:u,r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(!(0, i.isArray)(t)){if(("undefined"==typeof t?"undefined":o(t))!==a.strFunction)throw new Error("Text-mask:conformToMask; The mask property must be an array.");t=t(e,r),t=(0, i.processCaretTraps)(t).maskWithoutCaretTraps;}var n=r.guide,l=void 0===n||n,f=r.previousConformedValue,c=void 0===f?s:f,p=r.placeholderChar,d=void 0===p?a.placeholderChar:p,h=r.placeholder,v=void 0===h?(0, i.convertMaskToPlaceholder)(t,d):h,y=r.currentCaretPosition,m=r.keepCharPositions,b=l===!1&&void 0!==c,g=e.length,k=c.length,C=v.length,O=t.length,T=g-k,P=T>0,x=y+(P?-T:0),w=x+Math.abs(T);if(m===!0&&!P){for(var S=s,_=x;_<w;_++)v[_]===d&&(S+=d);e=e.slice(0,x)+S+e.slice(x,g);}for(var M=e.split(s).map(function(e,t){return {char:e,isNew:t>=x&&t<w}}),j=g-1;j>=0;j--){var E=M[j].char;if(E!==d){var R=j>=x&&k===O;E===v[R?j-T:j]&&M.splice(j,1);}}var V=s,N=!1;e:for(var A=0;A<C;A++){var B=v[A];if(B===d){if(M.length>0)for(;M.length>0;){var I=M.shift(),F=I.char,q=I.isNew;if(F===d&&b!==!0){V+=d;continue e}if(t[A].test(F)){if(m===!0&&q!==!1&&c!==s&&l!==!1&&P){for(var D=M.length,L=null,W=0;W<D;W++){var J=M[W];if(J.char!==d&&J.isNew===!1)break;if(J.char===d){L=W;break}}null!==L?(V+=F,M.splice(L,1)):A--;}else V+=F;continue e}N=!0;}b===!1&&(V+=v.substr(A,C));break}V+=B;}if(b&&P===!1){for(var U=null,H=0;H<V.length;H++)v[H]===d&&(U=H);V=null!==U?V.substr(0,U+1):s;}return {conformedValue:V,meta:{someCharsRejected:N}}}Object.defineProperty(t,"__esModule",{value:!0});var o="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=n;var i=r(2),a=r(1),u=[],s="";},function(e,t){function r(e){var t=e.previousConformedValue,r=void 0===t?o:t,i=e.previousPlaceholder,a=void 0===i?o:i,u=e.currentCaretPosition,s=void 0===u?0:u,l=e.conformedValue,f=e.rawValue,c=e.placeholderChar,p=e.placeholder,d=e.indexesOfPipedChars,h=void 0===d?n:d,v=e.caretTrapIndexes,y=void 0===v?n:v;if(0===s||!f.length)return 0;var m=f.length,b=r.length,g=p.length,k=l.length,C=m-b,O=C>0,T=0===b,P=C>1&&!O&&!T;if(P)return s;var x=O&&(r===l||l===p),w=0,S=void 0,_=void 0;if(x)w=s-C;else {var M=l.toLowerCase(),j=f.toLowerCase(),E=j.substr(0,s).split(o),R=E.filter(function(e){return M.indexOf(e)!==-1});_=R[R.length-1];var V=a.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,N=p.substr(0,R.length).split(o).filter(function(e){return e!==c}).length,A=N!==V,B=void 0!==a[R.length-1]&&void 0!==p[R.length-2]&&a[R.length-1]!==c&&a[R.length-1]!==p[R.length-1]&&a[R.length-1]===p[R.length-2];!O&&(A||B)&&V>0&&p.indexOf(_)>-1&&void 0!==f[s]&&(S=!0,_=f[s]);for(var I=h.map(function(e){return M[e]}),F=I.filter(function(e){return e===_}).length,q=R.filter(function(e){return e===_}).length,D=p.substr(0,p.indexOf(c)).split(o).filter(function(e,t){return e===_&&f[t]!==e}).length,L=D+q+F+(S?1:0),W=0,J=0;J<k;J++){var U=M[J];if(w=J+1,U===_&&W++,W>=L)break}}if(O){for(var H=w,Y=w;Y<=g;Y++)if(p[Y]===c&&(H=Y),p[Y]===c||y.indexOf(Y)!==-1||Y===g)return H}else if(S){for(var z=w-1;z>=0;z--)if(l[z]===_||y.indexOf(z)!==-1||0===z)return z}else for(var G=w;G>=0;G--)if(p[G-1]===c||y.indexOf(G)!==-1||0===G)return G}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r;var n=[],o="";},function(e,t,r){function n(e){return e&&e.__esModule?e:{default:e}}function o(e){var t={previousConformedValue:void 0,previousPlaceholder:void 0};return {state:t,update:function(r){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:e,o=n.inputElement,l=n.mask,c=n.guide,y=n.pipe,b=n.placeholderChar,g=void 0===b?h.placeholderChar:b,k=n.keepCharPositions,C=void 0!==k&&k,O=n.showMask,T=void 0!==O&&O;if("undefined"==typeof r&&(r=o.value),r!==t.previousConformedValue){("undefined"==typeof l?"undefined":s(l))===m&&void 0!==l.pipe&&void 0!==l.mask&&(y=l.pipe,l=l.mask);var P=void 0,x=void 0;if(l instanceof Array&&(P=(0, d.convertMaskToPlaceholder)(l,g)),l!==!1){var w=a(r),S=o.selectionEnd,_=t.previousConformedValue,M=t.previousPlaceholder,j=void 0;if(("undefined"==typeof l?"undefined":s(l))===h.strFunction){if(x=l(w,{currentCaretPosition:S,previousConformedValue:_,placeholderChar:g}),x===!1)return;var E=(0, d.processCaretTraps)(x),R=E.maskWithoutCaretTraps,V=E.indexes;x=R,j=V,P=(0, d.convertMaskToPlaceholder)(x,g);}else x=l;var N={previousConformedValue:_,guide:c,placeholderChar:g,pipe:y,placeholder:P,currentCaretPosition:S,keepCharPositions:C},A=(0, p.default)(w,x,N),B=A.conformedValue,I=("undefined"==typeof y?"undefined":s(y))===h.strFunction,F={};I&&(F=y(B,u({rawValue:w},N)),F===!1?F={value:_,rejected:!0}:(0, d.isString)(F)&&(F={value:F}));var q=I?F.value:B,D=(0, f.default)({previousConformedValue:_,previousPlaceholder:M,conformedValue:q,placeholder:P,rawValue:w,currentCaretPosition:S,placeholderChar:g,indexesOfPipedChars:F.indexesOfPipedChars,caretTrapIndexes:j}),L=q===P&&0===D,W=T?P:v,J=L?W:q;t.previousConformedValue=J,t.previousPlaceholder=P,o.value!==J&&(o.value=J,i(o,D));}}}}}function i(e,t){document.activeElement===e&&(b?g(function(){return e.setSelectionRange(t,t,y)},0):e.setSelectionRange(t,t,y));}function a(e){if((0, d.isString)(e))return e;if((0, d.isNumber)(e))return String(e);if(void 0===e||null===e)return v;throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n "+JSON.stringify(e))}Object.defineProperty(t,"__esModule",{value:!0});var u=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},s="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};t.default=o;var l=r(4),f=n(l),c=r(3),p=n(c),d=r(2),h=r(1),v="",y="none",m="object",b="undefined"!=typeof navigator&&/Android/i.test(navigator.userAgent),g="undefined"!=typeof requestAnimationFrame?requestAnimationFrame:setTimeout;},function(e,t){function r(e){return function(){return e}}var n=function(){};n.thatReturns=r,n.thatReturnsFalse=r(!1),n.thatReturnsTrue=r(!0),n.thatReturnsNull=r(null),n.thatReturnsThis=function(){return this},n.thatReturnsArgument=function(e){return e},e.exports=n;},function(e,t,r){function n(e,t,r,n,i,a,u,s){if(!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var f=[r,n,i,a,u,s],c=0;l=new Error(t.replace(/%s/g,function(){return f[c++]})),l.name="Invariant Violation";}throw l.framesToPop=1,l}}e.exports=n;},function(e,t,r){var n=r(6),o=r(7),i=r(10);e.exports=function(){function e(e,t,r,n,a,u){u!==i&&o(!1,"Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return r.checkPropTypes=n,r.PropTypes=r,r};},function(e,t,r){e.exports=r(8)();},function(e,t){var r="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=r;},function(t,r){t.exports=e;}])});
}(reactTextMask));

var MaskedInput = /*@__PURE__*/getDefaultExportFromCjs(reactTextMask.exports);

/**
 * Formatte une date sous la forme "22/05/2000"
 *
 * @param date : Date d'entrée a formatter
 */

var formatDateCourt = function formatDateCourt(date) {
  if (_typeof(date) === "object") {
    return format(date, "dd/MM/yyyy", {
      locale: locale
    });
  } else {
    var dateFormat = new Date(date);
    return format(dateFormat, "dd/MM/yyyy", {
      locale: locale
    });
  }
};
var formatApiDate = function formatApiDate(date) {
  return format(new Date(date), "yyyy-MM-dd", {
    locale: locale
  });
};
addMonths(new Date(), 6);

function Date$1(props) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: props.width ? props.width + 'px' : '24px',
    height: "26px",
    viewBox: "0 0 28 26",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "Date"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "BOARD-3---Ic\xF4nes",
    transform: "translate(-635.000000, -182.000000)",
    fill: "#1B202D"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Pictogrammes",
    transform: "translate(305.000000, 178.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "10---Date",
    transform: "translate(330.000000, 0.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M17.6519,7.61111111 L17.6519,5.08333333 C17.6519,4.48533333 18.1216,4 18.7019,4 C19.2815,4 19.7519,4.48533333 19.7519,5.08333333 L19.7519,7.61111111 L26.95,7.61111111 C27.2286,7.61111111 27.4953,7.72522222 27.6927,7.92816667 C27.8894,8.13183333 28,8.407 28,8.69444444 C28,12.4846667 28,25.1264444 28,28.9166667 C28,29.2041111 27.8894,29.4792778 27.6927,29.6829444 C27.4953,29.8858889 27.2286,30 26.95,30 C22.5309,30 5.4691,30 1.05,30 C0.7714,30 0.5047,29.8858889 0.3073,29.6829444 C0.1106,29.4792778 0,29.2041111 0,28.9166667 C0,25.1264444 0,12.4846667 0,8.69444444 C0,8.407 0.1106,8.13183333 0.3073,7.92816667 C0.5047,7.72522222 0.7714,7.61111111 1.05,7.61111111 L8.4,7.61111111 L8.4,5.08333333 C8.4,4.48533333 8.8704,4 9.45,4 C10.0296,4 10.5,4.48533333 10.5,5.08333333 L10.5,7.61111111 L17.6519,7.61111111 Z M8.4,9.77777778 L2.1,9.77777778 L2.1,27.8333333 L25.9,27.8333333 L25.9,9.77777778 L19.7519,9.77777778 L19.7519,11.5833333 C19.7519,12.1813333 19.2815,12.6666667 18.7019,12.6666667 C18.1216,12.6666667 17.6519,12.1813333 17.6519,11.5833333 L17.6519,9.77777778 L10.5,9.77777778 L10.5,11.5833333 C10.5,12.1813333 10.0296,12.6666667 9.45,12.6666667 C8.8704,12.6666667 8.4,12.1813333 8.4,11.5833333 L8.4,9.77777778 Z M7.7,23.4768889 L5.6,23.4768889 L5.6,21.3102222 L7.7,21.3102222 L7.7,23.4768889 Z M15.0283,23.4768889 L12.9283,23.4768889 L12.9283,21.3102222 L15.0283,21.3102222 L15.0283,23.4768889 Z M22.4,23.4768889 L20.3,23.4768889 L20.3,21.3102222 L22.4,21.3102222 L22.4,23.4768889 Z M7.7,18.4444444 L5.6,18.4444444 L5.6,16.2777778 L7.7,16.2777778 L7.7,18.4444444 Z M15.0283,18.4444444 L12.9283,18.4444444 L12.9283,16.2777778 L15.0283,16.2777778 L15.0283,18.4444444 Z M22.4,18.4444444 L20.3,18.4444444 L20.3,16.2777778 L22.4,16.2777778 L22.4,18.4444444 Z",
    id: "Shape"
  })))));
}

function Filtres(props) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: props.width ? props.width + 'px' : '14px',
    height: "14px",
    viewBox: "0 0 22 22",
    version: "1.1"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "Filtres"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "BOARD-3---Ic\xF4nes",
    transform: "translate(-638.000000, -237.000000)",
    fill: "#1B202D"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Pictogrammes",
    transform: "translate(305.000000, 178.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "11---Filtres",
    transform: "translate(333.000000, 52.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M8.35550177,17.3958207 C8.58848322,17.6470587 8.71639461,17.9752525 8.71639461,18.3147633 L8.71639461,28.3190149 C8.71639461,28.9211034 9.44960094,29.2266631 9.883586,28.8033837 L12.6999206,25.6051919 C13.0768024,25.1570377 13.2846584,24.9352013 13.2846584,24.4915965 L13.2846584,18.3170267 C13.2846584,17.9775159 13.4148539,17.6493221 13.6455512,17.3980615 L21.7267869,8.70887103 C22.3320819,8.0570103 21.8661418,7 20.9707393,7 L1.030268,7 C0.134888303,7 -0.333358732,8.05474689 0.274220347,8.70887103 L8.35550177,17.3958207 Z",
    id: "Path"
  })))));
}

function Loupe(props) {
  return /*#__PURE__*/React__default['default'].createElement("svg", {
    width: props.width ? props.width + 'px' : '14px',
    height: "14px",
    viewBox: "0 0 24 24",
    version: "1.1"
  }, /*#__PURE__*/React__default['default'].createElement("title", null, "Rechercher"), /*#__PURE__*/React__default['default'].createElement("g", {
    id: "BOARD-3---Ic\xF4nes",
    transform: "translate(-968.000000, -185.000000)",
    fill: "#1B202D"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "Pictogrammes",
    transform: "translate(305.000000, 178.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("g", {
    id: "19---Voir",
    transform: "translate(663.000000, 3.000000)"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M1.9512178,14.5691406 C1.9512178,9.81728125 5.81723153,5.95121875 10.5690886,5.95121875 C15.3209456,5.95121875 19.1869594,9.81723437 19.1869594,14.5690938 C19.1869594,19.3209531 15.3209456,23.1870625 10.5690886,23.1870625 C5.81723153,23.1870625 1.9512178,19.321 1.9512178,14.5691406 M23.7141447,26.334625 L18.6969752,21.3175 C20.2205995,19.4855313 21.1381772,17.1325938 21.1381772,14.5690938 C21.1381772,8.74145312 16.3970545,4 10.5690886,4 C4.74145081,4 0,8.74145312 0,14.5690938 C0,20.3970625 4.74145081,25.1382344 10.5690886,25.1382344 C13.1325873,25.1382344 15.4855237,24.2206094 17.3174447,22.6970313 L22.3346141,27.7141563 C22.5251609,27.9047031 22.7746295,28 23.0244263,28 C23.2738011,28 23.523551,27.9047031 23.7141447,27.7141563 C24.0952851,27.3333438 24.0952851,26.7154375 23.7141447,26.334625",
    id: "icon"
  })))));
}

var useStyles$e = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    formAutocomplete: {
      boxShadow: "none",
      margin: 0,
      paddingLeft: 4,
      border: "1px solid #CCC",
      borderRadius: "0",
      width: 268
    },
    inputAutoComplete: {
      fontSize: 12,
      minWidth: 0 + " !important"
    },
    listElement: {
      fontSize: 12
    },
    tag: {
      border: "1px solid " + theme.palette.secondary.dark,
      color: theme.palette.secondary.dark,
      background: "none",
      height: "auto",
      margin: "4px",
      "& svg": {
        color: theme.palette.secondary.dark
      },
      "&:hover": {
        background: "transparent",
        color: theme.palette.secondary.main,
        borderColor: theme.palette.secondary.main,
        "& svg": {
          color: theme.palette.secondary.main
        }
      }
    },
    deleteIcon: {
      marginRight: "8px !important",
      width: 14
    },
    label: {
      paddingRight: 8,
      fontSize: 12
    }
  });
});

function AutoComplete$2(props) {
  props.label;
      var name = props.name,
      value = props.value,
      required = props.required;
      props.error;
      var getOptions = props.getOptions,
      placeholder = props.placeholder;
      props.errors;
      var disabled = props.disabled;
  var classes = useStyles$e();

  var _a = React__default['default'].useState(getOptions || []),
      options = _a[0],
      setOptions = _a[1];

  var isReadOnly = disabled;
  var defaultValue = value || undefined;

  var _b = React__default['default'].useState(defaultValue),
      stateValue = _b[0],
      setStateValue = _b[1];

  var _c = React__default['default'].useState(false);
      _c[0];
      var setDirtyRequired = _c[1];

  var _onChange = function onChange(e, newValue) {
    e.preventDefault();
    setStateValue(newValue);

    if (getOptions) {
      var optionsSelected = newValue;
      props.onChange(name, optionsSelected);
    }

    if (!newValue && required) {
      setDirtyRequired(true);
    } else {
      setDirtyRequired(false);
    }
  };

  React$1.useEffect(function () {
    if (getOptions) {
      setOptions(getOptions);
    }

    return function () {};
  }, [getOptions]);
  React$1.useEffect(function () {
    if (value && options) {
      setStateValue(value);
    } else {
      setStateValue(undefined);
    }
  }, [value, options]);
  return /*#__PURE__*/React__default['default'].createElement(core.FormControl, {
    className: classes.formAutocomplete
  }, /*#__PURE__*/React__default['default'].createElement(Autocomplete$1, {
    "data-testid": "autocomplete-test",
    multiple: true,
    disabled: isReadOnly,
    disableClearable: true,
    classes: {
      input: classes.inputAutoComplete,
      option: classes.listElement
    },
    id: name,
    getOptionLabel: function getOptionLabel(option) {
      return option.value;
    },
    getOptionSelected: function getOptionSelected(option, value) {
      return option.id === value.id;
    },
    options: options,
    value: stateValue,
    onChange: function onChange(event, newValue) {
      _onChange(event, newValue);
    },
    popupIcon: /*#__PURE__*/React__default['default'].createElement(ExpandMore, null),
    ChipProps: {
      deleteIcon: /*#__PURE__*/React__default['default'].createElement(Close$1, {
        fontSize: "small"
      }),
      classes: {
        root: classes.tag,
        deleteIcon: classes.deleteIcon,
        label: classes.label
      }
    },
    noOptionsText: "Pas d'options",
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default['default'].createElement(core.InputBase, __assign({
        name: name
      }, params, params.InputProps, {
        placeholder: placeholder,
        classes: {}
      }));
    }
  }));
}

var useStyles$d = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    radioContainer: {
      fontSize: 13,
      "& > label": {
        marginTop: 16,
        marginBottom: 4
      } // '& > div': {
      //   marginBottom: 8,
      // },

    },
    radioLabel: {
      color: "black",
      fontSize: 13
    },
    titleRadio: {
      fontSize: 12
    },
    errorLabel: {
      color: theme.palette.secondary.main + " !important"
    },
    radioGroup: {
      marginLeft: -6,
      "& > span": {
        padding: 4
      }
    },
    icon: {
      color: theme.palette.secondary.light,
      "& svg": {
        fontSize: "1.2rem"
      },
      "&$checked": {
        color: theme.palette.secondary.light
      }
    },
    horizontalRadios: {
      flexDirection: "row"
    },
    radioIcon: {
      marginLeft: 0
    },
    iconStyle: {
      width: 48,
      height: 48,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: 4,
      border: "0.2px solid rgba(92,92,92,0.3)",
      background: theme.palette.primary.light,
      borderRadius: 4,
      '&[data-checked="true"]': {
        background: theme.palette.secondary.main,
        borderColor: theme.palette.secondary.main,
        "& svg": {
          "& > g": {
            fill: "white"
          }
        }
      }
    },
    messageError: {
      color: theme.palette.text.hint,
      fontSize: 12
    }
  });
});

function Radios(props) {
  var required = props.required,
      label = props.label,
      items = props.items,
      value = props.value,
      name = props.name,
      error = props.error,
      horizontal = props.horizontal,
      icon = props.icon;
  var classes = useStyles$d();
  var defaultValue = value || null;

  var _a = React__default['default'].useState(defaultValue),
      stateValue = _a[0],
      setValue = _a[1];

  var _b = React__default['default'].useState(false),
      isDirtyRequired = _b[0],
      setDirtyRequired = _b[1];

  var onChange = function onChange(e) {
    setValue(e.target.value);

    if (props.onChange) {
      props.onChange(name, e.target.value);
    }

    if (!e.target.value && required) {
      setDirtyRequired(true);
    } else {
      setDirtyRequired(false);
    }
  };

  React$1.useEffect(function () {
    if (value) {
      setValue(value);
    }
  }, [value]);
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(core.FormControl, {
    className: classes.radioContainer
  }, label && /*#__PURE__*/React__default['default'].createElement(core.FormLabel, {
    className: classes.radioLabel,
    error: error ? true : false,
    classes: {
      root: classes.radioLabel,
      error: classes.errorLabel
    }
  }, label, required ? "*" : ""), /*#__PURE__*/React__default['default'].createElement(core.RadioGroup, {
    "aria-label": name,
    name: name,
    onChange: onChange,
    value: stateValue,
    className: horizontal ? classes.horizontalRadios : ""
  }, items.map(function (item, index) {
    return /*#__PURE__*/React__default['default'].createElement(core.FormControlLabel, {
      name: name + "-" + item.value,
      key: name + "-" + item.value,
      label: !icon && item.label,
      value: item.value,
      classes: {
        label: classes.titleRadio,
        root: !icon ? classes.radioGroup : classes.radioIcon
      },
      control: icon ? /*#__PURE__*/React__default['default'].createElement("div", {
        className: classes.iconStyle,
        "data-checked": value === item.value
      }, icon) : /*#__PURE__*/React__default['default'].createElement(core.Radio, {
        color: "default",
        classes: {
          root: classes.icon
        }
      })
    });
  }))), error && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, error), isDirtyRequired && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, "Ce champ est obligatoire"));
}

var useStyles$c = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    popoverFiltres: {
      marginLeft: 4,
      "& button": {
        cursor: "pointer",
        background: "none",
        border: "none",
        boxShadow: "none",
        fontSize: 14,
        color: theme.palette.primary.main,
        fontWeight: "normal",
        display: "flex",
        alignItems: "center",
        "&:hover": {
          "& svg": {
            "& > g": {
              fill: theme.palette.secondary.main
            }
          }
        },
        "&:active, &:focus": {
          outline: "none"
        }
      }
    },
    active: {
      "& svg": {
        "& > g": {
          fill: theme.palette.secondary.main
        }
      }
    },
    popover: {
      marginTop: 8,
      color: theme.palette.secondary.dark,
      background: "white",
      minWidth: "50px"
    },
    checkboxList: {
      display: "flex",
      padding: "8px 16px 4px 4px",
      flexDirection: "column",
      "& label": {
        margin: 0,
        color: theme.palette.secondary.dark,
        "& span": {
          fontSize: 13
        }
      }
    },
    buttonFilter: {
      marginLeft: 112,
      width: "fit-content",
      marginBottom: 8
    },
    searchList: {
      padding: 16
    },
    autocompleteList: {
      padding: 16,
      flexDirection: "column",
      alignItems: "flex-end",
      display: "flex",
      "& > button": {
        marginTop: 4,
        width: "fit-content",
        marginBottom: 4
      }
    },
    paperRoot: {
      boxShadow: "none",
      paddingLeft: 4,
      border: "1px solid #CCC",
      borderRadius: "0"
    },
    inputInput: {
      fontSize: 13
    },
    dateList: {
      padding: "0 16px 16px 16px"
    },
    containerInputs: {
      display: "flex",
      justifyContent: "space-evenly",
      padding: "0 8px",
      "& > div": {
        margin: "16px 8px 16px 8px",
        "& label": {
          fontSize: 13,
          color: theme.palette.secondary.dark,
          paddingBottom: 4
        }
      }
    },
    dateRoot: {
      border: "1px solid #CCC",
      fontSize: 13,
      paddingLeft: 8
    },
    dateInput: {
      width: 100
    },
    calendar: {
      width: "100%",
      border: "none",
      fontFamily: "Mulish",
      "& .react-datepicker__header ": {
        background: "none",
        border: "none",
        fontSize: 13
      },
      "& .react-datepicker__current-month": {
        textTransform: "uppercase"
      },
      "& .react-datepicker__month-container": {
        width: "100%"
      },
      "& .react-datepicker__month": {
        marginTop: 0
      },
      "& .react-datepicker__day, .react-datepicker__time-name": {
        width: "36px",
        height: "27px",
        margin: "4px 0",
        borderRadius: 12,
        "&:hover": {
          background: "#ffd3d1"
        },
        "&:focus": {
          outline: "none !important"
        }
      },
      "& .react-datepicker__day--today": {
        color: theme.palette.secondary.main
      },
      "& .react-datepicker__day-name": {
        width: "36px",
        height: "27px",
        margin: 0,
        "&:hover": {
          background: "none"
        }
      },
      "& .react-datepicker__day--disabled": {
        "&:hover": {
          background: "none !important"
        }
      },
      "& .react-datepicker__day--outside-month": {
        color: theme.palette.primary.main
      },
      "&  .react-datepicker__day--keyboard-selected": {
        background: "none",
        color: theme.palette.secondary.dark
      },
      "& .react-datepicker__day--selected": {
        borderRadius: 12,
        background: theme.palette.secondary.main,
        color: "white"
      },
      "& .react-datepicker__day--in-range, .react-datepicker__day--in-selecting-range": {
        borderRadius: 0,
        background: "#ffd3d1",
        color: theme.palette.secondary.dark
      },
      "& .react-datepicker__day--range-start, .react-datepicker__day--selecting-range-start": {
        borderRadius: "12px 0 0 12px"
      },
      "& .react-datepicker__day--range-end, .react-datepicker__day--selecting-range-end": {
        borderRadius: "0 12px 12px 0",
        "&.react-datepicker__day--range-start": {
          borderRadius: 12
        }
      },
      "&& .react-datepicker__day--range-start, .react-datepicker__day--selecting-range-start,  .react-datepicker__day--range-end, .react-datepicker__day--selecting-range-end": {
        position: "relative",
        color: "white",
        zIndex: 1,
        "&:after": {
          content: '" "',
          width: 36,
          height: 27,
          position: "absolute",
          left: 0,
          borderRadius: 12,
          zIndex: "-1",
          background: theme.palette.secondary.main
        }
      }
    }
  });
});

DatePicker$2.registerLocale("fr", locale);

function PopoverFiltres(props) {
  var id = props.id,
      buttonName = props.buttonName,
      list = props.list,
      onFilter = props.onFilter,
      type = props.type,
      filters = props.filters,
      maxLength = props.maxLength;
  var classes = useStyles$c();

  var _a = React$1.useState(null),
      anchorEl = _a[0],
      setAnchorEl = _a[1];

  var _b = React$1.useState(filters || []),
      selection = _b[0],
      setSelection = _b[1];

  var _c = React$1.useState(filters),
      searchValue = _c[0],
      setSearchValue = _c[1];

  var _d = React$1.useState(filters && filters.startDate && new Date(filters.startDate) || new Date()),
      startDate = _d[0],
      setStartDate = _d[1];

  var _e = React$1.useState(filters && filters.endDate && new Date(filters.endDate) || null),
      endDate = _e[0],
      setEndDate = _e[1];

  React$1.useEffect(function () {
    setStartDate(filters && filters.startDate && new Date(filters.startDate) || new Date());
    setEndDate(filters && filters.endDate && new Date(filters.endDate) || null);
  }, [filters]);
  React$1.useEffect(function () {
    setSelection(filters);
    setSearchValue(filters);
  }, [filters]);

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
    setSelection(filters || []);
  };

  var handleSelect = function handleSelect(name, value) {
    var valueOk = value ? name : undefined;

    if (valueOk) {
      var selectionState = selection ? __spreadArray(__spreadArray([], selection), [name]) : [name];
      setSelection(selectionState);
    } else {
      selection && setSelection(selection.filter(function (s) {
        return s !== name;
      }));
    }
  };

  var handleSelectAutocomplete = function handleSelectAutocomplete(name, value) {
    // @ts-ignore
    setSelection(value);
  };

  var handleSelectDate = function handleSelectDate(dates) {
    // @ts-ignore
    var start = dates[0],
        end = dates[1];
    setStartDate(start);
    setEndDate(end);
  };

  var handleChangeDateEnd = function handleChangeDateEnd(event) {
    var newDate = event.target.value.split("/").reverse().join("-");

    if (newDate && isValid(new Date(newDate))) {
      setEndDate(new Date(newDate));
    } else {
      setEndDate(null);
    }
  };

  var handleChangeDateStart = function handleChangeDateStart(event) {
    var newDate = event.target.value.split("/").reverse().join("-");

    if (newDate && isValid(new Date(newDate))) {
      setStartDate(new Date(newDate));
    } else {
      setStartDate(null);
    }
  };

  var handleFilters = function handleFilters(id, value) {
    handleClose();
    onFilter && onFilter(id, value);
  };

  var handleDateFilters = function handleDateFilters() {
    handleClose();
    onFilter && onFilter("date", {
      dateMin: startDate,
      dateMax: endDate
    });
  };

  var open = Boolean(anchorEl);
  var hasFilters = _typeof(filters) === "object" ? Object.values(filters).find(function (o) {
    return o === true;
  }) : filters;

  var handleKeypress = function handleKeypress(e) {
    if (e.key === "Enter") {
      handleFilters(id, searchValue);
    }
  };

  var handleSelectRadios = function handleSelectRadios(name, value) {
    // @ts-ignore
    setSelection(value);
  };

  var listRadio = type === "radio" && list;
  var listCheckbox = type === "checkbox" && list;
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.popoverFiltres
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    "aria-describedby": buttonName,
    onClick: handleClick,
    className: (open || hasFilters) && classes.active,
    "data-testid": "buttonFilters"
  }, (type === "checkbox" || type === "radio") && /*#__PURE__*/React__default['default'].createElement(Filtres, null), (type === "search" || type === "autocomplete") && /*#__PURE__*/React__default['default'].createElement(Loupe, null), type === "date" && /*#__PURE__*/React__default['default'].createElement(Date$1, {
    width: 16
  })), /*#__PURE__*/React__default['default'].createElement(core.Popover, {
    id: id,
    open: open,
    classes: {
      paper: classes.popover
    },
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "center"
    }
  }, type === "checkbox" && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.checkboxList
  }, listCheckbox && listCheckbox.map(function (l) {
    return /*#__PURE__*/React__default['default'].createElement(Checkbox, {
      key: l.id,
      name: l.id.toString(),
      label: l.value,
      onChange: handleSelect,
      value: filters && filters.find(function (f) {
        return f === l.id;
      })
    });
  }), /*#__PURE__*/React__default['default'].createElement(Button, {
    variant: "contained",
    color: "primary",
    title: "Ok",
    onClick: function onClick() {
      return handleFilters(id, selection);
    },
    className: classes.buttonFilter
  })), " ", type === "radio" && listRadio && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.checkboxList
  }, /*#__PURE__*/React__default['default'].createElement(Radios, {
    name: id,
    items: listRadio,
    onChange: handleSelectRadios,
    value: filters && filters
  }), /*#__PURE__*/React__default['default'].createElement(Button, {
    variant: "contained",
    color: "primary",
    title: "Ok",
    onClick: function onClick() {
      return handleFilters(id, selection);
    },
    className: classes.buttonFilter
  })), type === "search" && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.searchList
  }, /*#__PURE__*/React__default['default'].createElement(core.Paper, {
    classes: {
      root: classes.paperRoot
    }
  }, /*#__PURE__*/React__default['default'].createElement(core.InputBase, {
    inputProps: {
      maxLength: maxLength || 30,
      "aria-label": "rechercher",
      autoFocus: true
    },
    classes: {
      input: classes.inputInput
    },
    onKeyPress: handleKeypress,
    value: searchValue,
    onChange: function onChange(e) {
      return setSearchValue(e.target.value);
    }
  }), " ", /*#__PURE__*/React__default['default'].createElement(core.IconButton, {
    "aria-label": "rechercher nom",
    disableFocusRipple: true,
    disableRipple: true,
    onClick: function onClick() {
      return handleFilters(id, searchValue);
    }
  }, /*#__PURE__*/React__default['default'].createElement(Loupe, null)))), type === "date" && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.dateList
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.containerInputs
  }, /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(core.InputLabel, {
    htmlFor: "startDate"
  }, "Date de d\xE9but"), /*#__PURE__*/React__default['default'].createElement(core.InputBase, {
    name: "startDate",
    id: "startDate",
    required: true,
    classes: {
      root: classes.dateRoot,
      input: classes.dateInput
    },
    inputComponent: function inputComponent(props) {
      return /*#__PURE__*/React__default['default'].createElement(MaskedInput, __assign({}, props, {
        mask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]
      }));
    },
    placeholder: "jj/mm/aaaa",
    onBlur: handleChangeDateStart,
    value: startDate && formatDateCourt(startDate)
  })), /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(core.InputLabel, {
    htmlFor: "endDate"
  }, "Date de fin"), /*#__PURE__*/React__default['default'].createElement(core.InputBase, {
    name: "endDate",
    id: "endDate",
    classes: {
      root: classes.dateRoot,
      input: classes.dateInput
    },
    inputComponent: function inputComponent(props) {
      return /*#__PURE__*/React__default['default'].createElement(MaskedInput, __assign({}, props, {
        mask: [/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]
      }));
    },
    placeholder: "jj/mm/aaaa",
    onBlur: handleChangeDateEnd,
    value: endDate && formatDateCourt(endDate)
  }))), /*#__PURE__*/React__default['default'].createElement(DatePicker__default['default'], {
    selected: startDate,
    onChange: handleSelectDate,
    startDate: startDate,
    endDate: endDate,
    filterDate: function filterDate(date) {
      return new Date() > date;
    },
    selectsRange: true,
    inline: true,
    locale: "fr",
    calendarClassName: classes.calendar
  }), /*#__PURE__*/React__default['default'].createElement(core.Grid, {
    container: true,
    justifyContent: "flex-end"
  }, startDate === null ? /*#__PURE__*/React__default['default'].createElement(core.Typography, {
    color: "error",
    variant: "caption"
  }, "Saisir une date de d\xE9but") : /*#__PURE__*/React__default['default'].createElement(Button, {
    variant: "contained",
    color: "primary",
    title: "Ok",
    onClick: function onClick() {
      return handleDateFilters();
    }
  }))), type === "autocomplete" && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.autocompleteList
  }, /*#__PURE__*/React__default['default'].createElement(AutoComplete$2, {
    name: "autocomplete",
    onChange: handleSelectAutocomplete,
    value: filters,
    getOptions: list
  }), /*#__PURE__*/React__default['default'].createElement(Button, {
    variant: "contained",
    color: "primary",
    title: "Ok",
    onClick: function onClick() {
      return handleFilters(id, selection);
    }
  }))));
}

var useStyles$b = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    popoverList: {
      "& button": {
        cursor: "pointer",
        background: "none",
        border: "none",
        boxShadow: "none",
        fontSize: 14,
        color: grisMoyen,
        fontWeight: "normal",
        display: "flex",
        alignItems: "center",
        "&:hover": {
          color: primaryBlack,
          "& $icon": {
            "& > g": {
              fill: primaryBlack
            }
          },
          // si buttonName est une icône
          "& svg": {
            color: primaryBlack
          }
        },
        "&:active, &:focus": {
          outline: "none"
        },
        "&[disabled]": {
          cursor: "initial",
          "&:hover": {
            color: grisMoyen
          }
        }
      }
    },
    icon: {
      marginLeft: 10,
      "& > g": {
        fill: grisMoyen
      }
    },
    subMenuList: {
      marginTop: 2,
      "& button": {
        fontSize: 18,
        paddingLeft: 0,
        fontWeight: 300
      }
    },
    active: {
      color: primaryBlack,
      "& $icon": {
        transform: "rotate(-180deg)",
        "& > g": {
          fill: primaryBlack
        }
      }
    },
    popover: {
      marginTop: 8,
      borderRadius: 12,
      color: theme.palette.secondary.dark,
      background: "white",
      border: "1px solid " + theme.palette.secondary.main,
      padding: "16px 16px 4px 16px",
      minWidth: "50px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      "& button": {
        marginBottom: 12,
        textAlign: "left",
        justifyContent: "flex-start",
        "&:hover": {
          color: theme.palette.secondary.light
        },
        "&:active, &:focus": {
          outline: "none"
        }
      },
      "& label": {
        margin: 0
      }
    },
    popoverSubMenu: {
      marginTop: 8,
      padding: "8px 0",
      maxHeight: "40vh",
      overflow: "auto",
      display: "flex",
      flexDirection: "column",
      "& button": {
        color: theme.palette.secondary.dark,
        textAlign: "left",
        width: "100%",
        fontWeight: 400,
        background: "none",
        border: "none",
        textDecoration: "none",
        display: "flex",
        justifyContent: "flex-start",
        boxShadow: "none",
        cursor: "pointer",
        fontSize: "1rem",
        lineHeight: "1.5",
        padding: "6px 16px 6px 16px",
        "&:focus, &:hover": {
          background: "rgba(0, 0, 0, 0.04)"
        }
      }
    },
    classNameButton: {
      textDecoration: "underline"
    },
    activeValue: {
      color: theme.palette.secondary.light
    },
    withArrow: {
      "& svg": {
        transform: "rotate(180deg)",
        "& > g": {
          fill: theme.palette.secondary.main
        }
      }
    },
    messageColumn: {
      padding: "0 0 12px 8px"
    }
  });
});

function PopoverComponent(props) {
  var id = props.id,
      buttonName = props.buttonName,
      list = props.list,
      onSelect = props.onSelect,
      onClose = props.onClose,
      anchorEl = props.anchorEl,
      withArrow = props.withArrow,
      subMenu = props.subMenu,
      checkbox = props.checkbox,
      selectedCheckbox = props.selectedCheckbox,
      onSelectCheckbox = props.onSelectCheckbox;
  var classes = useStyles$b();
  var open = Boolean(anchorEl);
  return /*#__PURE__*/React__default['default'].createElement(core.Popover, {
    id: id,
    open: open,
    classes: {
      paper: subMenu ? classes.popoverSubMenu : classes.popover
    },
    anchorEl: anchorEl,
    onClose: onClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: subMenu ? "left" : "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: subMenu ? "left" : "right"
    }
  }, list.map(function (l) {
    var classNameButton = "";
    if (l.value === buttonName) classNameButton += " " + classes.activeValue;
    if (withArrow) classNameButton += " " + classes.withArrow;

    if (checkbox) {
      return /*#__PURE__*/React__default['default'].createElement(Checkbox, {
        key: l.id,
        name: l.id.toString(),
        label: l.value,
        onChange: onSelectCheckbox && onSelectCheckbox,
        value: selectedCheckbox && selectedCheckbox[l.id],
        disabled: l.id === "nom" || selectedCheckbox && Object.values(selectedCheckbox).filter(function (value) {
          return value === true;
        }).length > 5 && !selectedCheckbox[l.id]
      });
    }

    return /*#__PURE__*/React__default['default'].createElement(Button, {
      variant: "text",
      color: "primary",
      icon: withArrow ? /*#__PURE__*/React__default['default'].createElement(Fleche, {
        width: 14
      }) : undefined,
      key: l.id,
      className: classNameButton,
      onClick: function onClick() {
        return onSelect && onSelect(l.id);
      },
      title: l.value
    });
  }), selectedCheckbox && Object.values(selectedCheckbox).filter(function (value) {
    return value === true;
  }).length > 5 && /*#__PURE__*/React__default['default'].createElement(core.Typography, {
    variant: "caption",
    color: "error",
    className: classes.messageColumn
  }, "6 colonnes maximum"));
}

function PopoverList(props) {
  var id = props.id,
      buttonName = props.buttonName,
      list = props.list,
      onSelect = props.onSelect,
      subMenu = props.subMenu,
      noArrow = props.noArrow,
      checkbox = props.checkbox,
      onSelectCheckbox = props.onSelectCheckbox,
      selectedCheckbox = props.selectedCheckbox;
  var classes = useStyles$b();

  var _a = React__default['default'].useState(null),
      anchorEl = _a[0],
      setAnchorEl = _a[1];

  var _b = React$1.useState(selectedCheckbox),
      stateSelectedCheckbox = _b[0],
      setSelectedCheckbox = _b[1];

  React$1.useEffect(function () {
    setSelectedCheckbox(selectedCheckbox);
  }, [selectedCheckbox]);

  var handleClick = function handleClick(event) {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var handleSelect = function handleSelect(listId) {
    handleClose();
    onSelect && onSelect(listId, id);
  };

  var handleSelectCheckbox = function handleSelectCheckbox(id, value) {
    var _a, _b;

    setSelectedCheckbox(__assign(__assign({}, stateSelectedCheckbox), (_a = {}, _a[id] = value, _a)));
    onSelectCheckbox && onSelectCheckbox(__assign(__assign({}, stateSelectedCheckbox), (_b = {}, _b[id] = value, _b)));
  };

  var classNamePopover = classes.popoverList;

  if (subMenu) {
    classNamePopover += " " + classes.subMenuList;
  }

  var open = Boolean(anchorEl);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classNamePopover
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    "aria-describedby": id,
    onClick: handleClick,
    disabled: !list,
    className: open ? classes.active : "",
    "data-testid": "buttonToggle"
  }, buttonName, " ", list && !noArrow && /*#__PURE__*/React__default['default'].createElement(Ouvrir, {
    className: classes.icon,
    width: 14
  })), list && /*#__PURE__*/React__default['default'].createElement(PopoverComponent, {
    checkbox: checkbox,
    subMenu: subMenu,
    onSelect: handleSelect,
    onSelectCheckbox: handleSelectCheckbox,
    selectedCheckbox: stateSelectedCheckbox,
    onClose: handleClose,
    list: list,
    id: id,
    buttonName: buttonName,
    anchorEl: anchorEl
  }));
}

var useStyles$a = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    card: {
      padding: 24,
      background: "white",
      boxShadow: "2px 3px 13px -2px #C2C2C2",
      borderRadius: 12,
      //minWidth: '50%',
      "& h3": {
        margin: 0,
        marginBottom: 24
      },
      position: "relative"
    },
    snackContent: {
      boxShadow: "2px 3px 13px -2px #C2C2C2",
      borderRadius: 12,
      background: "white",
      color: theme.palette.secondary.dark,
      padding: "0 24px 0 12px ",
      "& p": {
        margin: 0,
        fontWeight: "bold",
        fontSize: 16
      },
      "& a": {
        fontSize: 16,
        marginTop: 4
      }
    },
    message: {
      display: "flex"
    },
    borderLeft: {
      marginRight: 12,
      background: theme.palette.success.main,
      height: "100%",
      borderRadius: 5,
      width: 5
    },
    borderError: {
      background: theme.palette.secondary.main
    },
    borderInfo: {
      background: theme.palette.secondary.dark
    },
    messageTexte: {
      padding: "8px 0",
      "& > span": {
        fontSize: 12,
        color: theme.palette.primary.dark
      }
    }
  });
});

function Snack(props) {
  var type = props.type,
      message = props.message,
      onClose = props.onClose,
      link = props.link,
      linkTexte = props.linkTexte,
      fetching = props.fetching,
      onClick = props.onClick;
  var classes = useStyles$a();

  var handleClose = function handleClose(event, reason) {
    onClose();
  };

  var classNameSnack = classes.borderLeft;

  if (type === "error") {
    classNameSnack += " " + classes.borderError;
  } else if (type === "info") {
    classNameSnack += " " + classes.borderInfo;
  }

  return /*#__PURE__*/React__default['default'].createElement(core.Snackbar, {
    anchorOrigin: {
      vertical: "top",
      horizontal: "right"
    },
    open: true,
    action: /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(core.IconButton, {
      size: "small",
      "aria-label": "close",
      color: "inherit",
      onClick: handleClose
    }, /*#__PURE__*/React__default['default'].createElement(default_1, {
      fontSize: "small"
    })))
  }, /*#__PURE__*/React__default['default'].createElement(Alert$1, {
    severity: type,
    icon: false,
    onClose: handleClose,
    className: classes.snackContent,
    classes: {
      message: classes.message
    }
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    "data-testid": "colorSnack",
    className: classNameSnack
  }), /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageTexte
  }, /*#__PURE__*/React__default['default'].createElement("span", null, "Notification"), /*#__PURE__*/React__default['default'].createElement("p", {
    dangerouslySetInnerHTML: {
      __html: message
    }
  }), link && linkTexte && onClick && /*#__PURE__*/React__default['default'].createElement(Button, {
    onClick: onClick,
    color: "primary",
    variant: "text",
    fetching: fetching,
    title: linkTexte
  }))));
}

var useStyles$9 = styles$6.makeStyles(function (theme) {
  return styles$6.createStyles({
    tabs: {
      minHeight: 34
    },
    tabTitle: {
      textTransform: "inherit",
      padding: 0,
      minHeight: 34,
      minWidth: 60,
      margin: "0 16px",
      fontSize: 14,
      fontWeight: "bold",
      fontFamily: "Poppins",
      "& +$tabTitle": {
        minWidth: 72
      }
    },
    indicator: {
      height: 4,
      borderRadius: 2
    },
    selectedTab: {
      color: theme.palette.secondary.main
    }
  });
});

function a11yProps(index) {
  return {
    id: "onglet-" + index,
    "aria-controls": "onglet-panel-" + index
  };
}

function TabPanel(props) {
  var children = props.children,
      value = props.value,
      index = props.index,
      other = __rest(props, ["children", "value", "index"]);

  return /*#__PURE__*/React__default['default'].createElement("div", __assign({
    role: "tabpanel",
    hidden: value !== index,
    id: "onglet-panel-" + index,
    "aria-labelledby": "onglet-" + index
  }, other), value === index && /*#__PURE__*/React__default['default'].createElement(core.Box, null, /*#__PURE__*/React__default['default'].createElement(core.Typography, null, children)));
}

function Tabs(props) {
  var activeValue = props.activeValue,
      tabs = props.tabs,
      modificationMode = props.modificationMode,
      setBlockTab = props.setBlockTab,
      redirectTab = props.redirectTab,
      onChange = props.onChange;
  var classes = useStyles$9();

  var _a = React__default['default'].useState(activeValue || 0),
      value = _a[0],
      setValue = _a[1];

  var handleChange = function handleChange(event, newValue) {
    if (modificationMode && value === 0 && setBlockTab) {
      setBlockTab(true);
    } else {
      setValue(newValue);
      setBlockTab && setBlockTab(false);
    }

    if (onChange) {
      onChange(newValue);
    }
  };

  React$1.useEffect(function () {
    if (activeValue || activeValue === 0) {
      setValue(activeValue);
    }
  }, [activeValue]);
  React$1.useEffect(function () {
    if (redirectTab && setBlockTab) {
      setValue(1);
      setBlockTab(false);
    }
  }, [redirectTab]);
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(core.Tabs, {
    value: value,
    onChange: handleChange,
    "aria-label": "simple tabs example",
    classes: {
      root: classes.tabs,
      indicator: classes.indicator
    },
    scrollButtons: "on",
    variant: "scrollable"
  }, tabs.map(function (t) {
    return /*#__PURE__*/React__default['default'].createElement(core.Tab, __assign({
      classes: {
        root: classes.tabTitle,
        selected: classes.selectedTab
      },
      label: t.title
    }, a11yProps(t.index)));
  })), tabs.map(function (t) {
    return /*#__PURE__*/React__default['default'].createElement(TabPanel, {
      value: value,
      index: t.index
    }, t.content);
  }));
}

function AutoComplete$1(props) {
  var label = props.label,
      name = props.name,
      value = props.value,
      required = props.required,
      error = props.error,
      fetchOptions = props.fetchOptions,
      getOptions = props.getOptions,
      loading = props.loading,
      placeholder = props.placeholder,
      errors = props.errors,
      disabled = props.disabled;
  var classes = useStyles$h();
  var defaultValue = value || null;

  var _a = React__default['default'].useState(defaultValue),
      stateValue = _a[0],
      setStateValue = _a[1];

  var _b = React__default['default'].useState(defaultValue),
      inputValue = _b[0],
      setInputValue = _b[1];

  var _c = React__default['default'].useState(getOptions || []),
      options = _c[0],
      setOptions = _c[1];

  var _d = React__default['default'].useState(false),
      isDirtyRequired = _d[0],
      setDirtyRequired = _d[1];

  var _onChange = function onChange(e, newValue) {
    e.preventDefault();
    setStateValue(newValue);

    if (getOptions) {
      var optionsSelected = getOptions.find(function (opt) {
        return opt.id && newValue && opt.id === newValue.id;
      });
      props.onChange(name, optionsSelected);
    }

    if (!newValue && required) {
      setDirtyRequired(true);
    } else {
      setDirtyRequired(false);
    }
  };

  var _onInputChange = function onInputChange(e, newValue) {
    setInputValue(newValue);

    if (newValue.length > 3 && fetchOptions && newValue.match(/^\d+$/)) {
      fetchOptions(newValue);
    } else {
      setOptions([]);
    }

    var value = getOptions;

    if (value && newValue.length > 3) {
      setOptions(value);
    } else {
      setOptions([]);
    }
  };

  var handleBlur = function handleBlur(e) {
    if (!e.target.value && required) {
      setDirtyRequired(true);
    } else {
      setDirtyRequired(false);
    }
  };

  React$1.useEffect(function () {
    if (!inputValue || inputValue && inputValue.length <= 3) {
      setOptions([]);
      return undefined;
    }

    if (getOptions) {
      setOptions(getOptions);
    }

    return function () {};
  }, [inputValue, getOptions]);
  React$1.useEffect(function () {
    if (value) {
      setInputValue(value);
      setStateValue(value);
    } else {
      setInputValue("");
      setStateValue("");
    }
  }, [value]);
  var requiredAsterisk = required ? " *" : "";
  return /*#__PURE__*/React__default['default'].createElement(core.FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/React__default['default'].createElement(Autocomplete$1, {
    disabled: disabled,
    classes: {
      inputRoot: classes.inputAutoComplete,
      popupIndicator: classes.popupIcon,
      popupIndicatorOpen: classes.popupIcon
    },
    id: name,
    getOptionLabel: function getOptionLabel(option) {
      return option.value;
    },
    loading: loading || false,
    options: options,
    value: stateValue,
    onChange: function onChange(event, newValue) {
      _onChange(event, newValue);
    },
    onBlur: handleBlur,
    debug: true,
    popupIcon: /*#__PURE__*/React__default['default'].createElement(ExpandMore, null),
    onInputChange: function onInputChange(event, newValue) {
      _onInputChange(event, newValue);
    },
    // TODO traduction
    noOptionsText: !inputValue || inputValue && inputValue.length <= 3 ? "Saisir un code postal (ex. 75000)" : "Aucun résultat",
    renderInput: function renderInput(params) {
      return /*#__PURE__*/React__default['default'].createElement(core.TextField, __assign({
        name: name
      }, params, {
        placeholder: placeholder,
        autoComplete: "off",
        error: error || isDirtyRequired || errors ? true : false,
        InputProps: __assign(__assign({}, params.InputProps), {
          classes: {
            root: classes.input,
            error: classes.errorInput,
            focused: classes.focused,
            disabled: classes.disabledInput
          },
          endAdornment: /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, loading ? /*#__PURE__*/React__default['default'].createElement(LoadingIcon, {
            size: "small"
          }) : null, params.InputProps.endAdornment)
        }),
        InputLabelProps: {
          shrink: true,
          classes: {
            root: classes.label,
            error: classes.errorLabel,
            disabled: classes.disabledLabel
          }
        },
        label: label ? label + requiredAsterisk : "",
        margin: "normal",
        fullWidth: true
      }));
    }
  }), error && /*#__PURE__*/React__default['default'].createElement("span", null, error), " ", (isDirtyRequired || errors && errors.type === "required") && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, "Ce champ est obligatoire"));
}

function AutoComplete(props) {
  var noAsyncList = props.noAsyncList,
      label = props.label,
      name = props.name,
      value = props.value,
      required = props.required,
      error = props.error,
      fetchOptions = props.fetchOptions,
      getOptions = props.getOptions,
      loading = props.loading,
      placeholder = props.placeholder,
      errors = props.errors,
      startFilter = props.startFilter,
      disabled = props.disabled,
      noDelete = props.noDelete,
      tooltip = props.tooltip,
      autofocus = props.autofocus,
      noStateChange = props.noStateChange;
  var classes = useStyles$h();

  var _a = React__default['default'].useState(getOptions || []),
      options = _a[0],
      setOptions = _a[1];

  var isReadOnly = disabled;
  var defaultValue = options.find(function (o) {
    return o.id === value;
  }) || null;

  if (options && options.length === 1) {
    defaultValue = options[0];
    isReadOnly = true;
  }

  var _b = React__default['default'].useState(defaultValue),
      stateValue = _b[0],
      setStateValue = _b[1];

  var _c = React__default['default'].useState(false),
      isDirtyRequired = _c[0],
      setDirtyRequired = _c[1];

  var _onChange = function onChange(e, newValue, reason) {
    e.preventDefault();

    if (!noStateChange) {
      setStateValue(newValue);
    }

    if (getOptions) {
      var optionsSelected = getOptions.find(function (opt) {
        return opt.id && newValue && opt.id === newValue.id;
      });
      props.onChange(name, optionsSelected && optionsSelected.id);
    }

    if (!newValue && required) {
      setDirtyRequired(true);
    } else {
      setDirtyRequired(false);
    }

    if (reason === "clear") {
      setStateValue(null);

      if (props.onChange) {
        props.onChange(name, null);
      }

      if (required) {
        setDirtyRequired(true);
      } else {
        setDirtyRequired(false);
      }
    }
  };

  var onInputChange = function onInputChange(e, newValue) {
    setStateValue(newValue);

    if (newValue.length > 3 && fetchOptions) {
      fetchOptions(newValue);
    }

    var value = getOptions;

    if (value) {
      setOptions(value);
    }
  };

  var handleBlur = function handleBlur(e) {
    if (!e.target.value && required) {
      setDirtyRequired(true);
    } else {
      setDirtyRequired(false);
    }
  };

  React$1.useEffect(function () {
    if (getOptions) {
      setOptions(getOptions);
    }

    return function () {};
  }, [getOptions]);
  React$1.useEffect(function () {
    if (value && (options === null || options === void 0 ? void 0 : options.find(function (o) {
      return o.id === value;
    }))) {
      setStateValue((options === null || options === void 0 ? void 0 : options.find(function (o) {
        return o.id === value;
      })) || null);
      setDirtyRequired(false);
    } else if (options && options.length === 1) {
      setStateValue(options[0]);
      isReadOnly = true;

      if (props.onChange) {
        props.onChange(name, options[0].id);
      }
    } else {
      setStateValue(null);
    }
  }, [value, options]);
  var filterOptions = createFilterOptions({
    matchFrom: "start",
    stringify: function stringify(option) {
      return option.value;
    }
  });
  var requiredAsterisk = required ? " *" : "";
  var labelValue = options && options.find(function (o) {
    return o.id === value;
  });

  var textField = function textField(params) {
    return /*#__PURE__*/React__default['default'].createElement(core.TextField, __assign({
      name: name,
      autoFocus: autofocus
    }, params, {
      placeholder: placeholder,
      autoComplete: "off",
      error: error || isDirtyRequired || errors ? true : false,
      InputProps: __assign(__assign({}, params.InputProps), {
        classes: {
          root: classes.input,
          error: classes.errorInput,
          focused: classes.focused,
          disabled: classes.disabledInput
        },
        endAdornment: /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, loading ? /*#__PURE__*/React__default['default'].createElement(LoadingIcon, {
          size: "small"
        }) : null, params.InputProps.endAdornment)
      }),
      InputLabelProps: {
        shrink: true,
        classes: {
          root: classes.label,
          error: classes.errorLabel,
          disabled: classes.disabledLabel
        }
      },
      label: label ? label + requiredAsterisk : "",
      margin: "normal",
      fullWidth: true
    }));
  };

  return /*#__PURE__*/React__default['default'].createElement(core.FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/React__default['default'].createElement(Autocomplete$1, {
    disabled: isReadOnly,
    classes: {
      inputRoot: classes.inputAutoComplete,
      popupIndicator: classes.popupIcon,
      popupIndicatorOpen: classes.popupIcon,
      option: classes.listElement
    },
    disableClearable: noDelete,
    filterOptions: startFilter ? filterOptions : undefined,
    id: name,
    getOptionLabel: function getOptionLabel(option) {
      return option.value;
    },
    getOptionSelected: function getOptionSelected(option, value) {
      return option.id === value.id;
    },
    loading: loading || false,
    options: options,
    value: stateValue,
    onChange: function onChange(event, newValue, reason) {
      _onChange(event, newValue, reason);
    },
    onBlur: handleBlur,
    popupIcon: /*#__PURE__*/React__default['default'].createElement(ExpandMore, null),
    onInputChange: noAsyncList ? undefined : function (event, newValue) {
      onInputChange(event, newValue);
    },
    // TODO traduction
    noOptionsText: "Pas d'options",
    renderInput: function renderInput(params) {
      return tooltip ? /*#__PURE__*/React__default['default'].createElement(core.Tooltip, {
        title: labelValue && labelValue.value || ""
      }, textField(params)) : textField(params);
    }
  }), error && /*#__PURE__*/React__default['default'].createElement("span", null, error), " ", (isDirtyRequired || errors && errors.type === "required") && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, "Ce champ est obligatoire"));
}

var MuiPickersContext = React$1.createContext(null);
var MuiPickersUtilsProvider = function MuiPickersUtilsProvider(_ref) {
  var Utils = _ref.utils,
      children = _ref.children,
      locale = _ref.locale,
      libInstance = _ref.libInstance;
  var utils = React$1.useMemo(function () {
    return new Utils({
      locale: locale,
      instance: libInstance
    });
  }, [Utils, libInstance, locale]);
  return React$1.createElement(MuiPickersContext.Provider, {
    value: utils,
    children: children
  });
};
process.env.NODE_ENV !== "production" ? MuiPickersUtilsProvider.propTypes = {
  utils: propTypes.exports.func.isRequired,
  locale: propTypes.exports.oneOfType([propTypes.exports.object, propTypes.exports.string]),
  children: propTypes.exports.oneOfType([propTypes.exports.element.isRequired, propTypes.exports.arrayOf(propTypes.exports.element.isRequired)]).isRequired
} : void 0;

var checkUtils = function checkUtils(utils) {
  if (!utils) {
    // tslint:disable-next-line
    throw new Error('Can not find utils in context. You either a) forgot to wrap your component tree in MuiPickersUtilsProvider; or b) mixed named and direct file imports.  Recommendation: use named imports from the module index.');
  }
};
function useUtils() {
  var utils = React$1.useContext(MuiPickersContext);
  checkUtils(utils);
  return utils;
}

/** Use it instead of .includes method for IE support */
function arrayIncludes(array, itemOrItems) {
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every(function (item) {
      return array.indexOf(item) !== -1;
    });
  }

  return array.indexOf(itemOrItems) !== -1;
}

var DIALOG_WIDTH = 310;
var DIALOG_WIDTH_WIDER = 325;
var VIEW_HEIGHT = 305;

var useStyles$8 = styles$6.makeStyles(function (theme) {
  return {
    staticWrapperRoot: {
      overflow: 'hidden',
      minWidth: DIALOG_WIDTH,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.background.paper
    }
  };
}, {
  name: 'MuiPickersStaticWrapper'
});
var StaticWrapper = function StaticWrapper(_ref) {
  var children = _ref.children;
  var classes = useStyles$8();
  return React$1.createElement("div", {
    className: classes.staticWrapperRoot,
    children: children
  });
};

var ModalDialog = function ModalDialog(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      onAccept = _ref.onAccept,
      onDismiss = _ref.onDismiss,
      onClear = _ref.onClear,
      onSetToday = _ref.onSetToday,
      okLabel = _ref.okLabel,
      cancelLabel = _ref.cancelLabel,
      clearLabel = _ref.clearLabel,
      todayLabel = _ref.todayLabel,
      clearable = _ref.clearable,
      showTodayButton = _ref.showTodayButton;
      _ref.showTabs;
      var wider = _ref.wider,
      other = _objectWithoutProperties(_ref, ["children", "classes", "onAccept", "onDismiss", "onClear", "onSetToday", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "clearable", "showTodayButton", "showTabs", "wider"]);

  return React$1.createElement(Dialog__default['default'], _extends({
    role: "dialog",
    onClose: onDismiss,
    classes: {
      paper: clsx(classes.dialogRoot, wider && classes.dialogRootWider)
    }
  }, other), React$1.createElement(DialogContent__default['default'], {
    children: children,
    className: classes.dialog
  }), React$1.createElement(DialogActions__default['default'], {
    classes: {
      root: clsx((clearable || showTodayButton) && classes.withAdditionalAction)
    }
  }, clearable && React$1.createElement(Button__default['default'], {
    color: "primary",
    onClick: onClear
  }, clearLabel), showTodayButton && React$1.createElement(Button__default['default'], {
    color: "primary",
    onClick: onSetToday
  }, todayLabel), cancelLabel && React$1.createElement(Button__default['default'], {
    color: "primary",
    onClick: onDismiss
  }, cancelLabel), okLabel && React$1.createElement(Button__default['default'], {
    color: "primary",
    onClick: onAccept
  }, okLabel)));
};
ModalDialog.displayName = 'ModalDialog';
var styles$3 = styles$6.createStyles({
  dialogRoot: {
    minWidth: DIALOG_WIDTH
  },
  dialogRootWider: {
    minWidth: DIALOG_WIDTH_WIDER
  },
  dialog: {
    '&:first-child': {
      padding: 0
    }
  },
  withAdditionalAction: {
    // set justifyContent to default value to fix IE11 layout bug
    // see https://github.com/dmtrKovalenko/material-ui-pickers/pull/267
    justifyContent: 'flex-start',
    '& > *:first-child': {
      marginRight: 'auto'
    }
  }
});
var ModalDialog$1 = styles$6.withStyles(styles$3, {
  name: 'MuiPickersModal'
})(ModalDialog);

var useIsomorphicEffect = typeof window === 'undefined' ? React$1.useEffect : React$1.useLayoutEffect;
function runKeyHandler(e, keyHandlers) {
  var handler = keyHandlers[e.key];

  if (handler) {
    handler(); // if event was handled prevent other side effects (e.g. page scroll)

    e.preventDefault();
  }
}
function useKeyDown(active, keyHandlers) {
  var keyHandlersRef = React$1.useRef(keyHandlers);
  keyHandlersRef.current = keyHandlers;
  useIsomorphicEffect(function () {
    if (active) {
      var handleKeyDown = function handleKeyDown(event) {
        runKeyHandler(event, keyHandlersRef.current);
      };

      window.addEventListener('keydown', handleKeyDown);
      return function () {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [active]);
}

var ModalWrapper = function ModalWrapper(_ref) {
  var open = _ref.open,
      children = _ref.children,
      okLabel = _ref.okLabel,
      cancelLabel = _ref.cancelLabel,
      clearLabel = _ref.clearLabel,
      todayLabel = _ref.todayLabel,
      showTodayButton = _ref.showTodayButton,
      clearable = _ref.clearable,
      DialogProps = _ref.DialogProps,
      showTabs = _ref.showTabs,
      wider = _ref.wider,
      InputComponent = _ref.InputComponent,
      DateInputProps = _ref.DateInputProps,
      onClear = _ref.onClear,
      onAccept = _ref.onAccept,
      onDismiss = _ref.onDismiss,
      onSetToday = _ref.onSetToday,
      other = _objectWithoutProperties(_ref, ["open", "children", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "showTodayButton", "clearable", "DialogProps", "showTabs", "wider", "InputComponent", "DateInputProps", "onClear", "onAccept", "onDismiss", "onSetToday"]);

  useKeyDown(open, {
    Enter: onAccept
  });
  return React$1.createElement(React$1.Fragment, null, React$1.createElement(InputComponent, _extends({}, other, DateInputProps)), React$1.createElement(ModalDialog$1, _extends({
    wider: wider,
    showTabs: showTabs,
    open: open,
    onClear: onClear,
    onAccept: onAccept,
    onDismiss: onDismiss,
    onSetToday: onSetToday,
    clearLabel: clearLabel,
    todayLabel: todayLabel,
    okLabel: okLabel,
    cancelLabel: cancelLabel,
    clearable: clearable,
    showTodayButton: showTodayButton,
    children: children
  }, DialogProps)));
};
process.env.NODE_ENV !== "production" ? ModalWrapper.propTypes = {
  okLabel: propTypes.exports.node,
  cancelLabel: propTypes.exports.node,
  clearLabel: propTypes.exports.node,
  clearable: propTypes.exports.bool,
  todayLabel: propTypes.exports.node,
  showTodayButton: propTypes.exports.bool,
  DialogProps: propTypes.exports.object
} : void 0;
ModalWrapper.defaultProps = {
  okLabel: 'OK',
  cancelLabel: 'Cancel',
  clearLabel: 'Clear',
  todayLabel: 'Today',
  clearable: false,
  showTodayButton: false
};

var InlineWrapper = function InlineWrapper(_ref) {
  var open = _ref.open;
      _ref.wider;
      var children = _ref.children,
      PopoverProps = _ref.PopoverProps;
      _ref.onClear;
      var onDismiss = _ref.onDismiss;
      _ref.onSetToday;
      var onAccept = _ref.onAccept;
      _ref.showTabs;
      var DateInputProps = _ref.DateInputProps,
      InputComponent = _ref.InputComponent,
      other = _objectWithoutProperties(_ref, ["open", "wider", "children", "PopoverProps", "onClear", "onDismiss", "onSetToday", "onAccept", "showTabs", "DateInputProps", "InputComponent"]);

  var ref = React$1.useRef();
  useKeyDown(open, {
    Enter: onAccept
  });
  return React$1.createElement(React$1.Fragment, null, React$1.createElement(InputComponent, _extends({}, other, DateInputProps, {
    inputRef: ref
  })), React$1.createElement(Popover__default['default'], _extends({
    open: open,
    onClose: onDismiss,
    anchorEl: ref.current,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    children: children
  }, PopoverProps)));
};
process.env.NODE_ENV !== "production" ? InlineWrapper.propTypes = {
  onOpen: propTypes.exports.func,
  onClose: propTypes.exports.func,
  PopoverProps: propTypes.exports.object
} : void 0;

function getWrapperFromVariant(variant) {
  switch (variant) {
    case 'inline':
      return InlineWrapper;

    case 'static':
      return StaticWrapper;

    default:
      return ModalWrapper;
  }
}
var VariantContext = React$1.createContext(null);
var Wrapper = function Wrapper(_ref) {
  var variant = _ref.variant,
      props = _objectWithoutProperties(_ref, ["variant"]);

  var Component = getWrapperFromVariant(variant);
  return React$1.createElement(VariantContext.Provider, {
    value: variant || 'dialog'
  }, React$1.createElement(Component, props));
};

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

var Rifm =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Rifm, _React$Component);

  function Rifm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._state = null;
    _this._del = false;

    _this._handleChange = function (evt) {
      if (process.env.NODE_ENV !== 'production') {
        if (evt.target.type === 'number') {
          console.error('Rifm does not support input type=number, use type=tel instead.');
          return;
        }
      } // FUTURE: use evt.nativeEvent.inputType for del event, see comments at onkeydown


      var stateValue = _this.state.value;
      var value = evt.target.value;
      var input = evt.target;
      var op = value.length > stateValue.length;
      var del = _this._del;

      var noOp = stateValue === _this.props.format(value);

      _this.setState({
        value: value,
        local: true
      }, function () {
        var selectionStart = input.selectionStart;
        var refuse = _this.props.refuse || /[^\d]+/g;
        var before = value.substr(0, selectionStart).replace(refuse, '');
        _this._state = {
          input: input,
          before: before,
          op: op,
          di: del && noOp,
          del: del
        };

        if (_this.props.replace && _this.props.replace(stateValue) && op && !noOp) {
          var start = -1;

          for (var i = 0; i !== before.length; ++i) {
            start = Math.max(start, value.toLowerCase().indexOf(before[i].toLowerCase(), start + 1));
          }

          var c = value.substr(start + 1).replace(refuse, '')[0];
          start = value.indexOf(c, start + 1);
          value = "" + value.substr(0, start) + value.substr(start + 1);
        }

        var fv = _this.props.format(value);

        if (stateValue === fv) {
          _this.setState({
            value: value
          });
        } else {
          _this.props.onChange(fv);
        }
      });
    };

    _this._hKD = function (evt) {
      if (evt.code === 'Delete') {
        _this._del = true;
      }
    };

    _this._hKU = function (evt) {
      if (evt.code === 'Delete') {
        _this._del = false;
      }
    };

    _this.state = {
      value: props.value,
      local: true
    };
    return _this;
  }

  Rifm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    return {
      value: state.local ? state.value : props.value,
      local: false
    };
  };

  var _proto = Rifm.prototype;

  _proto.render = function render() {
    var _handleChange = this._handleChange,
        value = this.state.value,
        children = this.props.children;
    return children({
      value: value,
      onChange: _handleChange
    });
  } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this._hKD);
    document.removeEventListener('keyup', this._hKU);
  } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
  ;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('keydown', this._hKD);
    document.addEventListener('keyup', this._hKU);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _state = this._state;

    if (_state) {
      var value = this.state.value;
      var start = -1;

      for (var i = 0; i !== _state.before.length; ++i) {
        start = Math.max(start, value.toLowerCase().indexOf(_state.before[i].toLowerCase(), start + 1));
      } // format usually looks better without this


      if (this.props.replace && (_state.op || _state.del && !_state.di)) {
        while (value[start + 1] && (this.props.refuse || /[^\d]+/).test(value[start + 1])) {
          start += 1;
        }
      }

      _state.input.selectionStart = _state.input.selectionEnd = start + 1 + (_state.di ? 1 : 0);
    }

    this._state = null;
  };

  return Rifm;
}(React$1.Component);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

var useStyles$7 = styles$6.makeStyles(function (theme) {
  return {
    day: {
      width: 36,
      height: 36,
      fontSize: theme.typography.caption.fontSize,
      margin: '0 2px',
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightMedium,
      padding: 0
    },
    hidden: {
      opacity: 0,
      pointerEvents: 'none'
    },
    current: {
      color: theme.palette.primary.main,
      fontWeight: 600
    },
    daySelected: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      '&:hover': {
        backgroundColor: theme.palette.primary.main
      }
    },
    dayDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersDay'
});
var Day = function Day(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      hidden = _ref.hidden,
      current = _ref.current,
      selected = _ref.selected,
      other = _objectWithoutProperties(_ref, ["children", "disabled", "hidden", "current", "selected"]);

  var classes = useStyles$7();
  var className = clsx(classes.day, hidden && classes.hidden, current && classes.current, selected && classes.daySelected, disabled && classes.dayDisabled);
  return React$1.createElement(IconButton__default['default'], _extends({
    className: className,
    tabIndex: hidden || disabled ? -1 : 0
  }, other), React$1.createElement(Typography__default['default'], {
    variant: "body2",
    color: "inherit"
  }, children));
};
Day.displayName = 'Day';
process.env.NODE_ENV !== "production" ? Day.propTypes = {
  current: propTypes.exports.bool,
  disabled: propTypes.exports.bool,
  hidden: propTypes.exports.bool,
  selected: propTypes.exports.bool
} : void 0;
Day.defaultProps = {
  disabled: false,
  hidden: false,
  current: false,
  selected: false
};

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React__default['default'].createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default['default'].findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default['default'].findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default['default'].findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default['default'].createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default['default'].cloneElement(React__default['default'].Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default['default'].Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props;
        _this$props.classNames;
        var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);

    return /*#__PURE__*/React__default['default'].createElement(Transition, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default['default'].Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && React$1.isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) React$1.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return React$1.cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!React$1.isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = React$1.isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = React$1.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = React$1.cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && React$1.isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = React$1.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps$1 = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React__default['default'].createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React__default['default'].createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default['default'].createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default['default'].Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps$1;

var findClosestEnabledDate = function findClosestEnabledDate(_ref) {
  var date = _ref.date,
      utils = _ref.utils,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      disableFuture = _ref.disableFuture,
      disablePast = _ref.disablePast,
      shouldDisableDate = _ref.shouldDisableDate;
  var today = utils.startOfDay(utils.date());

  if (disablePast && utils.isBefore(minDate, today)) {
    minDate = today;
  }

  if (disableFuture && utils.isAfter(maxDate, today)) {
    maxDate = today;
  }

  var forward = date;
  var backward = date;

  if (utils.isBefore(date, minDate)) {
    forward = utils.date(minDate);
    backward = null;
  }

  if (utils.isAfter(date, maxDate)) {
    if (backward) {
      backward = utils.date(maxDate);
    }

    forward = null;
  }

  while (forward || backward) {
    if (forward && utils.isAfter(forward, maxDate)) {
      forward = null;
    }

    if (backward && utils.isBefore(backward, minDate)) {
      backward = null;
    }

    if (forward) {
      if (!shouldDisableDate(forward)) {
        return forward;
      }

      forward = utils.addDays(forward, 1);
    }

    if (backward) {
      if (!shouldDisableDate(backward)) {
        return backward;
      }

      backward = utils.addDays(backward, -1);
    }
  } // fallback to today if no enabled days


  return utils.date();
};
var isYearOnlyView = function isYearOnlyView(views) {
  return views.length === 1 && views[0] === 'year';
};
var isYearAndMonthViews = function isYearAndMonthViews(views) {
  return views.length === 2 && arrayIncludes(views, 'month') && arrayIncludes(views, 'year');
};
var getFormatByViews = function getFormatByViews(views, utils) {
  if (isYearOnlyView(views)) {
    return utils.yearFormat;
  }

  if (isYearAndMonthViews(views)) {
    return utils.yearMonthFormat;
  }

  return utils.dateFormat;
};

var DayWrapper = function DayWrapper(_ref) {
  var children = _ref.children,
      value = _ref.value,
      disabled = _ref.disabled,
      onSelect = _ref.onSelect,
      dayInCurrentMonth = _ref.dayInCurrentMonth,
      other = _objectWithoutProperties(_ref, ["children", "value", "disabled", "onSelect", "dayInCurrentMonth"]);

  var handleClick = React$1.useCallback(function () {
    return onSelect(value);
  }, [onSelect, value]);
  return React$1.createElement("div", _extends({
    role: "presentation",
    onClick: dayInCurrentMonth && !disabled ? handleClick : undefined,
    onKeyPress: dayInCurrentMonth && !disabled ? handleClick : undefined
  }, other), children);
};

var animationDuration = 350;
var useStyles$6 = styles$6.makeStyles(function (theme) {
  var slideTransition = theme.transitions.create('transform', {
    duration: animationDuration,
    easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
  });
  return {
    transitionContainer: {
      display: 'block',
      position: 'relative',
      '& > *': {
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0
      }
    },
    'slideEnter-left': {
      willChange: 'transform',
      transform: 'translate(100%)'
    },
    'slideEnter-right': {
      willChange: 'transform',
      transform: 'translate(-100%)'
    },
    slideEnterActive: {
      transform: 'translate(0%)',
      transition: slideTransition
    },
    slideExit: {
      transform: 'translate(0%)'
    },
    'slideExitActiveLeft-left': {
      willChange: 'transform',
      transform: 'translate(-200%)',
      transition: slideTransition
    },
    'slideExitActiveLeft-right': {
      willChange: 'transform',
      transform: 'translate(200%)',
      transition: slideTransition
    }
  };
}, {
  name: 'MuiPickersSlideTransition'
});

var SlideTransition = function SlideTransition(_ref) {
  var children = _ref.children,
      transKey = _ref.transKey,
      slideDirection = _ref.slideDirection,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className;
  var classes = useStyles$6();
  var transitionClasses = {
    exit: classes.slideExit,
    enterActive: classes.slideEnterActive,
    // @ts-ignore
    enter: classes['slideEnter-' + slideDirection],
    // @ts-ignore
    exitActive: classes['slideExitActiveLeft-' + slideDirection]
  };
  return React$1.createElement(TransitionGroup, {
    className: clsx(classes.transitionContainer, className),
    childFactory: function childFactory(element) {
      return React$1.cloneElement(element, {
        classNames: transitionClasses
      });
    }
  }, React$1.createElement(CSSTransition, {
    mountOnEnter: true,
    unmountOnExit: true,
    key: transKey + slideDirection,
    timeout: animationDuration,
    classNames: transitionClasses,
    children: children
  }));
};

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return React__default['default'].createElement(SvgIcon__default['default'], props, React__default['default'].createElement("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
  }), React__default['default'].createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
};

var ArrowRightIcon = function ArrowRightIcon(props) {
  return React__default['default'].createElement(SvgIcon__default['default'], props, React__default['default'].createElement("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
  }), React__default['default'].createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
};

var useStyles$1$3 = styles$6.makeStyles(function (theme) {
  return {
    switchHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(1)
    },
    transitionContainer: {
      width: '100%',
      overflow: 'hidden',
      height: 23
    },
    iconButton: {
      zIndex: 1,
      backgroundColor: theme.palette.background.paper
    },
    daysHeader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxHeight: 16
    },
    dayLabel: {
      width: 36,
      margin: '0 2px',
      textAlign: 'center',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersCalendarHeader'
});
var CalendarHeader = function CalendarHeader(_ref) {
  var currentMonth = _ref.currentMonth,
      onMonthChange = _ref.onMonthChange,
      leftArrowIcon = _ref.leftArrowIcon,
      rightArrowIcon = _ref.rightArrowIcon,
      leftArrowButtonProps = _ref.leftArrowButtonProps,
      rightArrowButtonProps = _ref.rightArrowButtonProps,
      disablePrevMonth = _ref.disablePrevMonth,
      disableNextMonth = _ref.disableNextMonth,
      slideDirection = _ref.slideDirection;
  var utils = useUtils();
  var classes = useStyles$1$3();
  var theme = styles$6.useTheme();
  var rtl = theme.direction === 'rtl';

  var selectNextMonth = function selectNextMonth() {
    return onMonthChange(utils.getNextMonth(currentMonth), 'left');
  };

  var selectPreviousMonth = function selectPreviousMonth() {
    return onMonthChange(utils.getPreviousMonth(currentMonth), 'right');
  };

  return React$1.createElement("div", null, React$1.createElement("div", {
    className: classes.switchHeader
  }, React$1.createElement(IconButton__default['default'], _extends({}, leftArrowButtonProps, {
    disabled: disablePrevMonth,
    onClick: selectPreviousMonth,
    className: classes.iconButton
  }), rtl ? rightArrowIcon : leftArrowIcon), React$1.createElement(SlideTransition, {
    slideDirection: slideDirection,
    transKey: currentMonth.toString(),
    className: classes.transitionContainer
  }, React$1.createElement(Typography__default['default'], {
    align: "center",
    variant: "body1"
  }, utils.getCalendarHeaderText(currentMonth))), React$1.createElement(IconButton__default['default'], _extends({}, rightArrowButtonProps, {
    disabled: disableNextMonth,
    onClick: selectNextMonth,
    className: classes.iconButton
  }), rtl ? leftArrowIcon : rightArrowIcon)), React$1.createElement("div", {
    className: classes.daysHeader
  }, utils.getWeekdays().map(function (day, index) {
    return React$1.createElement(Typography__default['default'], {
      key: index // eslint-disable-line react/no-array-index-key
      ,
      variant: "caption",
      className: classes.dayLabel
    }, day);
  })));
};
CalendarHeader.displayName = 'CalendarHeader';
process.env.NODE_ENV !== "production" ? CalendarHeader.propTypes = {
  leftArrowIcon: propTypes.exports.node,
  rightArrowIcon: propTypes.exports.node,
  disablePrevMonth: propTypes.exports.bool,
  disableNextMonth: propTypes.exports.bool
} : void 0;
CalendarHeader.defaultProps = {
  leftArrowIcon: React$1.createElement(ArrowLeftIcon, null),
  rightArrowIcon: React$1.createElement(ArrowRightIcon, null),
  disablePrevMonth: false,
  disableNextMonth: false
};

var withUtils = function withUtils() {
  return function (Component) {
    var WithUtils = function WithUtils(props) {
      var utils = useUtils();
      return React$1.createElement(Component, _extends({
        utils: utils
      }, props));
    };

    WithUtils.displayName = "WithUtils(".concat(Component.displayName || Component.name, ")");
    return WithUtils;
  };
};

var KeyDownListener = function KeyDownListener(_ref) {
  var onKeyDown = _ref.onKeyDown;
  React$1.useEffect(function () {
    window.addEventListener('keydown', onKeyDown);
    return function () {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
  return null;
};

var Calendar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Calendar, _React$Component);

  function Calendar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      slideDirection: 'left',
      currentMonth: _this.props.utils.startOfMonth(_this.props.date),
      loadingQueue: 0
    };

    _this.pushToLoadingQueue = function () {
      var loadingQueue = _this.state.loadingQueue + 1;

      _this.setState({
        loadingQueue: loadingQueue
      });
    };

    _this.popFromLoadingQueue = function () {
      var loadingQueue = _this.state.loadingQueue;
      loadingQueue = loadingQueue <= 0 ? 0 : loadingQueue - 1;

      _this.setState({
        loadingQueue: loadingQueue
      });
    };

    _this.handleChangeMonth = function (newMonth, slideDirection) {
      _this.setState({
        currentMonth: newMonth,
        slideDirection: slideDirection
      });

      if (_this.props.onMonthChange) {
        var returnVal = _this.props.onMonthChange(newMonth);

        if (returnVal) {
          _this.pushToLoadingQueue();

          returnVal.then(function () {
            _this.popFromLoadingQueue();
          });
        }
      }
    };

    _this.validateMinMaxDate = function (day) {
      var _this$props = _this.props,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          utils = _this$props.utils,
          disableFuture = _this$props.disableFuture,
          disablePast = _this$props.disablePast;
      var now = utils.date();
      return Boolean(disableFuture && utils.isAfterDay(day, now) || disablePast && utils.isBeforeDay(day, now) || minDate && utils.isBeforeDay(day, utils.date(minDate)) || maxDate && utils.isAfterDay(day, utils.date(maxDate)));
    };

    _this.shouldDisablePrevMonth = function () {
      var _this$props2 = _this.props,
          utils = _this$props2.utils,
          disablePast = _this$props2.disablePast,
          minDate = _this$props2.minDate;
      var now = utils.date();
      var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utils.date(minDate)) ? now : utils.date(minDate));
      return !utils.isBefore(firstEnabledMonth, _this.state.currentMonth);
    };

    _this.shouldDisableNextMonth = function () {
      var _this$props3 = _this.props,
          utils = _this$props3.utils,
          disableFuture = _this$props3.disableFuture,
          maxDate = _this$props3.maxDate;
      var now = utils.date();
      var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utils.date(maxDate)) ? now : utils.date(maxDate));
      return !utils.isAfter(lastEnabledMonth, _this.state.currentMonth);
    };

    _this.shouldDisableDate = function (day) {
      var shouldDisableDate = _this.props.shouldDisableDate;
      return _this.validateMinMaxDate(day) || Boolean(shouldDisableDate && shouldDisableDate(day));
    };

    _this.handleDaySelect = function (day) {
      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$props4 = _this.props,
          date = _this$props4.date,
          utils = _this$props4.utils;

      _this.props.onChange(utils.mergeDateAndTime(day, date), isFinish);
    };

    _this.moveToDay = function (day) {
      var utils = _this.props.utils;

      if (day && !_this.shouldDisableDate(day)) {
        if (utils.getMonth(day) !== utils.getMonth(_this.state.currentMonth)) {
          _this.handleChangeMonth(utils.startOfMonth(day), 'left');
        }

        _this.handleDaySelect(day, false);
      }
    };

    _this.handleKeyDown = function (event) {
      var _this$props5 = _this.props,
          theme = _this$props5.theme,
          date = _this$props5.date,
          utils = _this$props5.utils;
      runKeyHandler(event, {
        ArrowUp: function ArrowUp() {
          return _this.moveToDay(utils.addDays(date, -7));
        },
        ArrowDown: function ArrowDown() {
          return _this.moveToDay(utils.addDays(date, 7));
        },
        ArrowLeft: function ArrowLeft() {
          return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? -1 : 1));
        },
        ArrowRight: function ArrowRight() {
          return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? 1 : -1));
        }
      });
    };

    _this.renderWeeks = function () {
      var _this$props6 = _this.props,
          utils = _this$props6.utils,
          classes = _this$props6.classes;
      var weeks = utils.getWeekArray(_this.state.currentMonth);
      return weeks.map(function (week) {
        return React$1.createElement("div", {
          key: "week-".concat(week[0].toString()),
          className: classes.week
        }, _this.renderDays(week));
      });
    };

    _this.renderDays = function (week) {
      var _this$props7 = _this.props,
          date = _this$props7.date,
          renderDay = _this$props7.renderDay,
          utils = _this$props7.utils;
      var now = utils.date();
      var selectedDate = utils.startOfDay(date);
      var currentMonthNumber = utils.getMonth(_this.state.currentMonth);
      return week.map(function (day) {
        var disabled = _this.shouldDisableDate(day);

        var isDayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
        var dayComponent = React$1.createElement(Day, {
          disabled: disabled,
          current: utils.isSameDay(day, now),
          hidden: !isDayInCurrentMonth,
          selected: utils.isSameDay(selectedDate, day)
        }, utils.getDayText(day));

        if (renderDay) {
          dayComponent = renderDay(day, selectedDate, isDayInCurrentMonth, dayComponent);
        }

        return React$1.createElement(DayWrapper, {
          value: day,
          key: day.toString(),
          disabled: disabled,
          dayInCurrentMonth: isDayInCurrentMonth,
          onSelect: _this.handleDaySelect
        }, dayComponent);
      });
    };

    return _this;
  }

  _createClass(Calendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props8 = this.props,
          date = _this$props8.date,
          minDate = _this$props8.minDate,
          maxDate = _this$props8.maxDate,
          utils = _this$props8.utils,
          disablePast = _this$props8.disablePast,
          disableFuture = _this$props8.disableFuture;

      if (this.shouldDisableDate(date)) {
        var closestEnabledDate = findClosestEnabledDate({
          date: date,
          utils: utils,
          minDate: utils.date(minDate),
          maxDate: utils.date(maxDate),
          disablePast: Boolean(disablePast),
          disableFuture: Boolean(disableFuture),
          shouldDisableDate: this.shouldDisableDate
        });
        this.handleDaySelect(closestEnabledDate, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          currentMonth = _this$state.currentMonth,
          slideDirection = _this$state.slideDirection;
      var _this$props9 = this.props,
          classes = _this$props9.classes,
          allowKeyboardControl = _this$props9.allowKeyboardControl,
          leftArrowButtonProps = _this$props9.leftArrowButtonProps,
          leftArrowIcon = _this$props9.leftArrowIcon,
          rightArrowButtonProps = _this$props9.rightArrowButtonProps,
          rightArrowIcon = _this$props9.rightArrowIcon,
          loadingIndicator = _this$props9.loadingIndicator;
      var loadingElement = loadingIndicator ? loadingIndicator : React$1.createElement(CircularProgress__default['default'], null);
      return React$1.createElement(React$1.Fragment, null, allowKeyboardControl && this.context !== 'static' && React$1.createElement(KeyDownListener, {
        onKeyDown: this.handleKeyDown
      }), React$1.createElement(CalendarHeader, {
        currentMonth: currentMonth,
        slideDirection: slideDirection,
        onMonthChange: this.handleChangeMonth,
        leftArrowIcon: leftArrowIcon,
        leftArrowButtonProps: leftArrowButtonProps,
        rightArrowIcon: rightArrowIcon,
        rightArrowButtonProps: rightArrowButtonProps,
        disablePrevMonth: this.shouldDisablePrevMonth(),
        disableNextMonth: this.shouldDisableNextMonth()
      }), React$1.createElement(SlideTransition, {
        slideDirection: slideDirection,
        transKey: currentMonth.toString(),
        className: classes.transitionContainer
      }, React$1.createElement(React$1.Fragment, null, this.state.loadingQueue > 0 && React$1.createElement("div", {
        className: classes.progressContainer
      }, loadingElement) || React$1.createElement("div", null, this.renderWeeks()))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var utils = nextProps.utils,
          nextDate = nextProps.date;

      if (!utils.isEqual(nextDate, state.lastDate)) {
        var nextMonth = utils.getMonth(nextDate);
        var lastDate = state.lastDate || nextDate;
        var lastMonth = utils.getMonth(lastDate);
        return {
          lastDate: nextDate,
          currentMonth: nextProps.utils.startOfMonth(nextDate),
          // prettier-ignore
          slideDirection: nextMonth === lastMonth ? state.slideDirection : utils.isAfterDay(nextDate, lastDate) ? 'left' : 'right'
        };
      }

      return null;
    }
  }]);

  return Calendar;
}(React$1.Component);
Calendar.contextType = VariantContext;
process.env.NODE_ENV !== "production" ? Calendar.propTypes = {
  renderDay: propTypes.exports.func,
  shouldDisableDate: propTypes.exports.func,
  allowKeyboardControl: propTypes.exports.bool
} : void 0;
Calendar.defaultProps = {
  minDate: new Date('1900-01-01'),
  maxDate: new Date('2100-01-01'),
  disablePast: false,
  disableFuture: false,
  allowKeyboardControl: true
};
var styles$2 = function styles(theme) {
  return {
    transitionContainer: {
      minHeight: 36 * 6,
      marginTop: theme.spacing(1.5)
    },
    progressContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    week: {
      display: 'flex',
      justifyContent: 'center'
    }
  };
};
var Calendar$1 = styles$6.withStyles(styles$2, {
  name: 'MuiPickersCalendar',
  withTheme: true
})(withUtils()(Calendar));

var ClockType;

(function (ClockType) {
  ClockType["HOURS"] = "hours";
  ClockType["MINUTES"] = "minutes";
  ClockType["SECONDS"] = "seconds";
})(ClockType || (ClockType = {}));

var ClockType$1 = ClockType;

var ClockPointer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ClockPointer, _React$Component);

  function ClockPointer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ClockPointer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ClockPointer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      toAnimateTransform: false,
      previousType: undefined
    };

    _this.getAngleStyle = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          isInner = _this$props.isInner,
          type = _this$props.type;
      var max = type === ClockType$1.HOURS ? 12 : 60;
      var angle = 360 / max * value;

      if (type === ClockType$1.HOURS && value > 12) {
        angle -= 360; // round up angle to max 360 degrees
      }

      return {
        height: isInner ? '26%' : '40%',
        transform: "rotateZ(".concat(angle, "deg)")
      };
    };

    return _this;
  }

  _createClass(ClockPointer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          hasSelected = _this$props2.hasSelected;
      return React$1.createElement("div", {
        style: this.getAngleStyle(),
        className: clsx(classes.pointer, this.state.toAnimateTransform && classes.animateTransform)
      }, React$1.createElement("div", {
        className: clsx(classes.thumb, hasSelected && classes.noPoint)
      }));
    }
  }]);

  return ClockPointer;
}(React$1.Component);

ClockPointer.getDerivedStateFromProps = function (nextProps, state) {
  if (nextProps.type !== state.previousType) {
    return {
      toAnimateTransform: true,
      previousType: nextProps.type
    };
  }

  return {
    toAnimateTransform: false,
    previousType: nextProps.type
  };
};

var styles$1 = function styles(theme) {
  return styles$6.createStyles({
    pointer: {
      width: 2,
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      left: 'calc(50% - 1px)',
      bottom: '50%',
      transformOrigin: 'center bottom 0px'
    },
    animateTransform: {
      transition: theme.transitions.create(['transform', 'height'])
    },
    thumb: {
      width: 4,
      height: 4,
      backgroundColor: theme.palette.primary.contrastText,
      borderRadius: '100%',
      position: 'absolute',
      top: -21,
      left: -15,
      border: "14px solid ".concat(theme.palette.primary.main),
      boxSizing: 'content-box'
    },
    noPoint: {
      backgroundColor: theme.palette.primary.main
    }
  });
};
var ClockPointer$1 = styles$6.withStyles(styles$1, {
  name: 'MuiPickersClockPointer'
})(ClockPointer);

var center = {
  x: 260 / 2,
  y: 260 / 2
};
var basePoint = {
  x: center.x,
  y: 0
};
var cx = basePoint.x - center.x;
var cy = basePoint.y - center.y;

var rad2deg = function rad2deg(rad) {
  return rad * 57.29577951308232;
};

var getAngleValue = function getAngleValue(step, offsetX, offsetY) {
  var x = offsetX - center.x;
  var y = offsetY - center.y;
  var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
  var deg = rad2deg(atan);
  deg = Math.round(deg / step) * step;
  deg %= 360;
  var value = Math.floor(deg / step) || 0;
  var delta = Math.pow(x, 2) + Math.pow(y, 2);
  var distance = Math.sqrt(delta);
  return {
    value: value,
    distance: distance
  };
};

var getHours = function getHours(offsetX, offsetY, ampm) {
  var _getAngleValue = getAngleValue(30, offsetX, offsetY),
      value = _getAngleValue.value,
      distance = _getAngleValue.distance;

  value = value || 12;

  if (!ampm) {
    if (distance < 90) {
      value += 12;
      value %= 24;
    }
  } else {
    value %= 12;
  }

  return value;
};
var getMinutes = function getMinutes(offsetX, offsetY) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var angleStep = step * 6;

  var _getAngleValue2 = getAngleValue(angleStep, offsetX, offsetY),
      value = _getAngleValue2.value;

  value = value * step % 60;
  return value;
};
var getMeridiem = function getMeridiem(date, utils) {
  return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
var convertToMeridiem = function convertToMeridiem(time, meridiem, ampm, utils) {
  if (ampm) {
    var currentMeridiem = utils.getHours(time) >= 12 ? 'pm' : 'am';

    if (currentMeridiem !== meridiem) {
      var hours = meridiem === 'am' ? utils.getHours(time) - 12 : utils.getHours(time) + 12;
      return utils.setHours(time, hours);
    }
  }

  return time;
};

var Clock =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Clock, _React$Component);

  function Clock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Clock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Clock)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.isMoving = false;

    _this.handleTouchMove = function (e) {
      _this.isMoving = true;

      _this.setTime(e);
    };

    _this.handleTouchEnd = function (e) {
      if (_this.isMoving) {
        _this.setTime(e, true);

        _this.isMoving = false;
      }
    };

    _this.handleMove = function (e) {
      e.preventDefault();
      e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari

      var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;

      if (isButtonPressed) {
        _this.setTime(e.nativeEvent, false);
      }
    };

    _this.handleMouseUp = function (e) {
      if (_this.isMoving) {
        _this.isMoving = false;
      }

      _this.setTime(e.nativeEvent, true);
    };

    _this.hasSelected = function () {
      var _this$props = _this.props,
          type = _this$props.type,
          value = _this$props.value;

      if (type === ClockType$1.HOURS) {
        return true;
      }

      return value % 5 === 0;
    };

    return _this;
  }

  _createClass(Clock, [{
    key: "setTime",
    value: function setTime(e) {
      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var offsetX = e.offsetX,
          offsetY = e.offsetY;

      if (typeof offsetX === 'undefined') {
        var rect = e.target.getBoundingClientRect();
        offsetX = e.changedTouches[0].clientX - rect.left;
        offsetY = e.changedTouches[0].clientY - rect.top;
      }

      var value = this.props.type === ClockType$1.SECONDS || this.props.type === ClockType$1.MINUTES ? getMinutes(offsetX, offsetY, this.props.minutesStep) : getHours(offsetX, offsetY, Boolean(this.props.ampm));
      this.props.onChange(value, isFinish);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          value = _this$props2.value,
          children = _this$props2.children,
          type = _this$props2.type,
          ampm = _this$props2.ampm;
      var isPointerInner = !ampm && type === ClockType$1.HOURS && (value < 1 || value > 12);
      return React$1.createElement("div", {
        className: classes.container
      }, React$1.createElement("div", {
        className: classes.clock
      }, React$1.createElement("div", {
        role: "menu",
        tabIndex: -1,
        className: classes.squareMask,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd,
        onMouseUp: this.handleMouseUp,
        onMouseMove: this.handleMove
      }), React$1.createElement("div", {
        className: classes.pin
      }), React$1.createElement(ClockPointer$1, {
        type: type,
        value: value,
        isInner: isPointerInner,
        hasSelected: this.hasSelected()
      }), children));
    }
  }]);

  return Clock;
}(React$1.Component);
process.env.NODE_ENV !== "production" ? Clock.propTypes = {
  type: propTypes.exports.oneOf(Object.keys(ClockType$1).map(function (key) {
    return ClockType$1[key];
  })).isRequired,
  value: propTypes.exports.number.isRequired,
  onChange: propTypes.exports.func.isRequired,
  children: propTypes.exports.arrayOf(propTypes.exports.node).isRequired,
  ampm: propTypes.exports.bool,
  minutesStep: propTypes.exports.number,
  innerRef: propTypes.exports.any
} : void 0;
Clock.defaultProps = {
  ampm: false,
  minutesStep: 1
};
var styles$1$1 = function styles(theme) {
  return styles$6.createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
      margin: "".concat(theme.spacing(2), "px 0 ").concat(theme.spacing(1), "px")
    },
    clock: {
      backgroundColor: 'rgba(0,0,0,.07)',
      borderRadius: '50%',
      height: 260,
      width: 260,
      position: 'relative',
      pointerEvents: 'none'
    },
    squareMask: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      pointerEvents: 'auto',
      outline: 'none',
      touchActions: 'none',
      userSelect: 'none',
      '&:active': {
        cursor: 'move'
      }
    },
    pin: {
      width: 6,
      height: 6,
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  });
};
var Clock$1 = styles$6.withStyles(styles$1$1, {
  name: 'MuiPickersClock'
})(Clock);

var positions = {
  0: [0, 40],
  1: [55, 19.6],
  2: [94.4, 59.5],
  3: [109, 114],
  4: [94.4, 168.5],
  5: [54.5, 208.4],
  6: [0, 223],
  7: [-54.5, 208.4],
  8: [-94.4, 168.5],
  9: [-109, 114],
  10: [-94.4, 59.5],
  11: [-54.5, 19.6],
  12: [0, 5],
  13: [36.9, 49.9],
  14: [64, 77],
  15: [74, 114],
  16: [64, 151],
  17: [37, 178],
  18: [0, 188],
  19: [-37, 178],
  20: [-64, 151],
  21: [-74, 114],
  22: [-64, 77],
  23: [-37, 50]
};
var useStyles$5 = styles$6.makeStyles(function (theme) {
  var size = theme.spacing(4);
  return {
    clockNumber: {
      width: size,
      height: 32,
      userSelect: 'none',
      position: 'absolute',
      left: "calc((100% - ".concat(typeof size === 'number' ? "".concat(size, "px") : size, ") / 2)"),
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.hint
    },
    clockNumberSelected: {
      color: theme.palette.primary.contrastText
    }
  };
}, {
  name: 'MuiPickersClockNumber'
});
var ClockNumber = function ClockNumber(_ref) {
  var selected = _ref.selected,
      label = _ref.label,
      index = _ref.index,
      isInner = _ref.isInner;
  var classes = useStyles$5();
  var className = clsx(classes.clockNumber, selected && classes.clockNumberSelected);
  var transformStyle = React$1.useMemo(function () {
    var position = positions[index];
    return {
      transform: "translate(".concat(position[0], "px, ").concat(position[1], "px")
    };
  }, [index]);
  return React$1.createElement(Typography__default['default'], {
    component: "span",
    className: className,
    variant: isInner ? 'body2' : 'body1',
    style: transformStyle,
    children: label
  });
};

var getHourNumbers = function getHourNumbers(_ref) {
  var ampm = _ref.ampm,
      utils = _ref.utils,
      date = _ref.date;
  var currentHours = utils.getHours(date);
  var hourNumbers = [];
  var startHour = ampm ? 1 : 0;
  var endHour = ampm ? 12 : 23;

  var isSelected = function isSelected(hour) {
    if (ampm) {
      if (hour === 12) {
        return currentHours === 12 || currentHours === 0;
      }

      return currentHours === hour || currentHours - 12 === hour;
    }

    return currentHours === hour;
  };

  for (var hour = startHour; hour <= endHour; hour += 1) {
    var label = hour.toString();

    if (hour === 0) {
      label = '00';
    }

    var props = {
      index: hour,
      label: utils.formatNumber(label),
      selected: isSelected(hour),
      isInner: !ampm && (hour === 0 || hour > 12)
    };
    hourNumbers.push(React$1.createElement(ClockNumber, _extends({
      key: hour
    }, props)));
  }

  return hourNumbers;
};
var getMinutesNumbers = function getMinutesNumbers(_ref2) {
  var value = _ref2.value,
      utils = _ref2.utils;
  var f = utils.formatNumber;
  return [React$1.createElement(ClockNumber, {
    label: f('00'),
    selected: value === 0,
    index: 12,
    key: 12
  }), React$1.createElement(ClockNumber, {
    label: f('05'),
    selected: value === 5,
    index: 1,
    key: 1
  }), React$1.createElement(ClockNumber, {
    label: f('10'),
    selected: value === 10,
    index: 2,
    key: 2
  }), React$1.createElement(ClockNumber, {
    label: f('15'),
    selected: value === 15,
    index: 3,
    key: 3
  }), React$1.createElement(ClockNumber, {
    label: f('20'),
    selected: value === 20,
    index: 4,
    key: 4
  }), React$1.createElement(ClockNumber, {
    label: f('25'),
    selected: value === 25,
    index: 5,
    key: 5
  }), React$1.createElement(ClockNumber, {
    label: f('30'),
    selected: value === 30,
    index: 6,
    key: 6
  }), React$1.createElement(ClockNumber, {
    label: f('35'),
    selected: value === 35,
    index: 7,
    key: 7
  }), React$1.createElement(ClockNumber, {
    label: f('40'),
    selected: value === 40,
    index: 8,
    key: 8
  }), React$1.createElement(ClockNumber, {
    label: f('45'),
    selected: value === 45,
    index: 9,
    key: 9
  }), React$1.createElement(ClockNumber, {
    label: f('50'),
    selected: value === 50,
    index: 10,
    key: 10
  }), React$1.createElement(ClockNumber, {
    label: f('55'),
    selected: value === 55,
    index: 11,
    key: 11
  })];
};

var ClockView = function ClockView(_ref) {
  var type = _ref.type,
      onHourChange = _ref.onHourChange,
      onMinutesChange = _ref.onMinutesChange,
      onSecondsChange = _ref.onSecondsChange,
      ampm = _ref.ampm,
      date = _ref.date,
      minutesStep = _ref.minutesStep;
  var utils = useUtils();
  var viewProps = React$1.useMemo(function () {
    switch (type) {
      case ClockType$1.HOURS:
        return {
          value: utils.getHours(date),
          children: getHourNumbers({
            date: date,
            utils: utils,
            ampm: Boolean(ampm)
          }),
          onChange: function onChange(value, isFinish) {
            var currentMeridiem = getMeridiem(date, utils);
            var updatedTimeWithMeridiem = convertToMeridiem(utils.setHours(date, value), currentMeridiem, Boolean(ampm), utils);
            onHourChange(updatedTimeWithMeridiem, isFinish);
          }
        };

      case ClockType$1.MINUTES:
        var minutesValue = utils.getMinutes(date);
        return {
          value: minutesValue,
          children: getMinutesNumbers({
            value: minutesValue,
            utils: utils
          }),
          onChange: function onChange(value, isFinish) {
            var updatedTime = utils.setMinutes(date, value);
            onMinutesChange(updatedTime, isFinish);
          }
        };

      case ClockType$1.SECONDS:
        var secondsValue = utils.getSeconds(date);
        return {
          value: secondsValue,
          children: getMinutesNumbers({
            value: secondsValue,
            utils: utils
          }),
          onChange: function onChange(value, isFinish) {
            var updatedTime = utils.setSeconds(date, value);
            onSecondsChange(updatedTime, isFinish);
          }
        };

      default:
        throw new Error('You must provide the type for TimePickerView');
    }
  }, [ampm, date, onHourChange, onMinutesChange, onSecondsChange, type, utils]);
  return React$1.createElement(Clock$1, _extends({
    type: type,
    ampm: ampm,
    minutesStep: minutesStep
  }, viewProps));
};
ClockView.displayName = 'TimePickerView';
process.env.NODE_ENV !== "production" ? ClockView.propTypes = {
  date: propTypes.exports.object.isRequired,
  onHourChange: propTypes.exports.func.isRequired,
  onMinutesChange: propTypes.exports.func.isRequired,
  onSecondsChange: propTypes.exports.func.isRequired,
  ampm: propTypes.exports.bool,
  minutesStep: propTypes.exports.number,
  type: propTypes.exports.oneOf(Object.keys(ClockType$1).map(function (key) {
    return ClockType$1[key];
  })).isRequired
} : void 0;
ClockView.defaultProps = {
  ampm: true,
  minutesStep: 1
};
React$1.memo(ClockView);

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
propTypes.exports.oneOfType([propTypes.exports.object, propTypes.exports.string, propTypes.exports.number, propTypes.exports.instanceOf(Date)]);
propTypes.exports.oneOf(['year', 'month', 'day']);
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */

var timePickerDefaultProps = {
  ampm: true,
  invalidDateMessage: 'Invalid Time Format'
};
var datePickerDefaultProps = {
  minDate: new Date('1900-01-01'),
  maxDate: new Date('2100-01-01'),
  invalidDateMessage: 'Invalid Date Format',
  minDateMessage: 'Date should not be before minimal date',
  maxDateMessage: 'Date should not be after maximal date',
  allowKeyboardControl: true
};
_objectSpread$3({}, timePickerDefaultProps, {}, datePickerDefaultProps, {
  showTabs: true
});

function useViews(views, openTo, onChange) {
  var _React$useState = React$1.useState(openTo && arrayIncludes(views, openTo) ? openTo : views[0]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openView = _React$useState2[0],
      setOpenView = _React$useState2[1];

  var handleChangeAndOpenNext = React$1.useCallback(function (date, isFinish) {
    var nextViewToOpen = views[views.indexOf(openView) + 1];

    if (isFinish && nextViewToOpen) {
      // do not close picker if needs to show next view
      onChange(date, false);
      setOpenView(nextViewToOpen);
      return;
    }

    onChange(date, Boolean(isFinish));
  }, [onChange, openView, views]);
  return {
    handleChangeAndOpenNext: handleChangeAndOpenNext,
    openView: openView,
    setOpenView: setOpenView
  };
}

var useStyles$2 = styles$6.makeStyles(function (theme) {
  return {
    root: {
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      outline: 'none',
      '&:focus': {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    yearSelected: {
      margin: '10px 0',
      fontWeight: theme.typography.fontWeightMedium
    },
    yearDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersYear'
});
var Year = function Year(_ref) {
  var onSelect = _ref.onSelect,
      forwardedRef = _ref.forwardedRef,
      value = _ref.value,
      selected = _ref.selected,
      disabled = _ref.disabled,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["onSelect", "forwardedRef", "value", "selected", "disabled", "children"]);

  var classes = useStyles$2();
  var handleClick = React$1.useCallback(function () {
    return onSelect(value);
  }, [onSelect, value]);
  return React$1.createElement(Typography__default['default'], _extends({
    role: "button",
    component: "div",
    tabIndex: disabled ? -1 : 0,
    onClick: handleClick,
    onKeyPress: handleClick,
    color: selected ? 'primary' : undefined,
    variant: selected ? 'h5' : 'subtitle1',
    children: children,
    ref: forwardedRef,
    className: clsx(classes.root, selected && classes.yearSelected, disabled && classes.yearDisabled)
  }, other));
};
Year.displayName = 'Year';
var Year$1 = React$1.forwardRef(function (props, ref) {
  return React$1.createElement(Year, _extends({}, props, {
    forwardedRef: ref
  }));
});

var useStyles$1$2 = styles$6.makeStyles({
  container: {
    height: 300,
    overflowY: 'auto'
  }
}, {
  name: 'MuiPickersYearSelection'
});
var YearSelection = function YearSelection(_ref) {
  var date = _ref.date,
      onChange = _ref.onChange,
      onYearChange = _ref.onYearChange,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      animateYearScrolling = _ref.animateYearScrolling;
  var utils = useUtils();
  var classes = useStyles$1$2();
  var currentVariant = React$1.useContext(VariantContext);
  var selectedYearRef = React$1.useRef(null);
  React$1.useEffect(function () {
    if (selectedYearRef.current && selectedYearRef.current.scrollIntoView) {
      try {
        selectedYearRef.current.scrollIntoView({
          block: currentVariant === 'static' ? 'nearest' : 'center',
          behavior: animateYearScrolling ? 'smooth' : 'auto'
        });
      } catch (e) {
        // call without arguments in case when scrollIntoView works improperly (e.g. Firefox 52-57)
        selectedYearRef.current.scrollIntoView();
      }
    }
  }, []); // eslint-disable-line

  var currentYear = utils.getYear(date);
  var onYearSelect = React$1.useCallback(function (year) {
    var newDate = utils.setYear(date, year);

    if (onYearChange) {
      onYearChange(newDate);
    }

    onChange(newDate, true);
  }, [date, onChange, onYearChange, utils]);
  return React$1.createElement("div", {
    className: classes.container
  }, utils.getYearRange(minDate, maxDate).map(function (year) {
    var yearNumber = utils.getYear(year);
    var selected = yearNumber === currentYear;
    return React$1.createElement(Year$1, {
      key: utils.getYearText(year),
      selected: selected,
      value: yearNumber,
      onSelect: onYearSelect,
      ref: selected ? selectedYearRef : undefined,
      disabled: Boolean(disablePast && utils.isBeforeYear(year, utils.date()) || disableFuture && utils.isAfterYear(year, utils.date()))
    }, utils.getYearText(year));
  }));
};

var useStyles$2$1 = styles$6.makeStyles(function (theme) {
  return {
    root: {
      flex: '1 0 33.33%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      outline: 'none',
      height: 75,
      transition: theme.transitions.create('font-size', {
        duration: '100ms'
      }),
      '&:focus': {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    monthSelected: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium
    },
    monthDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersMonth'
});
var Month = function Month(_ref) {
  var selected = _ref.selected,
      onSelect = _ref.onSelect,
      disabled = _ref.disabled,
      value = _ref.value,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["selected", "onSelect", "disabled", "value", "children"]);

  var classes = useStyles$2$1();
  var handleSelection = React$1.useCallback(function () {
    onSelect(value);
  }, [onSelect, value]);
  return React$1.createElement(Typography__default['default'], _extends({
    role: "button",
    component: "div",
    className: clsx(classes.root, selected && classes.monthSelected, disabled && classes.monthDisabled),
    tabIndex: disabled ? -1 : 0,
    onClick: handleSelection,
    onKeyPress: handleSelection,
    color: selected ? 'primary' : undefined,
    variant: selected ? 'h5' : 'subtitle1',
    children: children
  }, other));
};
Month.displayName = 'Month';

var useStyles$3 = styles$6.makeStyles({
  container: {
    width: 310,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch'
  }
}, {
  name: 'MuiPickersMonthSelection'
});
var MonthSelection = function MonthSelection(_ref) {
  var disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      date = _ref.date,
      onMonthChange = _ref.onMonthChange,
      onChange = _ref.onChange;
  var utils = useUtils();
  var classes = useStyles$3();
  var currentMonth = utils.getMonth(date);

  var shouldDisableMonth = function shouldDisableMonth(month) {
    var now = utils.date();
    var utilMinDate = utils.date(minDate);
    var utilMaxDate = utils.date(maxDate);
    var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utilMinDate) ? now : utilMinDate);
    var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utilMaxDate) ? now : utilMaxDate);
    var isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
    var isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
    return isBeforeFirstEnabled || isAfterLastEnabled;
  };

  var onMonthSelect = React$1.useCallback(function (month) {
    var newDate = utils.setMonth(date, month);
    onChange(newDate, true);

    if (onMonthChange) {
      onMonthChange(newDate);
    }
  }, [date, onChange, onMonthChange, utils]);
  return React$1.createElement("div", {
    className: classes.container
  }, utils.getMonthArray(date).map(function (month) {
    var monthNumber = utils.getMonth(month);
    var monthText = utils.format(month, 'MMM');
    return React$1.createElement(Month, {
      key: monthText,
      value: monthNumber,
      selected: monthNumber === currentMonth,
      onSelect: onMonthSelect,
      disabled: shouldDisableMonth(month)
    }, monthText);
  }));
};

var getOrientation = function getOrientation() {
  if (typeof window === 'undefined') {
    return 'portrait';
  }

  if (window.screen && window.screen.orientation && window.screen.orientation.angle) {
    return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
  } // Support IOS safari


  if (window.orientation) {
    return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
  }

  return 'portrait';
};

function useIsLandscape(customOrientation) {
  var _React$useState = React$1.useState(getOrientation()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      orientation = _React$useState2[0],
      setOrientation = _React$useState2[1];

  var eventHandler = React$1.useCallback(function () {
    return setOrientation(getOrientation());
  }, []);
  useIsomorphicEffect(function () {
    window.addEventListener('orientationchange', eventHandler);
    return function () {
      return window.removeEventListener('orientationchange', eventHandler);
    };
  }, [eventHandler]);
  var orientationToUse = customOrientation || orientation;
  return orientationToUse === 'landscape';
}

function ownKeys$1$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$2(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var viewsMap = {
  year: YearSelection,
  month: MonthSelection,
  date: Calendar$1,
  hours: ClockView,
  minutes: ClockView,
  seconds: ClockView
};
var useStyles$4 = styles$6.makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  containerLandscape: {
    flexDirection: 'row'
  },
  pickerView: {
    overflowX: 'hidden',
    minHeight: VIEW_HEIGHT,
    minWidth: DIALOG_WIDTH,
    maxWidth: DIALOG_WIDTH_WIDER,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  pickerViewLandscape: {
    padding: '0 8px'
  }
}, {
  name: 'MuiPickersBasePicker'
});
var Picker = function Picker(_ref) {
  var date = _ref.date,
      views = _ref.views,
      disableToolbar = _ref.disableToolbar,
      onChange = _ref.onChange,
      openTo = _ref.openTo,
      unparsedMinDate = _ref.minDate,
      unparsedMaxDate = _ref.maxDate,
      ToolbarComponent = _ref.ToolbarComponent,
      orientation = _ref.orientation,
      rest = _objectWithoutProperties(_ref, ["date", "views", "disableToolbar", "onChange", "openTo", "minDate", "maxDate", "ToolbarComponent", "orientation"]);

  var utils = useUtils();
  var classes = useStyles$4();
  var isLandscape = useIsLandscape(orientation);

  var _useViews = useViews(views, openTo, onChange),
      openView = _useViews.openView,
      setOpenView = _useViews.setOpenView,
      handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;

  var minDate = React$1.useMemo(function () {
    return utils.date(unparsedMinDate);
  }, [unparsedMinDate, utils]);
  var maxDate = React$1.useMemo(function () {
    return utils.date(unparsedMaxDate);
  }, [unparsedMaxDate, utils]);
  return React$1.createElement("div", {
    className: clsx(classes.container, isLandscape && classes.containerLandscape)
  }, !disableToolbar && React$1.createElement(ToolbarComponent, _extends({}, rest, {
    views: views,
    isLandscape: isLandscape,
    date: date,
    onChange: onChange,
    setOpenView: setOpenView,
    openView: openView
  })), React$1.createElement("div", {
    className: clsx(classes.pickerView, isLandscape && classes.pickerViewLandscape)
  }, openView === 'year' && React$1.createElement(YearSelection, _extends({}, rest, {
    date: date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate
  })), openView === 'month' && React$1.createElement(MonthSelection, _extends({}, rest, {
    date: date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate
  })), openView === 'date' && React$1.createElement(Calendar$1, _extends({}, rest, {
    date: date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate
  })), (openView === 'hours' || openView === 'minutes' || openView === 'seconds') && React$1.createElement(ClockView, _extends({}, rest, {
    date: date,
    type: openView,
    onHourChange: handleChangeAndOpenNext,
    onMinutesChange: handleChangeAndOpenNext,
    onSecondsChange: handleChangeAndOpenNext
  }))));
};
Picker.defaultProps = _objectSpread$1$2({}, datePickerDefaultProps, {
  views: Object.keys(viewsMap)
});

var useStyles$1 = styles$6.makeStyles(function (theme) {
  var textColor = theme.palette.type === 'light' ? theme.palette.primary.contrastText : theme.palette.getContrastText(theme.palette.background["default"]);
  return {
    toolbarTxt: {
      color: styles$6.fade(textColor, 0.54)
    },
    toolbarBtnSelected: {
      color: textColor
    }
  };
}, {
  name: 'MuiPickersToolbarText'
});

var ToolbarText = function ToolbarText(_ref) {
  var selected = _ref.selected,
      label = _ref.label,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      other = _objectWithoutProperties(_ref, ["selected", "label", "className"]);

  var classes = useStyles$1();
  return React$1.createElement(Typography__default['default'], _extends({
    children: label,
    className: clsx(classes.toolbarTxt, className, selected && classes.toolbarBtnSelected)
  }, other));
};

var ToolbarButton = function ToolbarButton(_ref) {
  var classes = _ref.classes,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      label = _ref.label,
      selected = _ref.selected,
      variant = _ref.variant,
      align = _ref.align,
      typographyClassName = _ref.typographyClassName,
      other = _objectWithoutProperties(_ref, ["classes", "className", "label", "selected", "variant", "align", "typographyClassName"]);

  return React$1.createElement(Button__default['default'], _extends({
    variant: "text",
    className: clsx(classes.toolbarBtn, className)
  }, other), React$1.createElement(ToolbarText, {
    align: align,
    className: typographyClassName,
    variant: variant,
    label: label,
    selected: selected
  }));
};

process.env.NODE_ENV !== "production" ? ToolbarButton.propTypes = {
  selected: propTypes.exports.bool.isRequired,
  label: propTypes.exports.string.isRequired,
  classes: propTypes.exports.any.isRequired,
  className: propTypes.exports.string,
  innerRef: propTypes.exports.any
} : void 0;
ToolbarButton.defaultProps = {
  className: ''
};
var styles = styles$6.createStyles({
  toolbarBtn: {
    padding: 0,
    minWidth: '16px',
    textTransform: 'none'
  }
});
var ToolbarButton$1 = styles$6.withStyles(styles, {
  name: 'MuiPickersToolbarButton'
})(ToolbarButton);

var useStyles$1$1 = styles$6.makeStyles(function (theme) {
  return {
    toolbar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      height: 100,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background["default"]
    },
    toolbarLandscape: {
      height: 'auto',
      maxWidth: 150,
      padding: 8,
      justifyContent: 'flex-start'
    }
  };
}, {
  name: 'MuiPickersToolbar'
});

var PickerToolbar = function PickerToolbar(_ref) {
  var children = _ref.children,
      isLandscape = _ref.isLandscape,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      other = _objectWithoutProperties(_ref, ["children", "isLandscape", "className"]);

  var classes = useStyles$1$1();
  return React$1.createElement(Toolbar__default['default'], _extends({
    className: clsx(classes.toolbar, className, isLandscape && classes.toolbarLandscape)
  }, other), children);
};

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var PureDateInput = function PureDateInput(_ref) {
  var inputValue = _ref.inputValue,
      inputVariant = _ref.inputVariant,
      validationError = _ref.validationError,
      InputProps = _ref.InputProps,
      onOpen = _ref.openPicker,
      _ref$TextFieldCompone = _ref.TextFieldComponent,
      TextFieldComponent = _ref$TextFieldCompone === void 0 ? TextField__default['default'] : _ref$TextFieldCompone,
      other = _objectWithoutProperties(_ref, ["inputValue", "inputVariant", "validationError", "InputProps", "openPicker", "TextFieldComponent"]);

  var PureDateInputProps = React$1.useMemo(function () {
    return _objectSpread$1({}, InputProps, {
      readOnly: true
    });
  }, [InputProps]);
  return React$1.createElement(TextFieldComponent, _extends({
    error: Boolean(validationError),
    helperText: validationError
  }, other, {
    // do not overridable
    onClick: onOpen,
    value: inputValue,
    variant: inputVariant,
    InputProps: PureDateInputProps,
    onKeyDown: function onKeyDown(e) {
      // space
      if (e.keyCode === 32) {
        e.stopPropagation();
        onOpen();
      }
    }
  }));
};
PureDateInput.displayName = 'PureDateInput';

var KeyboardIcon = function KeyboardIcon(props) {
  return React__default['default'].createElement(SvgIcon__default['default'], props, React__default['default'].createElement("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
  }), React__default['default'].createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
};

var getDisplayDate = function getDisplayDate(value, format, utils, isEmpty, _ref) {
  var invalidLabel = _ref.invalidLabel,
      emptyLabel = _ref.emptyLabel,
      labelFunc = _ref.labelFunc;
  var date = utils.date(value);

  if (labelFunc) {
    return labelFunc(isEmpty ? null : date, invalidLabel);
  }

  if (isEmpty) {
    return emptyLabel || '';
  }

  return utils.isValid(date) ? utils.format(date, format) : invalidLabel;
};

var getComparisonMaxDate = function getComparisonMaxDate(utils, strictCompareDates, date) {
  if (strictCompareDates) {
    return date;
  }

  return utils.endOfDay(date);
};

var getComparisonMinDate = function getComparisonMinDate(utils, strictCompareDates, date) {
  if (strictCompareDates) {
    return date;
  }

  return utils.startOfDay(date);
};

var validate = function validate(value, utils, _ref2) {
  var maxDate = _ref2.maxDate,
      minDate = _ref2.minDate,
      disablePast = _ref2.disablePast,
      disableFuture = _ref2.disableFuture,
      maxDateMessage = _ref2.maxDateMessage,
      minDateMessage = _ref2.minDateMessage,
      invalidDateMessage = _ref2.invalidDateMessage,
      strictCompareDates = _ref2.strictCompareDates;
  var parsedValue = utils.date(value); // if null - do not show error

  if (value === null) {
    return '';
  }

  if (!utils.isValid(value)) {
    return invalidDateMessage;
  }

  if (maxDate && utils.isAfter(parsedValue, getComparisonMaxDate(utils, !!strictCompareDates, utils.date(maxDate)))) {
    return maxDateMessage;
  }

  if (disableFuture && utils.isAfter(parsedValue, getComparisonMaxDate(utils, !!strictCompareDates, utils.date()))) {
    return maxDateMessage;
  }

  if (minDate && utils.isBefore(parsedValue, getComparisonMinDate(utils, !!strictCompareDates, utils.date(minDate)))) {
    return minDateMessage;
  }

  if (disablePast && utils.isBefore(parsedValue, getComparisonMinDate(utils, !!strictCompareDates, utils.date()))) {
    return minDateMessage;
  }

  return '';
};
function makeMaskFromFormat(format, numberMaskChar) {
  return format.replace(/[a-z]/gi, numberMaskChar);
}
var maskedDateFormatter = function maskedDateFormatter(mask, numberMaskChar, refuse) {
  return function (value) {
    var result = '';
    var parsed = value.replace(refuse, '');

    if (parsed === '') {
      return parsed;
    }

    var i = 0;
    var n = 0;

    while (i < mask.length) {
      var maskChar = mask[i];

      if (maskChar === numberMaskChar && n < parsed.length) {
        var parsedChar = parsed[n];
        result += parsedChar;
        n += 1;
      } else {
        result += maskChar;
      }

      i += 1;
    }

    return result;
  };
};

function ownKeys$1$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$1(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var KeyboardDateInput = function KeyboardDateInput(_ref) {
  var inputValue = _ref.inputValue,
      inputVariant = _ref.inputVariant,
      validationError = _ref.validationError,
      KeyboardButtonProps = _ref.KeyboardButtonProps,
      InputAdornmentProps = _ref.InputAdornmentProps,
      onOpen = _ref.openPicker,
      onChange = _ref.onChange,
      InputProps = _ref.InputProps,
      mask = _ref.mask,
      _ref$maskChar = _ref.maskChar,
      maskChar = _ref$maskChar === void 0 ? '_' : _ref$maskChar,
      _ref$refuse = _ref.refuse,
      refuse = _ref$refuse === void 0 ? /[^\d]+/gi : _ref$refuse,
      format = _ref.format,
      keyboardIcon = _ref.keyboardIcon,
      disabled = _ref.disabled,
      rifmFormatter = _ref.rifmFormatter,
      _ref$TextFieldCompone = _ref.TextFieldComponent,
      TextFieldComponent = _ref$TextFieldCompone === void 0 ? TextField__default['default'] : _ref$TextFieldCompone,
      other = _objectWithoutProperties(_ref, ["inputValue", "inputVariant", "validationError", "KeyboardButtonProps", "InputAdornmentProps", "openPicker", "onChange", "InputProps", "mask", "maskChar", "refuse", "format", "keyboardIcon", "disabled", "rifmFormatter", "TextFieldComponent"]);

  var inputMask = mask || makeMaskFromFormat(format, maskChar); // prettier-ignore

  var formatter = React$1.useMemo(function () {
    return maskedDateFormatter(inputMask, maskChar, refuse);
  }, [inputMask, maskChar, refuse]);
  var position = InputAdornmentProps && InputAdornmentProps.position ? InputAdornmentProps.position : 'end';

  var handleChange = function handleChange(text) {
    var finalString = text === '' || text === inputMask ? null : text;
    onChange(finalString);
  };

  return React$1.createElement(Rifm, {
    key: inputMask,
    value: inputValue,
    onChange: handleChange,
    refuse: refuse,
    format: rifmFormatter || formatter
  }, function (_ref2) {
    var onChange = _ref2.onChange,
        value = _ref2.value;
    return React$1.createElement(TextFieldComponent, _extends({
      disabled: disabled,
      error: Boolean(validationError),
      helperText: validationError
    }, other, {
      value: value,
      onChange: onChange,
      variant: inputVariant,
      InputProps: _objectSpread$1$1({}, InputProps, _defineProperty({}, "".concat(position, "Adornment"), React$1.createElement(InputAdornment__default['default'], _extends({
        position: position
      }, InputAdornmentProps), React$1.createElement(IconButton__default['default'], _extends({
        disabled: disabled
      }, KeyboardButtonProps, {
        onClick: onOpen
      }), keyboardIcon))))
    }));
  });
};
KeyboardDateInput.defaultProps = {
  keyboardIcon: React$1.createElement(KeyboardIcon, null)
};

function useOpenState(_ref) {
  var open = _ref.open,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose;
  var setIsOpenState = null;

  if (open === undefined || open === null) {
    // The component is uncontrolled, so we need to give it its own state.
    var _useState = React$1.useState(false);

    var _useState2 = _slicedToArray(_useState, 2);

    open = _useState2[0];
    setIsOpenState = _useState2[1];
  } // prettier-ignore


  var setIsOpen = React$1.useCallback(function (newIsOpen) {
    setIsOpenState && setIsOpenState(newIsOpen);
    return newIsOpen ? onOpen && onOpen() : onClose && onClose();
  }, [onOpen, onClose, setIsOpenState]);
  return {
    isOpen: open,
    setIsOpen: setIsOpen
  };
}

var useValueToDate = function useValueToDate(utils, _ref) {
  var value = _ref.value,
      initialFocusedDate = _ref.initialFocusedDate;
  var nowRef = React$1.useRef(utils.date());
  var date = utils.date(value || initialFocusedDate || nowRef.current);
  return date && utils.isValid(date) ? date : nowRef.current;
};

function useDateValues(props, options) {
  var utils = useUtils();
  var date = useValueToDate(utils, props);
  var format = props.format || options.getDefaultFormat();
  return {
    date: date,
    format: format
  };
}

function usePickerState(props, options) {
  var autoOk = props.autoOk,
      disabled = props.disabled,
      readOnly = props.readOnly,
      onAccept = props.onAccept,
      _onChange = props.onChange,
      onError = props.onError,
      value = props.value,
      variant = props.variant;
  var utils = useUtils();

  var _useOpenState = useOpenState(props),
      isOpen = _useOpenState.isOpen,
      setIsOpen = _useOpenState.setIsOpen;

  var _useDateValues = useDateValues(props, options),
      date = _useDateValues.date,
      format = _useDateValues.format;

  var _useState = React$1.useState(date),
      _useState2 = _slicedToArray(_useState, 2),
      pickerDate = _useState2[0],
      setPickerDate = _useState2[1];

  React$1.useEffect(function () {
    // if value was changed in closed state - treat it as accepted
    if (!isOpen && !utils.isEqual(pickerDate, date)) {
      setPickerDate(date);
    }
  }, [date, isOpen, pickerDate, utils]);
  var acceptDate = React$1.useCallback(function (acceptedDate) {
    _onChange(acceptedDate);

    if (onAccept) {
      onAccept(acceptedDate);
    }

    setIsOpen(false);
  }, [onAccept, _onChange, setIsOpen]);
  var wrapperProps = React$1.useMemo(function () {
    return {
      format: format,
      open: isOpen,
      onClear: function onClear() {
        return acceptDate(null);
      },
      onAccept: function onAccept() {
        return acceptDate(pickerDate);
      },
      onSetToday: function onSetToday() {
        return setPickerDate(utils.date());
      },
      onDismiss: function onDismiss() {
        setIsOpen(false);
      }
    };
  }, [acceptDate, format, isOpen, pickerDate, setIsOpen, utils]);
  var pickerProps = React$1.useMemo(function () {
    return {
      date: pickerDate,
      onChange: function onChange(newDate) {
        var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        setPickerDate(newDate);

        if (isFinish && autoOk) {
          acceptDate(newDate);
          return;
        } // simulate autoOk, but do not close the modal


        if (variant === 'inline' || variant === 'static') {
          _onChange(newDate);

          onAccept && onAccept(newDate);
        }
      }
    };
  }, [acceptDate, autoOk, onAccept, _onChange, pickerDate, variant]);
  var validationError = validate(value, utils, props);
  React$1.useEffect(function () {
    if (onError) {
      onError(validationError, value);
    }
  }, [onError, validationError, value]);
  var inputValue = getDisplayDate(date, format, utils, value === null, props);
  var inputProps = React$1.useMemo(function () {
    return {
      inputValue: inputValue,
      validationError: validationError,
      openPicker: function openPicker() {
        return !readOnly && !disabled && setIsOpen(true);
      }
    };
  }, [disabled, inputValue, readOnly, setIsOpen, validationError]);
  var pickerState = {
    pickerProps: pickerProps,
    inputProps: inputProps,
    wrapperProps: wrapperProps
  };
  React$1.useDebugValue(pickerState);
  return pickerState;
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseInputString(value, utils, format) {
  try {
    return utils.parse(value, format);
  } catch (_unused) {
    return null;
  }
}

function useKeyboardPickerState(props, options) {
  var _props$format = props.format,
      format = _props$format === void 0 ? options.getDefaultFormat() : _props$format,
      inputValue = props.inputValue,
      _onChange = props.onChange,
      value = props.value;
  var utils = useUtils();
  var displayDate = getDisplayDate(value, format, utils, value === null, props);

  var _useState = React$1.useState(displayDate),
      _useState2 = _slicedToArray(_useState, 2),
      innerInputValue = _useState2[0],
      setInnerInputValue = _useState2[1];

  var dateValue = inputValue ? parseInputString(inputValue, utils, format) : value;
  React$1.useEffect(function () {
    if (value === null || utils.isValid(value)) {
      setInnerInputValue(displayDate);
    }
  }, [displayDate, setInnerInputValue, utils, value]);
  var handleKeyboardChange = React$1.useCallback(function (date) {
    _onChange(date, date === null ? null : utils.format(date, format));
  }, [format, _onChange, utils]);

  var _usePickerState = usePickerState( // Extend props interface
  _objectSpread$2({}, props, {
    value: dateValue,
    onChange: handleKeyboardChange
  }), options),
      innerInputProps = _usePickerState.inputProps,
      wrapperProps = _usePickerState.wrapperProps,
      pickerProps = _usePickerState.pickerProps;

  var inputProps = React$1.useMemo(function () {
    return _objectSpread$2({}, innerInputProps, {
      // reuse validation and open/close logic
      format: wrapperProps.format,
      inputValue: inputValue || innerInputValue,
      onChange: function onChange(value) {
        setInnerInputValue(value || '');
        var date = value === null ? null : utils.parse(value, wrapperProps.format);

        _onChange(date, value);
      }
    });
  }, [innerInputProps, innerInputValue, inputValue, _onChange, utils, wrapperProps.format]);
  return {
    inputProps: inputProps,
    wrapperProps: wrapperProps,
    pickerProps: pickerProps
  };
}

function makePickerWithState(_ref) {
  var Input = _ref.Input,
      useState = _ref.useState,
      useOptions = _ref.useOptions,
      getCustomProps = _ref.getCustomProps,
      DefaultToolbarComponent = _ref.DefaultToolbarComponent;

  function PickerWithState(props) {
    var allowKeyboardControl = props.allowKeyboardControl,
        ampm = props.ampm,
        animateYearScrolling = props.animateYearScrolling;
        props.autoOk;
        var dateRangeIcon = props.dateRangeIcon,
        disableFuture = props.disableFuture,
        disablePast = props.disablePast,
        disableToolbar = props.disableToolbar;
        props.emptyLabel;
        props.format;
        props.forwardedRef;
        var hideTabs = props.hideTabs;
        props.initialFocusedDate;
        props.invalidDateMessage;
        props.invalidLabel;
        props.labelFunc;
        var leftArrowButtonProps = props.leftArrowButtonProps,
        leftArrowIcon = props.leftArrowIcon,
        loadingIndicator = props.loadingIndicator,
        maxDate = props.maxDate;
        props.maxDateMessage;
        var minDate = props.minDate;
        props.minDateMessage;
        var minutesStep = props.minutesStep;
        props.onAccept;
        props.onChange;
        props.onClose;
        var onMonthChange = props.onMonthChange;
        props.onOpen;
        var onYearChange = props.onYearChange,
        openTo = props.openTo,
        orientation = props.orientation,
        renderDay = props.renderDay,
        rightArrowButtonProps = props.rightArrowButtonProps,
        rightArrowIcon = props.rightArrowIcon,
        shouldDisableDate = props.shouldDisableDate,
        strictCompareDates = props.strictCompareDates,
        timeIcon = props.timeIcon,
        _props$ToolbarCompone = props.ToolbarComponent,
        ToolbarComponent = _props$ToolbarCompone === void 0 ? DefaultToolbarComponent : _props$ToolbarCompone;
        props.value;
        var variant = props.variant,
        views = props.views,
        other = _objectWithoutProperties(props, ["allowKeyboardControl", "ampm", "animateYearScrolling", "autoOk", "dateRangeIcon", "disableFuture", "disablePast", "disableToolbar", "emptyLabel", "format", "forwardedRef", "hideTabs", "initialFocusedDate", "invalidDateMessage", "invalidLabel", "labelFunc", "leftArrowButtonProps", "leftArrowIcon", "loadingIndicator", "maxDate", "maxDateMessage", "minDate", "minDateMessage", "minutesStep", "onAccept", "onChange", "onClose", "onMonthChange", "onOpen", "onYearChange", "openTo", "orientation", "renderDay", "rightArrowButtonProps", "rightArrowIcon", "shouldDisableDate", "strictCompareDates", "timeIcon", "ToolbarComponent", "value", "variant", "views"]);

    var injectedProps = getCustomProps ? getCustomProps(props) : {};
    var options = useOptions(props);

    var _useState = useState(props, options),
        pickerProps = _useState.pickerProps,
        inputProps = _useState.inputProps,
        wrapperProps = _useState.wrapperProps;

    return React$1.createElement(Wrapper, _extends({
      variant: variant,
      InputComponent: Input,
      DateInputProps: inputProps
    }, injectedProps, wrapperProps, other), React$1.createElement(Picker, _extends({}, pickerProps, {
      allowKeyboardControl: allowKeyboardControl,
      ampm: ampm,
      animateYearScrolling: animateYearScrolling,
      dateRangeIcon: dateRangeIcon,
      disableFuture: disableFuture,
      disablePast: disablePast,
      disableToolbar: disableToolbar,
      hideTabs: hideTabs,
      leftArrowButtonProps: leftArrowButtonProps,
      leftArrowIcon: leftArrowIcon,
      loadingIndicator: loadingIndicator,
      maxDate: maxDate,
      minDate: minDate,
      minutesStep: minutesStep,
      onMonthChange: onMonthChange,
      onYearChange: onYearChange,
      openTo: openTo,
      orientation: orientation,
      renderDay: renderDay,
      rightArrowButtonProps: rightArrowButtonProps,
      rightArrowIcon: rightArrowIcon,
      shouldDisableDate: shouldDisableDate,
      strictCompareDates: strictCompareDates,
      timeIcon: timeIcon,
      ToolbarComponent: ToolbarComponent,
      views: views
    })));
  }

  return PickerWithState;
}

var useStyles = styles$6.makeStyles({
  toolbar: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  toolbarLandscape: {
    padding: 16
  },
  dateLandscape: {
    marginRight: 16
  }
}, {
  name: 'MuiPickersDatePickerRoot'
});
var DatePickerToolbar = function DatePickerToolbar(_ref) {
  var date = _ref.date,
      views = _ref.views,
      setOpenView = _ref.setOpenView,
      isLandscape = _ref.isLandscape,
      openView = _ref.openView;
  var utils = useUtils();
  var classes = useStyles();
  var isYearOnly = React$1.useMemo(function () {
    return isYearOnlyView(views);
  }, [views]);
  var isYearAndMonth = React$1.useMemo(function () {
    return isYearAndMonthViews(views);
  }, [views]);
  return React$1.createElement(PickerToolbar, {
    isLandscape: isLandscape,
    className: clsx(!isYearOnly && classes.toolbar, isLandscape && classes.toolbarLandscape)
  }, React$1.createElement(ToolbarButton$1, {
    variant: isYearOnly ? 'h3' : 'subtitle1',
    onClick: function onClick() {
      return setOpenView('year');
    },
    selected: openView === 'year',
    label: utils.getYearText(date)
  }), !isYearOnly && !isYearAndMonth && React$1.createElement(ToolbarButton$1, {
    variant: "h4",
    selected: openView === 'date',
    onClick: function onClick() {
      return setOpenView('date');
    },
    align: isLandscape ? 'left' : 'center',
    label: utils.getDatePickerHeaderText(date),
    className: clsx(isLandscape && classes.dateLandscape)
  }), isYearAndMonth && React$1.createElement(ToolbarButton$1, {
    variant: "h4",
    onClick: function onClick() {
      return setOpenView('month');
    },
    selected: openView === 'month',
    label: utils.getMonthText(date)
  }));
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultProps = _objectSpread({}, datePickerDefaultProps, {
  openTo: 'date',
  views: ['year', 'date']
});

function useOptions(props) {
  var utils = useUtils();
  return {
    getDefaultFormat: function getDefaultFormat() {
      return getFormatByViews(props.views, utils);
    }
  };
}

var DatePicker$1 = makePickerWithState({
  useOptions: useOptions,
  Input: PureDateInput,
  useState: usePickerState,
  DefaultToolbarComponent: DatePickerToolbar
});
var KeyboardDatePicker = makePickerWithState({
  useOptions: useOptions,
  Input: KeyboardDateInput,
  useState: useKeyboardPickerState,
  DefaultToolbarComponent: DatePickerToolbar
});
DatePicker$1.defaultProps = defaultProps;
KeyboardDatePicker.defaultProps = defaultProps;

function DatePicker(props) {
  var label = props.label,
      value = props.value,
      name = props.name,
      error = props.error,
      required = props.required,
      errors = props.errors,
      onChange = props.onChange,
      readOnly = props.readOnly,
      autofocus = props.autofocus,
      minDate = props.minDate;
  var classes = useStyles$h();
  var defaultValue = value && new Date(value) || null;

  var _a = React__default['default'].useState(defaultValue),
      stateValue = _a[0],
      setValue = _a[1];

  var _b = React__default['default'].useState(errors),
      errorsState = _b[0],
      setErrors = _b[1];

  var _c = React__default['default'].useState(false),
      isDirtyRequired = _c[0],
      setDirtyRequired = _c[1];

  var _d = React__default['default'].useState(false),
      errorFormat = _d[0],
      setErrorFormat = _d[1];

  var handleDateChange = function handleDateChange(date) {
    setValue(date);

    if (onChange) {
      //  const newDate = formatApiDate(date);
      var isValidDate = date && isValid(date);
      onChange(name, !isValidDate ? null : formatApiDate(date));
    }

    if (!date && required) {
      setDirtyRequired(true);
    } else {
      setDirtyRequired(false);
    }
  };

  var handleBlur = function handleBlur(e) {
    if (!e.target.value && required) {
      setDirtyRequired(true);
    } else {
      setDirtyRequired(false);
    }

    var newdate = e.target.value.split("/").reverse().join("-");
    var dateWithoutUnderscore = newdate.replace(/[^0-9\-]/g, "");

    if (isValid(new Date(dateWithoutUnderscore)) && dateWithoutUnderscore.length === 10) {
      setErrorFormat(false);
    } else if (dateWithoutUnderscore && (!isValid(new Date(dateWithoutUnderscore)) || dateWithoutUnderscore.length !== 10)) {
      setErrorFormat(true);
    } else {
      setErrorFormat(false);
    }
  };

  React$1.useEffect(function () {
    if (value) {
      setValue(new Date(value));
      setDirtyRequired(false);
    } else if (value === "" || !value) {
      setValue(null);
    }
  }, [value]);
  React$1.useEffect(function () {
    if (errors) {
      setErrors(errors);
    } else {
      setErrors(null);
    }

    if (!required) {
      setDirtyRequired(false);
    }
  }, [errors, required]);
  var showLabel = label && required ? label + "*" : label;
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(MuiPickersUtilsProvider, {
    utils: DateFnsUtils__default['default'],
    locale: locale
  }, /*#__PURE__*/React__default['default'].createElement(KeyboardDatePicker, {
    name: name,
    disabled: readOnly,
    variant: "inline",
    format: "dd/MM/yyyy",
    margin: "normal",
    minDate: minDate,
    autoOk: true,
    autoFocus: autofocus,
    id: name,
    label: showLabel,
    value: stateValue,
    onChange: handleDateChange,
    onBlur: handleBlur,
    keyboardIcon: /*#__PURE__*/React__default['default'].createElement(Date$1, {
      width: 16
    }),
    inputProps: {
      "data-testid": "datePicker-input"
    },
    // @ts-ignore
    classes: {
      root: classes.formControl
    },
    InputProps: {
      classes: {
        root: classes.input,
        error: classes.errorInput,
        focused: classes.focused,
        disabled: classes.disabled
      },
      error: error || isDirtyRequired || errorsState || errorFormat ? true : false
    },
    InputLabelProps: {
      shrink: true,
      classes: {
        root: classes.label,
        error: classes.errorLabel,
        disabled: classes.disabledLabel
      }
    },
    KeyboardButtonProps: {
      "aria-label": label
    },
    error: error || isDirtyRequired || errorFormat ? true : false
  })), error && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, error), errorFormat && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, "Le format de la date n'est pas valide"), (isDirtyRequired || errorsState && errorsState.type === "required") && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, "Ce champ est obligatoire"));
}

function InputField(props) {
  var required = props.required,
      label = props.label,
      value = props.value,
      type = props.type,
      name = props.name,
      placeholder = props.placeholder,
      multiline = props.multiline,
      error = props.error,
      errors = props.errors,
      className = props.className,
      maxLength = props.maxLength,
      pattern = props.pattern,
      disabled = props.disabled,
      onBlur = props.onBlur,
      autofocus = props.autofocus,
      passwordType = props.passwordType,
      register = props.register,
      onChange = props.onChange,
      validate = props.validate,
      forceUpperCase = props.forceUpperCase;
  var classes = useStyles$h();
  var defaultValue = value || "";

  var _a = React__default['default'].useState(defaultValue),
      stateValue = _a[0],
      setValue = _a[1];

  var _b = React__default['default'].useState(errors),
      stateErrors = _b[0],
      setErrors = _b[1];

  var _c = React__default['default'].useState(error),
      stateError = _c[0],
      setError = _c[1];

  var _d = React__default['default'].useState(false),
      showPassword = _d[0],
      setShowPassword = _d[1]; // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setValue(event.target.value);
  //   // if (props.onChange) {
  //   //   props.onChange(event.target.value);
  //   //   setError(undefined);
  //   // }
  // };


  React$1.useEffect(function () {
    if (value) {
      setValue(value);
    } else {
      setValue("");
    }
  }, [value]);
  React$1.useEffect(function () {
    if (errors) {
      setErrors(errors);
    } else {
      setErrors("");
    }
  }, [errors]);
  React$1.useEffect(function () {
    if (error) {
      setError(error);
    } else {
      setError("");
    }
  }, [error]); // const handleBlur = (
  //   event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) => {
  //   if (onBlur) {
  //     onBlur(event);
  //   }
  // };

  var requiredAsterisk = required ? " *" : "";
  var typeInput = "text";

  if (type) {
    typeInput = type;
  }

  if (passwordType && showPassword === false) {
    typeInput = "password";
  }

  var classNames = className;

  if (forceUpperCase) {
    classNames += " " + classes.forceUpperCase;
  }

  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(core.FormControl, {
    className: classes.formControl + " " + classNames,
    margin: "normal"
  }, /*#__PURE__*/React__default['default'].createElement(core.TextField, __assign({
    id: name,
    autoFocus: autofocus,
    autoComplete: passwordType ? "new-password" : "off",
    hidden: passwordType,
    InputProps: {
      classes: {
        root: classes.input,
        error: classes.errorInput,
        focused: classes.focused,
        disabled: classes.disabledInput
      },
      error: stateErrors || stateError ? true : false,
      endAdornment: passwordType && /*#__PURE__*/React__default['default'].createElement(core.InputAdornment, {
        position: "end",
        classes: {
          root: classes.endAdornment
        }
      }, /*#__PURE__*/React__default['default'].createElement("div", {
        "aria-label": "Afficher le mot de passe",
        onClick: function onClick() {
          return setShowPassword(!showPassword);
        }
      }, showPassword ? /*#__PURE__*/React__default['default'].createElement(Visibility, {
        className: classes.iconAdornment
      }) : /*#__PURE__*/React__default['default'].createElement(VisibilityOff, {
        className: classes.iconAdornment
      })))
    },
    disabled: disabled,
    placeholder: placeholder || "",
    multiline: multiline,
    rows: multiline ? 4 : 1,
    defaultValue: stateValue
  }, register(name, {
    required: required,
    onBlur: onBlur,
    onChange: onChange,
    pattern: pattern,
    validate: validate,
    maxLength: maxLength
  }), {
    type: typeInput,
    InputLabelProps: {
      shrink: true,
      classes: {
        root: classes.label,
        error: classes.errorLabel,
        disabled: classes.disabledLabel
      }
    },
    inputProps: {
      maxLength: maxLength || 150,
      type: typeInput
    },
    error: stateError ? true : false,
    label: label && label + requiredAsterisk
  }))), " ", stateErrors && stateErrors.type === "required" && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, "Ce champ est obligatoire"), stateErrors && stateErrors.type === "pattern" && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, stateErrors.message), stateErrors && stateErrors.type === "validate" && name === "immatriculation" && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    dangerouslySetInnerHTML: {
      __html: messageErrorImmat
    }
  })), " ", stateErrors && stateErrors.type === "validate" && name === "confirmationMdpTemporaire" && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, /*#__PURE__*/React__default['default'].createElement("p", null, "Les mots de passe ne sont pas identiques")), stateErrors && stateErrors.type === "validate" && name.startsWith("numeroSerie") && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, /*#__PURE__*/React__default['default'].createElement("p", null, "Ce v\xE9hicule est pr\xE9sent plus d'une fois dans la liste.")), stateError && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    dangerouslySetInnerHTML: {
      __html: stateError
    }
  })), errors && errors.type === "maxLength" && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, /*#__PURE__*/React__default['default'].createElement("p", {
    dangerouslySetInnerHTML: {
      __html: "Taille maximum atteinte (max:" + maxLength + " caractères)"
    }
  })));
}

// import messages from '../../../traductions/index';

function InputSearch(props) {
  var value = props.value,
      name = props.name,
      placeholder = props.placeholder,
      fetchOptions = props.fetchOptions,
      options = props.options,
      onSelect = props.onSelect,
      onChange = props.onChange,
      fetching = props.fetching,
      error = props.error,
      autofocus = props.autofocus,
      t = props.t;
  var classes = useStyles$h();
  var defaultValue = value || null;

  var _a = React__default['default'].useState(defaultValue),
      stateValue = _a[0],
      setValue = _a[1];

  var _b = React__default['default'].useState(defaultValue && defaultValue.value || ""),
      inputValue = _b[0],
      setInputValue = _b[1]; //const [openSearch, setOpenSearch] = React.useState(false);


  var _c = React__default['default'].useState(null),
      anchorEl = _c[0],
      setAnchorEl = _c[1];

  var handleChange = function handleChange(event) {
    setInputValue(event.target.value);

    if (onChange) {
      onChange(event.target.value);
    }
  };

  var handleSearch = function handleSearch(event) {
    fetchOptions(stateValue);
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var handleSelect = function handleSelect(value) {
    setValue(value);
    setInputValue(value.value);
    setAnchorEl(null);

    if (onSelect) {
      onSelect(name, value);
    }
  };

  var handleKeypress = function handleKeypress(e) {
    if (e.key === "Enter") {
      handleSearch(e);
    }
  };

  var handleBlur = function handleBlur() {
    var open = Boolean(anchorEl);

    if (value && !open) {
      setInputValue(value.value);
    }
  };

  React$1.useEffect(function () {
    if (value) {
      setValue(value);
      setInputValue(value.value);
    } else {
      setValue(null);
      setInputValue("");
    }
  }, [value]);
  var open = Boolean(anchorEl);
  var hasError = error && error.response && error.response.status === 404 ? t("errors.aucunResultat") : t("errors.erreurSurvenue");
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(core.FormControl, {
    className: classes.formControl,
    margin: "normal"
  }, /*#__PURE__*/React__default['default'].createElement(core.Input, {
    autoFocus: autofocus,
    name: name,
    classes: {
      root: classes.input,
      error: classes.errorInput,
      focused: classes.focused
    },
    placeholder: placeholder || "",
    id: name,
    defaultValue: inputValue,
    value: inputValue,
    onChange: handleChange,
    onKeyPress: handleKeypress,
    onBlur: handleBlur,
    type: "text",
    inputProps: {
      maxLength: 30,
      "data-testid": "inputSearch-input"
    },
    endAdornment: /*#__PURE__*/React__default['default'].createElement(core.InputAdornment, {
      position: "end"
    }, /*#__PURE__*/React__default['default'].createElement(core.IconButton, {
      "aria-label": "rechercher",
      "data-testid": "buttonSearch-input",
      id: "id",
      onClick: handleSearch,
      onMouseDown: handleSearch
    }, /*#__PURE__*/React__default['default'].createElement(Search, null)))
  })), /*#__PURE__*/React__default['default'].createElement(core.Popover, {
    id: "id",
    open: open,
    anchorEl: anchorEl,
    onClose: handleClose,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    },
    classes: {
      paper: classes.paperPopover
    }
  }, fetching && /*#__PURE__*/React__default['default'].createElement(LoadingIcon, {
    size: "small"
  }), options && options.length > 0 && !fetching && !error && options.map(function (o) {
    return /*#__PURE__*/React__default['default'].createElement("button", {
      key: o.id,
      title: "options",
      onClick: function onClick() {
        return handleSelect(o);
      }
    }, o.value);
  }), !error && !fetching && options && options.length === 0 && /*#__PURE__*/React__default['default'].createElement("p", null, "Aucun r\xE9sultat"), error && !fetching && /*#__PURE__*/React__default['default'].createElement("p", null, hasError)));
}

function Select(props) {
  var options = props.options,
      label = props.label,
      name = props.name,
      value = props.value,
      required = props.required,
      inputRef = props.inputRef,
      error = props.error,
      readOnly = props.readOnly,
      errors = props.errors,
      noDelete = props.noDelete,
      tooltip = props.tooltip,
      tabIndex = props.tabIndex;
  var classes = useStyles$h();
  var defaultValue = value || "";
  var isReadOnly = readOnly;

  if (options && options.length === 1) {
    defaultValue = options[0].id;
    isReadOnly = true;
  }

  var _a = React__default['default'].useState(defaultValue),
      stateValue = _a[0],
      setStateValue = _a[1];

  var _b = React__default['default'].useState(errors),
      stateErrors = _b[0],
      setErrors = _b[1];

  var _c = React__default['default'].useState(error),
      stateError = _c[0],
      setError = _c[1];

  var _d = React__default['default'].useState(false),
      isDirtyRequired = _d[0],
      setDirtyRequired = _d[1];

  var onChange = function onChange(e) {
    setStateValue(e === null || e === void 0 ? void 0 : e.target.value);

    if (props.onChange) {
      props.onChange(name, e === null || e === void 0 ? void 0 : e.target.value);
    }

    if (!e.target.value && required) {
      setDirtyRequired(true);
    } else {
      setDirtyRequired(false);
    }
  };

  var handleBlur = function handleBlur(e) {
    if (!e.target.value && required) {
      setDirtyRequired(true);
    } else {
      setDirtyRequired(false);
    }
  };

  React$1.useEffect(function () {
    if (value && (options === null || options === void 0 ? void 0 : options.find(function (o) {
      return o.id === value;
    }))) {
      setStateValue(value);
      setDirtyRequired(false);
    } else if (options && options.length === 1) {
      setStateValue(options[0].id);
      isReadOnly = true;

      if (props.onChange) {
        props.onChange(name, options[0].id);
      }
    } else {
      setStateValue("");
    }
  }, [value, options]);
  React$1.useEffect(function () {
    if (errors) {
      setErrors(errors);
    } else {
      setErrors("");
    }
  }, [errors]);
  React$1.useEffect(function () {
    if (error) {
      setError(error);
    } else {
      setError("");
    }
  }, [error]);
  var requiredAsterisk = required ? "*" : "";

  var handleDeleteValue = function handleDeleteValue() {
    setStateValue("");

    if (props.onChange) {
      props.onChange(name, null);
    }

    if (required) {
      setDirtyRequired(true);
    } else {
      setDirtyRequired(false);
    }
  };

  var labelClassName = classes.label;

  if (isReadOnly) {
    labelClassName += " " + classes.disabledLabel;
  }

  var labelValue = options && options.find(function (o) {
    return o.id === stateValue;
  });
  var select = /*#__PURE__*/React__default['default'].createElement(core.Select, __assign({
    labelId: name + "label",
    // label={label + requiredAsterisk}
    id: name,
    IconComponent: ExpandMore,
    tabIndex: tabIndex,
    classes: {
      select: classes.select,
      icon: classes.iconSelect
    },
    input: /*#__PURE__*/React__default['default'].createElement(core.InputBase, {
      classes: {
        root: classes.input,
        focused: classes.focused,
        error: classes.errorInput,
        disabled: classes.disabledInput
      }
    }),
    error: stateError || isDirtyRequired || stateErrors ? true : false,
    value: stateValue,
    onChange: onChange,
    onBlur: handleBlur
  }, inputRef, {
    disabled: isReadOnly,
    displayEmpty: true
  }), options === null || options === void 0 ? void 0 : options.map(function (o) {
    return /*#__PURE__*/React__default['default'].createElement(core.MenuItem, {
      key: o.id,
      value: o.id,
      classes: {
        root: classes.listElement
      }
    }, o.value);
  }));
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(core.FormControl, {
    className: classes.formControl,
    margin: "normal"
  }, /*#__PURE__*/React__default['default'].createElement("label", {
    id: name + "label",
    className: labelClassName
  }, label + requiredAsterisk), tooltip ? /*#__PURE__*/React__default['default'].createElement(core.Tooltip, {
    title: labelValue && labelValue.value || ""
  }, select) : select, noDelete || isReadOnly ? undefined : /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.clearIcon
  }, /*#__PURE__*/React__default['default'].createElement(core.IconButton, {
    "aria-label": "supprimer la valeur",
    onClick: handleDeleteValue,
    tabIndex: "-1"
  }, /*#__PURE__*/React__default['default'].createElement(CloseOutlined, {
    fontSize: "small"
  })))), stateError && /*#__PURE__*/React__default['default'].createElement("span", {
    className: classes.showError
  }, stateError), (isDirtyRequired || stateErrors && stateErrors.type === "required") && /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes.messageError
  }, "Ce champ est obligatoire"));
}

var MentionsLegales = function MentionsLegales(props) {
  React$1.useEffect(function () {
    window.scrollTo(0, 0);
  }, []);
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement(core.Typography, {
    variant: "h1"
  }, "Mentions L\xE9gales"), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement(Card, null, /*#__PURE__*/React__default['default'].createElement(core.Typography, {
    variant: "h3"
  }, "Identification"), /*#__PURE__*/React__default['default'].createElement("p", null, "Ce site est \xE9dit\xE9 par SAGA SERVICE PLUS (ci-apr\xE8s \xAB ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), " \xBB), soci\xE9t\xE9 par actions simplifi\xE9e au capital de 133 950 euros, immatricul\xE9e au RCS de Nantes sous le n\xB0350 751 129, dont le si\xE8ge social est situ\xE9 46 bis rue des Hauts Pav\xE9s 44000 NANTES.", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), "Conseil et courtier en assurances (exer\xE7ant conform\xE9ment \xE0 l\u2019article L521-2-1\xB0b) du Code des assurances)- La liste des fournisseurs actifs est disponible au point 10 ci-dessous. Immatriculation \xE0 l\u2019Organisme pour le Registre des Interm\xE9diaires en Assurances (ORIAS) sous le num\xE9ro 07 019 221 \u2013", " ", /*#__PURE__*/React__default['default'].createElement("a", {
    href: "www.orias.fr",
    target: "_blank"
  }, "www.orias.fr"), ". ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), " est soumise au contr\xF4le de l\u2019Autorit\xE9 de Contr\xF4le Prudentiel et de R\xE9solution (ACPR), 4 place de Budapest 75009 Paris.", " ", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), "Directeur de la publication : Monsieur Pierre BESSE.", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), "Responsable de la r\xE9daction et h\xE9bergeur : GIE INFO 2, 46 bis rue des Hauts Pav\xE9s - 44000 NANTES.", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), "Toute r\xE9clamation ou demande sur les proc\xE9dures de m\xE9diation peuvent \xEAtre adress\xE9es par \xE9crit \xE0 l\u2019adresse suivante :", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), "Service R\xE9clamation / Info m\xE9diation - 46 bis rue des Hauts Pav\xE9s 44000 Nantes.", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), "Vous recevrez un accus\xE9 de r\xE9ception sous 10 jours maximum et une r\xE9ponse dans un d\xE9lai maximum de 2 mois \xE0 compter de l\u2019envoi de votre r\xE9clamation.", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), "En tout \xE9tat de cause, deux (2) mois apr\xE8s l\u2019envoi de votre premi\xE8re r\xE9clamation \xE9crite, quel que soit l\u2019interlocuteur ou le service aupr\xE8s duquel elle a \xE9t\xE9 formul\xE9e et qu\u2019il y ait \xE9t\xE9 ou non r\xE9pondu, vous avez la possibilit\xE9 de saisir le M\xE9diateur de l'Assurance : par courrier \xE0 l\u2019adresse suivante : La M\xE9diation de L\u2019assurance - TSA 50110 - 75441 PARIS Cedex 09, ou en vous rendant sur le site suivant :", /*#__PURE__*/React__default['default'].createElement("a", {
    href: "http://www.mediation-assurance.org/",
    target: "_blank"
  }, "La m\xE9diation de l'assurance - Accueil"), ".", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null)), /*#__PURE__*/React__default['default'].createElement(core.Typography, {
    variant: "h3"
  }, "Conditions d'utilisation"), "Nous vous recommandons de lire attentivement les pr\xE9sentes conditions d\u2019utilisation (\"", /*#__PURE__*/React__default['default'].createElement("b", null, "les Conditions"), "\") et de les consulter de mani\xE8re r\xE9guli\xE8re car elles sont susceptibles d\u2019\xEAtre modifi\xE9es.", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), "En acc\xE9dant \xE0 ce site, vous acceptez d\u2019\xEAtre li\xE9(e) par ces Conditions, et notamment par notre politique en mati\xE8re de gestion des donn\xE9es personnelles. Si vous n\u2019acceptez pas d\u2019\xEAtre li\xE9(e) par ces Conditions, vous ne devez pas acc\xE9der au pr\xE9sent site ni en consulter les pages.", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("ul", null, /*#__PURE__*/React__default['default'].createElement("li", null, "Bien que ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), " ait pris soin de s\u2019assurer que les informations pr\xE9sent\xE9es sur le site soient correctes au moment de leur mise en ligne, ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), " ne garantit aucunement leur exactitude et leur exhaustivit\xE9 et ne saurait en cons\xE9quence \xEAtre tenu responsable d\u2019\xE9ventuelles erreurs, inexactitudes ou omissions les concernant. Le pr\xE9sent site est mis \xE0 votre disposition de mani\xE8re gracieuse, sans aucune garantie de quelque nature que ce soit quant \xE0 son contenu.", " ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), " ne pourra \xEAtre tenu responsable de tout dommage li\xE9 au contenu, \xE0 l\u2019utilisation du site ou \xE0 tout message qui pourrait \xEAtre envoy\xE9 via le site.", /*#__PURE__*/React__default['default'].createElement("br", null), "La responsabilit\xE9 de ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), " ne pourra pas non plus \xEAtre recherch\xE9e en cas de panne, inaccessibilit\xE9, d\xE9faillance, bug ou difficult\xE9 de fonctionnement de tout ou partie du site."), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("li", null, /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), " est le propri\xE9taire exclusif ou d\xE9tient les droits d\u2019usage de tous les \xE9l\xE9ments constituant le site et de tous les droits de propri\xE9t\xE9 intellectuelle qui y sont attach\xE9s, ce qui inclut sans limitation : les marques, les logos, les noms de domaine, les photographies, les illustrations, les images anim\xE9es ou non, les films, les graphismes, les commentaires, les textes, les sons, les applications informatiques, les logiciels. L\u2019ensemble de ces \xE9l\xE9ments est prot\xE9g\xE9 par la loi.", /*#__PURE__*/React__default['default'].createElement("br", null), "Toute repr\xE9sentation, utilisation, reproduction, exploitation, adaptation, modification, publication ou distribution de tout ou partie du site et des droits qui y sont attach\xE9s, faites sans le consentement pr\xE9alable, expr\xE8s et \xE9crit de ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), ", est illicite et constituera une contrefa\xE7on quel que soient les supports et les moyens utilis\xE9s.", /*#__PURE__*/React__default['default'].createElement("br", null), "Aucun manquement ou retard de ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), " \xE0 engager une quelconque proc\xE9dure pour faire respecter ses droits, ne saurait \xEAtre consid\xE9r\xE9 ou constituer une renonciation ou une renonciation ult\xE9rieure \xE0 exercer un tel droit."), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("li", null, "Il est strictement interdit de rendre tout ou partie de ce site disponible sur un autre site, que ce soit par l\u2019utilisation d\u2019un hyperlien ou de toute autre mani\xE8re, \xE0 moins d\u2019y avoir \xE9t\xE9 express\xE9ment autoris\xE9 au pr\xE9alable et par \xE9crit par ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), ". Pour obtenir une autorisation, vous devez envoyer soit un courriel soit un courrier postal \xE0 ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), " aux coordonn\xE9es mentionn\xE9es ci-dessous au point 9. avec les informations suivantes :", /*#__PURE__*/React__default['default'].createElement("ul", null, /*#__PURE__*/React__default['default'].createElement("li", null, "votre nom ou le nom du contact technique ayant la responsabilit\xE9 des liens,"), /*#__PURE__*/React__default['default'].createElement("li", null, "le nom de votre soci\xE9t\xE9,"), /*#__PURE__*/React__default['default'].createElement("li", null, "votre adresse m\xE8l et votre num\xE9ro de t\xE9l\xE9phone ou l\u2019adresse m\xE8l et le num\xE9ro de t\xE9l\xE9phone du contact technique responsable des liens,"), /*#__PURE__*/React__default['default'].createElement("li", null, "l\u2019adresse ou les adresses des sites sur lesquels les liens vers la page d\u2019accueil figureront."))), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("li", null, "Ce site peut contenir des liens hypertextes vers d\u2019autres sites, mis en place avec l\u2019autorisation de ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), ". N\xE9anmoins, ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), " ", "ne contr\xF4le en aucune mani\xE8re le contenu de ces sites et n\u2019assumera en cons\xE9quence aucune responsabilit\xE9 li\xE9e \xE0 ces sites."), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("li", null, /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), " se r\xE9serve le droit \xE0 tout moment et sans avis pr\xE9alable d'am\xE9liorer, de modifier, de suspendre ou de cesser de mani\xE8re permanente tout ou partie du site et de restreindre ou d\u2019interdire l\u2019acc\xE8s \xE0 ce dernier."), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("li", null, "Les informations contenues dans le site ne constituent en aucun cas des conseils, une offre commerciale, une offre \xE0 contracter ou des avis juridiques. Pour des raisons de s\xE9curit\xE9, il est prudent de consid\xE9rer qu'une demande de garantie d'assurance, de prise d'effet de garantie, ou de d\xE9claration de sinistre, n'aura \xE9t\xE9 prise en compte qu'\xE0 partir du moment o\xF9 elle aura donn\xE9 lieu \xE0 une r\xE9ponse personnalis\xE9e du destinataire (\xE0 l'exclusion donc de tout proc\xE9d\xE9 automatique d'accus\xE9 de r\xE9ception ou de lecture). A d\xE9faut, votre message devra \xEAtre consid\xE9r\xE9 comme non re\xE7u."), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("li", null, "Les pr\xE9sentes Conditions peuvent \xEAtre modifi\xE9es \xE0 tout moment par", " ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), ". L\u2019utilisation de ce site \xE0 la suite de ces changements emporte votre acceptation de ces derniers."), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("li", null, "Pour toute question ou demande que vous pourriez avoir en relation avec le pr\xE9sent site, les pr\xE9sentes Conditions ou sur ", /*#__PURE__*/React__default['default'].createElement("b", null, "SAGA"), ", vous pouvez nous \xE9crire par courriel \xE0 l\u2019adresse suivante :", " ", /*#__PURE__*/React__default['default'].createElement("a", {
    href: "mailto:contact@sagaserviceplus.fr"
  }, "contact@sagaserviceplus.fr"), " ", "ou par courrier postal \xE0 l\u2019adresse suivante : SAGA, 46 bis rue des Hauts Pav\xE9s \u2013 BP 52 216 - 44 022 Nantes Cedex 01."), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("li", null, "Les pr\xE9sentes Conditions et le contenu du pr\xE9sent site sont r\xE9gis par la loi fran\xE7aise dont les tribunaux ont comp\xE9tence exclusive dans le r\xE8glement de tout litige. En cas de litige concernant un consommateur non professionnel, conform\xE9ment \xE0 L 133-4 du Code de la consommation, vous disposez de la facult\xE9 de saisir un m\xE9diateur. Liste des m\xE9diateurs disponible sur simple demande \xE0 l\u2019adresse indiqu\xE9e au point 9."), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("li", null, "Liste des fournisseurs actifs : Europ Assistance ; Mondial Assistance (y.c Fragonard SA et AWP P&C SA)"))), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement(Footer, null));
};

var DonneesPersonnelles = function DonneesPersonnelles(props) {
  React$1.useEffect(function () {
    window.scrollTo(0, 0);
  }, []);
  return /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement(core.Typography, {
    variant: "h1"
  }, "Donn\xE9es Personnelles"), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement(Card, null, /*#__PURE__*/React__default['default'].createElement("p", null, "Dans le cadre des services d\u2019accompagnement et de conseil en assurances que nous vous apportons, ainsi que pour l\u2019ex\xE9cution de vos contrats d\u2019assurances, des donn\xE9es personnelles seront collect\xE9es et trait\xE9es par SAGA SERVICE PLUS \u2013 46 bis rue des hauts pav\xE9s 44000 NANTES. ", /*#__PURE__*/React__default['default'].createElement("br", null), " ", /*#__PURE__*/React__default['default'].createElement("br", null), "Plus pr\xE9cis\xE9ment, le traitement de ces donn\xE9es personnelles nous permettra d\u2019analyser efficacement le dossier de candidature, de mettre en \u0153uvre la gestion et l\u2019ex\xE9cution de vos contrats d\u2019assurances ainsi que la gestion de vos sinistres et de vos indemnisations. Vos donn\xE9es pourront aussi \xEAtre utilis\xE9es pour nous permettre de respecter nos obligations de vigilance (lutte contre la fraude, le blanchiment de capitaux et le financement du terrorisme). Elles pourront faire l\u2019objet d\u2019analyses et de statistiques afin d\u2019am\xE9liorer notre accompagnement, nos services et nos produits et ainsi optimiser la relation client.", /*#__PURE__*/React__default['default'].createElement("br", null), " ", /*#__PURE__*/React__default['default'].createElement("br", null), "Ces traitements sont fond\xE9s sur l\u2019ex\xE9cution du contrat qui nous lie, le respect de nos obligations l\xE9gales de connaissance de nos clients et de vigilance, ainsi que sur l\u2019int\xE9r\xEAt l\xE9gitime du courtier en assurances (bases juridiques).", /*#__PURE__*/React__default['default'].createElement("br", null), " ", /*#__PURE__*/React__default['default'].createElement("br", null), "Les donn\xE9es requises doivent \xEAtre imp\xE9rativement renseign\xE9es afin que nous puissions g\xE9rer vos demandes de souscription et l\u2019ex\xE9cution de vos contrats. En cas de fausses d\xE9clarations ou d\u2019omissions, les cons\xE9quences peuvent \xEAtre le refus de vos souscriptions, la nullit\xE9 du contrat souscrit ou la r\xE9duction des garanties.", /*#__PURE__*/React__default['default'].createElement("br", null), " ", /*#__PURE__*/React__default['default'].createElement("br", null), "Les donn\xE9es seront conserv\xE9es tant que le contrat est actif (\xE9ventuellement augment\xE9e de la dur\xE9e de prescription li\xE9e \xE0 toutes actions d\xE9coulant de la souscription). En cas de sinistre ou de litige, la dur\xE9e de conservation est prorog\xE9e jusqu\u2019\xE0 l\u2019\xE9coulement des prescriptions desdites actions. Lorsqu\u2019une obligation l\xE9gale nous impose de devoir disposer des donn\xE9es personnelles, elles seront conserv\xE9es aussi longtemps que cette obligation l\xE9gale s\u2019impose \xE0 nous. En l\u2019absence de conclusion d\u2019un contrat, les donn\xE9es personnelles sont conserv\xE9es pour une dur\xE9e de 3 ans depuis le dernier contact.", /*#__PURE__*/React__default['default'].createElement("br", null), " ", /*#__PURE__*/React__default['default'].createElement("br", null), "Dans le cadre susmentionn\xE9, les donn\xE9es pourront \xEAtre communiqu\xE9es aux autres soci\xE9t\xE9s Bess\xE9, aux assureurs et aux experts, \xE0 nos sous-traitants (comme nos prestataires informatiques), aux autorit\xE9s publiques et \xE0 nos partenaires interm\xE9diaires en assurances.", /*#__PURE__*/React__default['default'].createElement("br", null), " ", /*#__PURE__*/React__default['default'].createElement("br", null), "En outre, certaines donn\xE9es personnelles pourront \xEAtre utilis\xE9es, mais avec l\u2019accord expr\xE8s du titulaire, par nos partenaires commerciaux afin de vous proposer d\u2019autres services et offres visant \xE0 mieux vous accompagner.", /*#__PURE__*/React__default['default'].createElement("br", null), " ", /*#__PURE__*/React__default['default'].createElement("br", null), "Conform\xE9ment \xE0 la loi, chaque titulaire peut demander l\u2019acc\xE8s, la rectification, l\u2019effacement ou la portabilit\xE9 de ses donn\xE9es, d\xE9finir des consignes relatives \xE0 leur sort apr\xE8s son d\xE9c\xE8s, choisir d\u2019en limiter l\u2019usage ou s\u2019opposer \xE0 leur traitement en \xE9crivant par courriel \xE0 notre D\xE9l\xE9gu\xE9 \xE0 la Protection des Donn\xE9es :", " ", /*#__PURE__*/React__default['default'].createElement("a", {
    href: "mailto:dpo@besse.fr"
  }, "dpo@besse.fr"), ". Si le titulaire a donn\xE9 une autorisation expresse \xE0 l\u2019utilisation de certaines de ses donn\xE9es, il peut de la m\xEAme mani\xE8re la retirer \xE0 tout moment sous r\xE9serve qu\u2019il ne s\u2019agisse pas d\u2019informations indispensables \xE0 l\u2019application de son contrat. En cas de r\xE9clamation, le titulaire peut choisir de saisir la CNIL.", /*#__PURE__*/React__default['default'].createElement("br", null), " ", /*#__PURE__*/React__default['default'].createElement("br", null), "Le traitement des donn\xE9es personnelles est effectu\xE9 de mani\xE8re s\xE9curis\xE9e dans notre syst\xE8me d\u2019information. Nous veillons \xE0 sensibiliser et former r\xE9guli\xE8rement nos collaborateurs \xE0 la bonne pr\xE9servation des donn\xE9es personnelles.", /*#__PURE__*/React__default['default'].createElement("br", null), " ", /*#__PURE__*/React__default['default'].createElement("br", null)), /*#__PURE__*/React__default['default'].createElement(core.Typography, {
    variant: "h3"
  }, "EN SAVOIR PLUS SUR LES COOKIES"), /*#__PURE__*/React__default['default'].createElement("h3", null, "Qu\u2019est-ce qu\u2019un \xAB cookie \xBB ? "), /*#__PURE__*/React__default['default'].createElement("p", null, "Lorsque vous consultez un site internet, sous r\xE9serve de votre choix et des param\xE8tres choisis dans votre navigateur, des fichiers de donn\xE9es peuvent \xEAtre d\xE9pos\xE9s temporairement en m\xE9moire ou sur un espace d\xE9di\xE9 du disque dur de votre ordinateur. ", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), "Le d\xE9p\xF4t et la lecture des cookies permettent au d\xE9tenteur d\u2019un site de notamment mieux comprendre comment les internautes interagissent avec le site, d\u2019\xE9tablir des statistiques de visites, d\u2019acc\xE9der \xE0 des services s\xE9curis\xE9s et ainsi am\xE9liorer la morphologie du site.", /*#__PURE__*/React__default['default'].createElement("br", null), "La dur\xE9e de validit\xE9 d\u2019un cookie est de 6 mois maximum. A l\u2019issue de ce d\xE9lai, le consentement de l\u2019utilisateur sera de nouveau sollicit\xE9 via l\u2019affichage du bandeau d\u2019information. ", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null)), /*#__PURE__*/React__default['default'].createElement("h3", null, "Quels types de cookies sont utilis\xE9s sur le site ?"), /*#__PURE__*/React__default['default'].createElement("p", null, "Deux types de cookies sont utilis\xE9s sur ce site.", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("strong", null, "Cookies strictement n\xE9cessaires\u202F: "), /*#__PURE__*/React__default['default'].createElement("br", null), "Ces cookies sont indispensables pour vous permettre de naviguer au sein du site et d\u2019utiliser les fonctionnalit\xE9s propos\xE9es, notamment pour acc\xE9der aux sections s\xE9curis\xE9es.", /*#__PURE__*/React__default['default'].createElement("br", null), "Sans ces cookies, les services demand\xE9es ne pourront pas \xEAtre assur\xE9s.", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("strong", null, "Cookies de performance\u202F: "), /*#__PURE__*/React__default['default'].createElement("br", null), "Ces cookies nous permettent de d\xE9terminer le nombre de visites et les sources du trafic sur notre site web, afin de mesurer et d\u2019am\xE9liorer les performances. Ils nous aident \xE9galement \xE0 identifier les pages les plus / moins visit\xE9es et \xE0 \xE9valuer comment les visiteurs naviguent sur le site. ", /*#__PURE__*/React__default['default'].createElement("br", null), "Toutes les informations collect\xE9es par ces cookies, sont agr\xE9g\xE9es et donc anonymis\xE9es. Si vous n\u2019acceptez pas ces cookies, nous ne pourrons pas savoir quand vous aurez r\xE9alis\xE9 votre visite sur notre site web, et nous ne pourrons pas mesurer sa performance.", /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("strong", null, "Comment param\xE9trer vos cookies ?"), " ", /*#__PURE__*/React__default['default'].createElement("br", null), "Le param\xE9trage des cookies se fait par le bandeau d\u2019information qui apparait lors de la 1\xE8re connexion.", /*#__PURE__*/React__default['default'].createElement("br", null), "Ce bandeau vous sera propos\xE9 tous les 6 mois.", /*#__PURE__*/React__default['default'].createElement("br", null), "Vous pouvez l\u2019afficher de nouveau en cliquant", " ", /*#__PURE__*/React__default['default'].createElement("a", {
    href: "/",
    onClick: props.setCookies
  }, "ici."), " ")), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement("br", null), /*#__PURE__*/React__default['default'].createElement(Footer, null));
};

exports.Accordeon = Accordeon;
exports.AsyncAutoComplete = AutoComplete$1;
exports.AutoComplete = AutoComplete;
exports.BlocMaintenance = BlocMaintenance;
exports.BlocTags = BlocTags;
exports.BlocTextes = BlocTextes;
exports.BoxCollapsed = BoxCollapsed;
exports.BoxColumns = BoxColumns;
exports.Button = Button;
exports.ButtonHeader = LinkButton$1;
exports.Card = Card;
exports.Checkbox = Checkbox;
exports.DatePicker = DatePicker;
exports.DonneesPersonnelles = DonneesPersonnelles;
exports.Footer = Footer;
exports.Header = Header;
exports.HeaderConnected = HeaderConnected;
exports.InfoBulle = InfoBulle;
exports.InputField = InputField;
exports.InputSearch = InputSearch;
exports.LinkButton = LinkButton;
exports.ListCard = ListCard;
exports.ListCheckbox = ListCheckbox;
exports.ListTransfer = ListTransfer;
exports.LoadingIcon = LoadingIcon;
exports.MentionsLegales = MentionsLegales;
exports.Modale = Modale;
exports.MultiAutocomplete = AutoComplete$2;
exports.Popover = PopoverComponent;
exports.PopoverFiltres = PopoverFiltres;
exports.PopoverList = PopoverList;
exports.Radios = Radios;
exports.Select = Select;
exports.Snack = Snack;
exports.StatutTag = StatutTag;
exports.Tabs = Tabs;
exports.Tag = Tag;
